/* eslint-disable */
import { timestamptz, timestamp, uuid, numeric, TagType, time, ta_device_view_template_type, ta_operation_mode_view_template_type, ta_device_metadata_type, ScenarioTagConfig, UserGroupConfig, AssociatedEscalationGroupConfig, UserGroupUserList, rt_get_usergroup_users_and_status_status, OrganisationConfig, OrganisationRestrictedConfig, ta_user_user_language, Schedule, UserResidentRelationshipType, UserGroupUserResidentRelationshipType, RuleConfig, UserDeviceType, NotificationLogType, NotificationUserState, NotificationVariables, BatchJobStatus } from '@nemlia/hasura-schema'
import { OrgmgrDocumentNode as DocumentNode } from "@nemlia/hasura-schema";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AssociatedEscalationGroupConfig: { input: AssociatedEscalationGroupConfig; output: AssociatedEscalationGroupConfig; }
  BatchJobStatus: { input: BatchJobStatus; output: BatchJobStatus; }
  NotificationLogType: { input: NotificationLogType; output: NotificationLogType; }
  NotificationUserState: { input: NotificationUserState; output: NotificationUserState; }
  NotificationVariables: { input: NotificationVariables; output: NotificationVariables; }
  OrganisationConfig: { input: OrganisationConfig; output: OrganisationConfig; }
  OrganisationRestrictedConfig: { input: OrganisationRestrictedConfig; output: OrganisationRestrictedConfig; }
  RuleConfig: { input: RuleConfig; output: RuleConfig; }
  ScenarioTagConfig: { input: ScenarioTagConfig; output: ScenarioTagConfig; }
  Schedule: { input: Schedule; output: Schedule; }
  TagType: { input: TagType; output: TagType; }
  UserDeviceType: { input: UserDeviceType; output: UserDeviceType; }
  UserGroupConfig: { input: UserGroupConfig; output: UserGroupConfig; }
  UserGroupUserList: { input: UserGroupUserList; output: UserGroupUserList; }
  UserGroupUserResidentRelationshipType: { input: UserGroupUserResidentRelationshipType; output: UserGroupUserResidentRelationshipType; }
  UserResidentRelationshipType: { input: UserResidentRelationshipType; output: UserResidentRelationshipType; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: numeric; output: numeric; }
  rt_get_usergroup_users_and_status_status: { input: rt_get_usergroup_users_and_status_status; output: rt_get_usergroup_users_and_status_status; }
  ta_device_metadata_type: { input: ta_device_metadata_type; output: ta_device_metadata_type; }
  ta_device_view_template_type: { input: ta_device_view_template_type; output: ta_device_view_template_type; }
  ta_operation_mode_view_template_type: { input: ta_operation_mode_view_template_type; output: ta_operation_mode_view_template_type; }
  ta_user_user_language: { input: ta_user_user_language; output: ta_user_user_language; }
  time: { input: time; output: time; }
  timestamp: { input: timestamp; output: timestamp; }
  timestamptz: { input: timestamptz; output: timestamptz; }
  uuid: { input: uuid; output: uuid; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "audit.event" */
export type Audit_Event = {
  __typename?: 'audit_event';
  change_keys: Array<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  details?: Maybe<Scalars['jsonb']['output']>;
  diff?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  operation: Scalars['String']['output'];
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  resident_id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  row_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  /** An array relationship */
  ta_organisation_users: Array<Ta_User_Organisation>;
  /** An object relationship */
  ta_resident?: Maybe<Ta_Citizen>;
  /** An object relationship */
  ta_user?: Maybe<Ta_User>;
  table_name: Scalars['String']['output'];
  updated_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_ta_user?: Maybe<Ta_User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "audit.event" */
export type Audit_EventDetailsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "audit.event" */
export type Audit_EventDiffArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "audit.event" */
export type Audit_EventTa_Organisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "audit.event". All fields are combined with a logical 'AND'. */
export type Audit_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Event_Bool_Exp>>;
  _not?: InputMaybe<Audit_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Event_Bool_Exp>>;
  change_keys?: InputMaybe<String_Array_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  details?: InputMaybe<Jsonb_Comparison_Exp>;
  diff?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  operation?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  resident_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  row_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  ta_resident?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  updated_by_ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "audit.event". */
export type Audit_Event_Order_By = {
  change_keys?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  details?: InputMaybe<Order_By>;
  diff?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  resident_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  row_id?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_organisation_users_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  ta_resident?: InputMaybe<Ta_Citizen_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  table_name?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_by_ta_user?: InputMaybe<Ta_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "audit.event" */
export enum Audit_Event_Select_Column {
  /** column name */
  ChangeKeys = 'change_keys',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Details = 'details',
  /** column name */
  Diff = 'diff',
  /** column name */
  Id = 'id',
  /** column name */
  Operation = 'operation',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ResidentId = 'resident_id',
  /** column name */
  Role = 'role',
  /** column name */
  RowId = 'row_id',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "audit_event" */
export type Audit_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Event_Stream_Cursor_Value_Input = {
  change_keys?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  details?: InputMaybe<Scalars['jsonb']['input']>;
  diff?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  resident_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  row_id?: InputMaybe<Scalars['uuid']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the jsonpath return any item for the specified JSON value */
  _jsonb_path_exists?: InputMaybe<Scalars['String']['input']>;
  /** does the jsonpath predicate check return true for the specified JSON value */
  _jsonb_path_match?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "ta_associated_escalation_group" */
  delete_ta_associated_escalation_group?: Maybe<Ta_Associated_Escalation_Group_Mutation_Response>;
  /** delete single row from the table: "ta_associated_escalation_group" */
  delete_ta_associated_escalation_group_by_pk?: Maybe<Ta_Associated_Escalation_Group>;
  /** delete data from the table: "ta_associated_sensor" */
  delete_ta_associated_sensor?: Maybe<Ta_Associated_Sensor_Mutation_Response>;
  /** delete single row from the table: "ta_associated_sensor" */
  delete_ta_associated_sensor_by_pk?: Maybe<Ta_Associated_Sensor>;
  /** delete data from the table: "ta_citizen_device" */
  delete_ta_citizen_device?: Maybe<Ta_Citizen_Device_Mutation_Response>;
  /** delete single row from the table: "ta_citizen_device" */
  delete_ta_citizen_device_by_pk?: Maybe<Ta_Citizen_Device>;
  /** delete data from the table: "ta_citizen_user" */
  delete_ta_citizen_user?: Maybe<Ta_Citizen_User_Mutation_Response>;
  /** delete single row from the table: "ta_citizen_user" */
  delete_ta_citizen_user_by_pk?: Maybe<Ta_Citizen_User>;
  /** delete data from the table: "ta_device" */
  delete_ta_device?: Maybe<Ta_Device_Mutation_Response>;
  /** delete single row from the table: "ta_device" */
  delete_ta_device_by_pk?: Maybe<Ta_Device>;
  /** delete data from the table: "ta_relationship_to_tag" */
  delete_ta_relationship_to_tag?: Maybe<Ta_Relationship_To_Tag_Mutation_Response>;
  /** delete single row from the table: "ta_relationship_to_tag" */
  delete_ta_relationship_to_tag_by_pk?: Maybe<Ta_Relationship_To_Tag>;
  /** delete data from the table: "ta_tag_rule_notification" */
  delete_ta_tag_rule_notification?: Maybe<Ta_Tag_Rule_Notification_Mutation_Response>;
  /** delete single row from the table: "ta_tag_rule_notification" */
  delete_ta_tag_rule_notification_by_pk?: Maybe<Ta_Tag_Rule_Notification>;
  /** delete data from the table: "ta_user_device_tokens" */
  delete_ta_user_device_tokens?: Maybe<Ta_User_Device_Tokens_Mutation_Response>;
  /** delete single row from the table: "ta_user_device_tokens" */
  delete_ta_user_device_tokens_by_pk?: Maybe<Ta_User_Device_Tokens>;
  /** delete data from the table: "ta_user_organisation" */
  delete_ta_user_organisation?: Maybe<Ta_User_Organisation_Mutation_Response>;
  /** delete single row from the table: "ta_user_organisation" */
  delete_ta_user_organisation_by_pk?: Maybe<Ta_User_Organisation>;
  /** delete data from the table: "ta_usergroup" */
  delete_ta_usergroup?: Maybe<Ta_Usergroup_Mutation_Response>;
  /** delete single row from the table: "ta_usergroup" */
  delete_ta_usergroup_by_pk?: Maybe<Ta_Usergroup>;
  /** delete data from the table: "ta_usergroup_citizen" */
  delete_ta_usergroup_citizen?: Maybe<Ta_Usergroup_Citizen_Mutation_Response>;
  /** delete single row from the table: "ta_usergroup_citizen" */
  delete_ta_usergroup_citizen_by_pk?: Maybe<Ta_Usergroup_Citizen>;
  /** delete data from the table: "ta_usergroup_user" */
  delete_ta_usergroup_user?: Maybe<Ta_Usergroup_User_Mutation_Response>;
  /** delete single row from the table: "ta_usergroup_user" */
  delete_ta_usergroup_user_by_pk?: Maybe<Ta_Usergroup_User>;
  /** delete data from the table: "ta_zone" */
  delete_ta_zone?: Maybe<Ta_Zone_Mutation_Response>;
  /** delete single row from the table: "ta_zone" */
  delete_ta_zone_by_pk?: Maybe<Ta_Zone>;
  /** insert data into the table: "ta_activation" */
  insert_ta_activation?: Maybe<Ta_Activation_Mutation_Response>;
  /** insert a single row into the table: "ta_activation" */
  insert_ta_activation_one?: Maybe<Ta_Activation>;
  /** insert data into the table: "ta_associated_escalation_group" */
  insert_ta_associated_escalation_group?: Maybe<Ta_Associated_Escalation_Group_Mutation_Response>;
  /** insert a single row into the table: "ta_associated_escalation_group" */
  insert_ta_associated_escalation_group_one?: Maybe<Ta_Associated_Escalation_Group>;
  /** insert data into the table: "ta_associated_sensor" */
  insert_ta_associated_sensor?: Maybe<Ta_Associated_Sensor_Mutation_Response>;
  /** insert a single row into the table: "ta_associated_sensor" */
  insert_ta_associated_sensor_one?: Maybe<Ta_Associated_Sensor>;
  /** insert data into the table: "ta_citizen" */
  insert_ta_citizen?: Maybe<Ta_Citizen_Mutation_Response>;
  /** insert data into the table: "ta_citizen_device" */
  insert_ta_citizen_device?: Maybe<Ta_Citizen_Device_Mutation_Response>;
  /** insert a single row into the table: "ta_citizen_device" */
  insert_ta_citizen_device_one?: Maybe<Ta_Citizen_Device>;
  /** insert data into the table: "ta_citizen_gateway" */
  insert_ta_citizen_gateway?: Maybe<Ta_Citizen_Gateway_Mutation_Response>;
  /** insert a single row into the table: "ta_citizen_gateway" */
  insert_ta_citizen_gateway_one?: Maybe<Ta_Citizen_Gateway>;
  /** insert a single row into the table: "ta_citizen" */
  insert_ta_citizen_one?: Maybe<Ta_Citizen>;
  /** insert data into the table: "ta_citizen_user" */
  insert_ta_citizen_user?: Maybe<Ta_Citizen_User_Mutation_Response>;
  /** insert a single row into the table: "ta_citizen_user" */
  insert_ta_citizen_user_one?: Maybe<Ta_Citizen_User>;
  /** insert data into the table: "ta_device" */
  insert_ta_device?: Maybe<Ta_Device_Mutation_Response>;
  /** insert a single row into the table: "ta_device" */
  insert_ta_device_one?: Maybe<Ta_Device>;
  /** insert data into the table: "ta_floors" */
  insert_ta_floors?: Maybe<Ta_Floors_Mutation_Response>;
  /** insert a single row into the table: "ta_floors" */
  insert_ta_floors_one?: Maybe<Ta_Floors>;
  /** insert data into the table: "ta_gateway" */
  insert_ta_gateway?: Maybe<Ta_Gateway_Mutation_Response>;
  /** insert a single row into the table: "ta_gateway" */
  insert_ta_gateway_one?: Maybe<Ta_Gateway>;
  /** insert data into the table: "ta_notification_notes" */
  insert_ta_notification_notes?: Maybe<Ta_Notification_Notes_Mutation_Response>;
  /** insert a single row into the table: "ta_notification_notes" */
  insert_ta_notification_notes_one?: Maybe<Ta_Notification_Notes>;
  /** insert data into the table: "ta_personal_device_log" */
  insert_ta_personal_device_log?: Maybe<Ta_Personal_Device_Log_Mutation_Response>;
  /** insert a single row into the table: "ta_personal_device_log" */
  insert_ta_personal_device_log_one?: Maybe<Ta_Personal_Device_Log>;
  /** insert data into the table: "ta_relationship_to_tag" */
  insert_ta_relationship_to_tag?: Maybe<Ta_Relationship_To_Tag_Mutation_Response>;
  /** insert a single row into the table: "ta_relationship_to_tag" */
  insert_ta_relationship_to_tag_one?: Maybe<Ta_Relationship_To_Tag>;
  /** insert data into the table: "ta_rule_notification" */
  insert_ta_rule_notification?: Maybe<Ta_Rule_Notification_Mutation_Response>;
  /** insert a single row into the table: "ta_rule_notification" */
  insert_ta_rule_notification_one?: Maybe<Ta_Rule_Notification>;
  /** insert data into the table: "ta_tag" */
  insert_ta_tag?: Maybe<Ta_Tag_Mutation_Response>;
  /** insert a single row into the table: "ta_tag" */
  insert_ta_tag_one?: Maybe<Ta_Tag>;
  /** insert data into the table: "ta_tag_rule_notification" */
  insert_ta_tag_rule_notification?: Maybe<Ta_Tag_Rule_Notification_Mutation_Response>;
  /** insert a single row into the table: "ta_tag_rule_notification" */
  insert_ta_tag_rule_notification_one?: Maybe<Ta_Tag_Rule_Notification>;
  /** insert data into the table: "ta_tracker" */
  insert_ta_tracker?: Maybe<Ta_Tracker_Mutation_Response>;
  /** insert a single row into the table: "ta_tracker" */
  insert_ta_tracker_one?: Maybe<Ta_Tracker>;
  /** insert data into the table: "ta_user_device_tokens" */
  insert_ta_user_device_tokens?: Maybe<Ta_User_Device_Tokens_Mutation_Response>;
  /** insert a single row into the table: "ta_user_device_tokens" */
  insert_ta_user_device_tokens_one?: Maybe<Ta_User_Device_Tokens>;
  /** insert data into the table: "ta_user_organisation" */
  insert_ta_user_organisation?: Maybe<Ta_User_Organisation_Mutation_Response>;
  /** insert a single row into the table: "ta_user_organisation" */
  insert_ta_user_organisation_one?: Maybe<Ta_User_Organisation>;
  /** insert data into the table: "ta_usergroup" */
  insert_ta_usergroup?: Maybe<Ta_Usergroup_Mutation_Response>;
  /** insert data into the table: "ta_usergroup_citizen" */
  insert_ta_usergroup_citizen?: Maybe<Ta_Usergroup_Citizen_Mutation_Response>;
  /** insert a single row into the table: "ta_usergroup_citizen" */
  insert_ta_usergroup_citizen_one?: Maybe<Ta_Usergroup_Citizen>;
  /** insert a single row into the table: "ta_usergroup" */
  insert_ta_usergroup_one?: Maybe<Ta_Usergroup>;
  /** insert data into the table: "ta_usergroup_user" */
  insert_ta_usergroup_user?: Maybe<Ta_Usergroup_User_Mutation_Response>;
  /** insert a single row into the table: "ta_usergroup_user" */
  insert_ta_usergroup_user_one?: Maybe<Ta_Usergroup_User>;
  /** insert data into the table: "ta_zone" */
  insert_ta_zone?: Maybe<Ta_Zone_Mutation_Response>;
  /** insert a single row into the table: "ta_zone" */
  insert_ta_zone_one?: Maybe<Ta_Zone>;
  /** update data of the table: "ta_activation" */
  update_ta_activation?: Maybe<Ta_Activation_Mutation_Response>;
  /** update single row of the table: "ta_activation" */
  update_ta_activation_by_pk?: Maybe<Ta_Activation>;
  /** update multiples rows of table: "ta_activation" */
  update_ta_activation_many?: Maybe<Array<Maybe<Ta_Activation_Mutation_Response>>>;
  /** update data of the table: "ta_associated_escalation_group" */
  update_ta_associated_escalation_group?: Maybe<Ta_Associated_Escalation_Group_Mutation_Response>;
  /** update single row of the table: "ta_associated_escalation_group" */
  update_ta_associated_escalation_group_by_pk?: Maybe<Ta_Associated_Escalation_Group>;
  /** update multiples rows of table: "ta_associated_escalation_group" */
  update_ta_associated_escalation_group_many?: Maybe<Array<Maybe<Ta_Associated_Escalation_Group_Mutation_Response>>>;
  /** update data of the table: "ta_associated_sensor" */
  update_ta_associated_sensor?: Maybe<Ta_Associated_Sensor_Mutation_Response>;
  /** update single row of the table: "ta_associated_sensor" */
  update_ta_associated_sensor_by_pk?: Maybe<Ta_Associated_Sensor>;
  /** update multiples rows of table: "ta_associated_sensor" */
  update_ta_associated_sensor_many?: Maybe<Array<Maybe<Ta_Associated_Sensor_Mutation_Response>>>;
  /** update data of the table: "ta_citizen" */
  update_ta_citizen?: Maybe<Ta_Citizen_Mutation_Response>;
  /** update single row of the table: "ta_citizen" */
  update_ta_citizen_by_pk?: Maybe<Ta_Citizen>;
  /** update data of the table: "ta_citizen_device" */
  update_ta_citizen_device?: Maybe<Ta_Citizen_Device_Mutation_Response>;
  /** update single row of the table: "ta_citizen_device" */
  update_ta_citizen_device_by_pk?: Maybe<Ta_Citizen_Device>;
  /** update multiples rows of table: "ta_citizen_device" */
  update_ta_citizen_device_many?: Maybe<Array<Maybe<Ta_Citizen_Device_Mutation_Response>>>;
  /** update data of the table: "ta_citizen_gateway" */
  update_ta_citizen_gateway?: Maybe<Ta_Citizen_Gateway_Mutation_Response>;
  /** update single row of the table: "ta_citizen_gateway" */
  update_ta_citizen_gateway_by_pk?: Maybe<Ta_Citizen_Gateway>;
  /** update multiples rows of table: "ta_citizen_gateway" */
  update_ta_citizen_gateway_many?: Maybe<Array<Maybe<Ta_Citizen_Gateway_Mutation_Response>>>;
  /** update multiples rows of table: "ta_citizen" */
  update_ta_citizen_many?: Maybe<Array<Maybe<Ta_Citizen_Mutation_Response>>>;
  /** update data of the table: "ta_citizen_user" */
  update_ta_citizen_user?: Maybe<Ta_Citizen_User_Mutation_Response>;
  /** update single row of the table: "ta_citizen_user" */
  update_ta_citizen_user_by_pk?: Maybe<Ta_Citizen_User>;
  /** update multiples rows of table: "ta_citizen_user" */
  update_ta_citizen_user_many?: Maybe<Array<Maybe<Ta_Citizen_User_Mutation_Response>>>;
  /** update data of the table: "ta_device" */
  update_ta_device?: Maybe<Ta_Device_Mutation_Response>;
  /** update single row of the table: "ta_device" */
  update_ta_device_by_pk?: Maybe<Ta_Device>;
  /** update multiples rows of table: "ta_device" */
  update_ta_device_many?: Maybe<Array<Maybe<Ta_Device_Mutation_Response>>>;
  /** update data of the table: "ta_floors" */
  update_ta_floors?: Maybe<Ta_Floors_Mutation_Response>;
  /** update single row of the table: "ta_floors" */
  update_ta_floors_by_pk?: Maybe<Ta_Floors>;
  /** update multiples rows of table: "ta_floors" */
  update_ta_floors_many?: Maybe<Array<Maybe<Ta_Floors_Mutation_Response>>>;
  /** update data of the table: "ta_gateway" */
  update_ta_gateway?: Maybe<Ta_Gateway_Mutation_Response>;
  /** update single row of the table: "ta_gateway" */
  update_ta_gateway_by_pk?: Maybe<Ta_Gateway>;
  /** update multiples rows of table: "ta_gateway" */
  update_ta_gateway_many?: Maybe<Array<Maybe<Ta_Gateway_Mutation_Response>>>;
  /** update data of the table: "ta_notification_user" */
  update_ta_notification_user?: Maybe<Ta_Notification_User_Mutation_Response>;
  /** update single row of the table: "ta_notification_user" */
  update_ta_notification_user_by_pk?: Maybe<Ta_Notification_User>;
  /** update multiples rows of table: "ta_notification_user" */
  update_ta_notification_user_many?: Maybe<Array<Maybe<Ta_Notification_User_Mutation_Response>>>;
  /** update data of the table: "ta_relationship_to_tag" */
  update_ta_relationship_to_tag?: Maybe<Ta_Relationship_To_Tag_Mutation_Response>;
  /** update single row of the table: "ta_relationship_to_tag" */
  update_ta_relationship_to_tag_by_pk?: Maybe<Ta_Relationship_To_Tag>;
  /** update multiples rows of table: "ta_relationship_to_tag" */
  update_ta_relationship_to_tag_many?: Maybe<Array<Maybe<Ta_Relationship_To_Tag_Mutation_Response>>>;
  /** update data of the table: "ta_rule_notification" */
  update_ta_rule_notification?: Maybe<Ta_Rule_Notification_Mutation_Response>;
  /** update single row of the table: "ta_rule_notification" */
  update_ta_rule_notification_by_pk?: Maybe<Ta_Rule_Notification>;
  /** update multiples rows of table: "ta_rule_notification" */
  update_ta_rule_notification_many?: Maybe<Array<Maybe<Ta_Rule_Notification_Mutation_Response>>>;
  /** update data of the table: "ta_sensor" */
  update_ta_sensor?: Maybe<Ta_Sensor_Mutation_Response>;
  /** update single row of the table: "ta_sensor" */
  update_ta_sensor_by_pk?: Maybe<Ta_Sensor>;
  /** update multiples rows of table: "ta_sensor" */
  update_ta_sensor_many?: Maybe<Array<Maybe<Ta_Sensor_Mutation_Response>>>;
  /** update data of the table: "ta_tag" */
  update_ta_tag?: Maybe<Ta_Tag_Mutation_Response>;
  /** update single row of the table: "ta_tag" */
  update_ta_tag_by_pk?: Maybe<Ta_Tag>;
  /** update multiples rows of table: "ta_tag" */
  update_ta_tag_many?: Maybe<Array<Maybe<Ta_Tag_Mutation_Response>>>;
  /** update data of the table: "ta_user" */
  update_ta_user?: Maybe<Ta_User_Mutation_Response>;
  /** update single row of the table: "ta_user" */
  update_ta_user_by_pk?: Maybe<Ta_User>;
  /** update data of the table: "ta_user_device_tokens" */
  update_ta_user_device_tokens?: Maybe<Ta_User_Device_Tokens_Mutation_Response>;
  /** update single row of the table: "ta_user_device_tokens" */
  update_ta_user_device_tokens_by_pk?: Maybe<Ta_User_Device_Tokens>;
  /** update multiples rows of table: "ta_user_device_tokens" */
  update_ta_user_device_tokens_many?: Maybe<Array<Maybe<Ta_User_Device_Tokens_Mutation_Response>>>;
  /** update multiples rows of table: "ta_user" */
  update_ta_user_many?: Maybe<Array<Maybe<Ta_User_Mutation_Response>>>;
  /** update data of the table: "ta_user_organisation" */
  update_ta_user_organisation?: Maybe<Ta_User_Organisation_Mutation_Response>;
  /** update single row of the table: "ta_user_organisation" */
  update_ta_user_organisation_by_pk?: Maybe<Ta_User_Organisation>;
  /** update multiples rows of table: "ta_user_organisation" */
  update_ta_user_organisation_many?: Maybe<Array<Maybe<Ta_User_Organisation_Mutation_Response>>>;
  /** update data of the table: "ta_usergroup" */
  update_ta_usergroup?: Maybe<Ta_Usergroup_Mutation_Response>;
  /** update single row of the table: "ta_usergroup" */
  update_ta_usergroup_by_pk?: Maybe<Ta_Usergroup>;
  /** update multiples rows of table: "ta_usergroup" */
  update_ta_usergroup_many?: Maybe<Array<Maybe<Ta_Usergroup_Mutation_Response>>>;
  /** update data of the table: "ta_zone" */
  update_ta_zone?: Maybe<Ta_Zone_Mutation_Response>;
  /** update single row of the table: "ta_zone" */
  update_ta_zone_by_pk?: Maybe<Ta_Zone>;
  /** update multiples rows of table: "ta_zone" */
  update_ta_zone_many?: Maybe<Array<Maybe<Ta_Zone_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Associated_Escalation_GroupArgs = {
  where: Ta_Associated_Escalation_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Associated_Escalation_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_Associated_SensorArgs = {
  where: Ta_Associated_Sensor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Associated_Sensor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_Citizen_DeviceArgs = {
  where: Ta_Citizen_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Citizen_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_Citizen_UserArgs = {
  where: Ta_Citizen_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Citizen_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_DeviceArgs = {
  where: Ta_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_Relationship_To_TagArgs = {
  where: Ta_Relationship_To_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Relationship_To_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_Tag_Rule_NotificationArgs = {
  where: Ta_Tag_Rule_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Tag_Rule_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_User_Device_TokensArgs = {
  where: Ta_User_Device_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_User_Device_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_User_OrganisationArgs = {
  where: Ta_User_Organisation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_User_Organisation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_UsergroupArgs = {
  where: Ta_Usergroup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Usergroup_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_Usergroup_CitizenArgs = {
  where: Ta_Usergroup_Citizen_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Usergroup_Citizen_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_Usergroup_UserArgs = {
  where: Ta_Usergroup_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Usergroup_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ta_ZoneArgs = {
  where: Ta_Zone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ta_Zone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Ta_ActivationArgs = {
  objects: Array<Ta_Activation_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Activation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Activation_OneArgs = {
  object: Ta_Activation_Insert_Input;
  on_conflict?: InputMaybe<Ta_Activation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Associated_Escalation_GroupArgs = {
  objects: Array<Ta_Associated_Escalation_Group_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Associated_Escalation_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Associated_Escalation_Group_OneArgs = {
  object: Ta_Associated_Escalation_Group_Insert_Input;
  on_conflict?: InputMaybe<Ta_Associated_Escalation_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Associated_SensorArgs = {
  objects: Array<Ta_Associated_Sensor_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Associated_Sensor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Associated_Sensor_OneArgs = {
  object: Ta_Associated_Sensor_Insert_Input;
  on_conflict?: InputMaybe<Ta_Associated_Sensor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_CitizenArgs = {
  objects: Array<Ta_Citizen_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Citizen_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Citizen_DeviceArgs = {
  objects: Array<Ta_Citizen_Device_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Citizen_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Citizen_Device_OneArgs = {
  object: Ta_Citizen_Device_Insert_Input;
  on_conflict?: InputMaybe<Ta_Citizen_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Citizen_GatewayArgs = {
  objects: Array<Ta_Citizen_Gateway_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Citizen_Gateway_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Citizen_Gateway_OneArgs = {
  object: Ta_Citizen_Gateway_Insert_Input;
  on_conflict?: InputMaybe<Ta_Citizen_Gateway_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Citizen_OneArgs = {
  object: Ta_Citizen_Insert_Input;
  on_conflict?: InputMaybe<Ta_Citizen_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Citizen_UserArgs = {
  objects: Array<Ta_Citizen_User_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Citizen_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Citizen_User_OneArgs = {
  object: Ta_Citizen_User_Insert_Input;
  on_conflict?: InputMaybe<Ta_Citizen_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_DeviceArgs = {
  objects: Array<Ta_Device_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Device_OneArgs = {
  object: Ta_Device_Insert_Input;
  on_conflict?: InputMaybe<Ta_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_FloorsArgs = {
  objects: Array<Ta_Floors_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Floors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Floors_OneArgs = {
  object: Ta_Floors_Insert_Input;
  on_conflict?: InputMaybe<Ta_Floors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_GatewayArgs = {
  objects: Array<Ta_Gateway_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Gateway_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Gateway_OneArgs = {
  object: Ta_Gateway_Insert_Input;
  on_conflict?: InputMaybe<Ta_Gateway_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Notification_NotesArgs = {
  objects: Array<Ta_Notification_Notes_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Notification_Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Notification_Notes_OneArgs = {
  object: Ta_Notification_Notes_Insert_Input;
  on_conflict?: InputMaybe<Ta_Notification_Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Personal_Device_LogArgs = {
  objects: Array<Ta_Personal_Device_Log_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Personal_Device_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Personal_Device_Log_OneArgs = {
  object: Ta_Personal_Device_Log_Insert_Input;
  on_conflict?: InputMaybe<Ta_Personal_Device_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Relationship_To_TagArgs = {
  objects: Array<Ta_Relationship_To_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Relationship_To_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Relationship_To_Tag_OneArgs = {
  object: Ta_Relationship_To_Tag_Insert_Input;
  on_conflict?: InputMaybe<Ta_Relationship_To_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Rule_NotificationArgs = {
  objects: Array<Ta_Rule_Notification_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Rule_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Rule_Notification_OneArgs = {
  object: Ta_Rule_Notification_Insert_Input;
  on_conflict?: InputMaybe<Ta_Rule_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_TagArgs = {
  objects: Array<Ta_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Tag_OneArgs = {
  object: Ta_Tag_Insert_Input;
  on_conflict?: InputMaybe<Ta_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Tag_Rule_NotificationArgs = {
  objects: Array<Ta_Tag_Rule_Notification_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Tag_Rule_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Tag_Rule_Notification_OneArgs = {
  object: Ta_Tag_Rule_Notification_Insert_Input;
  on_conflict?: InputMaybe<Ta_Tag_Rule_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_TrackerArgs = {
  objects: Array<Ta_Tracker_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Tracker_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Tracker_OneArgs = {
  object: Ta_Tracker_Insert_Input;
  on_conflict?: InputMaybe<Ta_Tracker_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_User_Device_TokensArgs = {
  objects: Array<Ta_User_Device_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Ta_User_Device_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_User_Device_Tokens_OneArgs = {
  object: Ta_User_Device_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Ta_User_Device_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_User_OrganisationArgs = {
  objects: Array<Ta_User_Organisation_Insert_Input>;
  on_conflict?: InputMaybe<Ta_User_Organisation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_User_Organisation_OneArgs = {
  object: Ta_User_Organisation_Insert_Input;
  on_conflict?: InputMaybe<Ta_User_Organisation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_UsergroupArgs = {
  objects: Array<Ta_Usergroup_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Usergroup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Usergroup_CitizenArgs = {
  objects: Array<Ta_Usergroup_Citizen_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Usergroup_Citizen_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Usergroup_Citizen_OneArgs = {
  object: Ta_Usergroup_Citizen_Insert_Input;
  on_conflict?: InputMaybe<Ta_Usergroup_Citizen_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Usergroup_OneArgs = {
  object: Ta_Usergroup_Insert_Input;
  on_conflict?: InputMaybe<Ta_Usergroup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Usergroup_UserArgs = {
  objects: Array<Ta_Usergroup_User_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Usergroup_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Usergroup_User_OneArgs = {
  object: Ta_Usergroup_User_Insert_Input;
  on_conflict?: InputMaybe<Ta_Usergroup_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_ZoneArgs = {
  objects: Array<Ta_Zone_Insert_Input>;
  on_conflict?: InputMaybe<Ta_Zone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ta_Zone_OneArgs = {
  object: Ta_Zone_Insert_Input;
  on_conflict?: InputMaybe<Ta_Zone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_ActivationArgs = {
  _set?: InputMaybe<Ta_Activation_Set_Input>;
  where: Ta_Activation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Activation_By_PkArgs = {
  _set?: InputMaybe<Ta_Activation_Set_Input>;
  pk_columns: Ta_Activation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Activation_ManyArgs = {
  updates: Array<Ta_Activation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Associated_Escalation_GroupArgs = {
  _append?: InputMaybe<Ta_Associated_Escalation_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Ta_Associated_Escalation_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ta_Associated_Escalation_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ta_Associated_Escalation_Group_Delete_Key_Input>;
  _prepend?: InputMaybe<Ta_Associated_Escalation_Group_Prepend_Input>;
  _set?: InputMaybe<Ta_Associated_Escalation_Group_Set_Input>;
  where: Ta_Associated_Escalation_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Associated_Escalation_Group_By_PkArgs = {
  _append?: InputMaybe<Ta_Associated_Escalation_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Ta_Associated_Escalation_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ta_Associated_Escalation_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ta_Associated_Escalation_Group_Delete_Key_Input>;
  _prepend?: InputMaybe<Ta_Associated_Escalation_Group_Prepend_Input>;
  _set?: InputMaybe<Ta_Associated_Escalation_Group_Set_Input>;
  pk_columns: Ta_Associated_Escalation_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Associated_Escalation_Group_ManyArgs = {
  updates: Array<Ta_Associated_Escalation_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Associated_SensorArgs = {
  _set?: InputMaybe<Ta_Associated_Sensor_Set_Input>;
  where: Ta_Associated_Sensor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Associated_Sensor_By_PkArgs = {
  _set?: InputMaybe<Ta_Associated_Sensor_Set_Input>;
  pk_columns: Ta_Associated_Sensor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Associated_Sensor_ManyArgs = {
  updates: Array<Ta_Associated_Sensor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_CitizenArgs = {
  _set?: InputMaybe<Ta_Citizen_Set_Input>;
  where: Ta_Citizen_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Citizen_By_PkArgs = {
  _set?: InputMaybe<Ta_Citizen_Set_Input>;
  pk_columns: Ta_Citizen_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Citizen_DeviceArgs = {
  _set?: InputMaybe<Ta_Citizen_Device_Set_Input>;
  where: Ta_Citizen_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Citizen_Device_By_PkArgs = {
  _set?: InputMaybe<Ta_Citizen_Device_Set_Input>;
  pk_columns: Ta_Citizen_Device_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Citizen_Device_ManyArgs = {
  updates: Array<Ta_Citizen_Device_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Citizen_GatewayArgs = {
  _set?: InputMaybe<Ta_Citizen_Gateway_Set_Input>;
  where: Ta_Citizen_Gateway_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Citizen_Gateway_By_PkArgs = {
  _set?: InputMaybe<Ta_Citizen_Gateway_Set_Input>;
  pk_columns: Ta_Citizen_Gateway_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Citizen_Gateway_ManyArgs = {
  updates: Array<Ta_Citizen_Gateway_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Citizen_ManyArgs = {
  updates: Array<Ta_Citizen_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Citizen_UserArgs = {
  _set?: InputMaybe<Ta_Citizen_User_Set_Input>;
  where: Ta_Citizen_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Citizen_User_By_PkArgs = {
  _set?: InputMaybe<Ta_Citizen_User_Set_Input>;
  pk_columns: Ta_Citizen_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Citizen_User_ManyArgs = {
  updates: Array<Ta_Citizen_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_DeviceArgs = {
  _set?: InputMaybe<Ta_Device_Set_Input>;
  where: Ta_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Device_By_PkArgs = {
  _set?: InputMaybe<Ta_Device_Set_Input>;
  pk_columns: Ta_Device_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Device_ManyArgs = {
  updates: Array<Ta_Device_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_FloorsArgs = {
  _inc?: InputMaybe<Ta_Floors_Inc_Input>;
  _set?: InputMaybe<Ta_Floors_Set_Input>;
  where: Ta_Floors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Floors_By_PkArgs = {
  _inc?: InputMaybe<Ta_Floors_Inc_Input>;
  _set?: InputMaybe<Ta_Floors_Set_Input>;
  pk_columns: Ta_Floors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Floors_ManyArgs = {
  updates: Array<Ta_Floors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_GatewayArgs = {
  _set?: InputMaybe<Ta_Gateway_Set_Input>;
  where: Ta_Gateway_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Gateway_By_PkArgs = {
  _set?: InputMaybe<Ta_Gateway_Set_Input>;
  pk_columns: Ta_Gateway_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Gateway_ManyArgs = {
  updates: Array<Ta_Gateway_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Notification_UserArgs = {
  _set?: InputMaybe<Ta_Notification_User_Set_Input>;
  where: Ta_Notification_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Notification_User_By_PkArgs = {
  _set?: InputMaybe<Ta_Notification_User_Set_Input>;
  pk_columns: Ta_Notification_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Notification_User_ManyArgs = {
  updates: Array<Ta_Notification_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Relationship_To_TagArgs = {
  _append?: InputMaybe<Ta_Relationship_To_Tag_Append_Input>;
  _delete_at_path?: InputMaybe<Ta_Relationship_To_Tag_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ta_Relationship_To_Tag_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ta_Relationship_To_Tag_Delete_Key_Input>;
  _prepend?: InputMaybe<Ta_Relationship_To_Tag_Prepend_Input>;
  _set?: InputMaybe<Ta_Relationship_To_Tag_Set_Input>;
  where: Ta_Relationship_To_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Relationship_To_Tag_By_PkArgs = {
  _append?: InputMaybe<Ta_Relationship_To_Tag_Append_Input>;
  _delete_at_path?: InputMaybe<Ta_Relationship_To_Tag_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ta_Relationship_To_Tag_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ta_Relationship_To_Tag_Delete_Key_Input>;
  _prepend?: InputMaybe<Ta_Relationship_To_Tag_Prepend_Input>;
  _set?: InputMaybe<Ta_Relationship_To_Tag_Set_Input>;
  pk_columns: Ta_Relationship_To_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Relationship_To_Tag_ManyArgs = {
  updates: Array<Ta_Relationship_To_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Rule_NotificationArgs = {
  _append?: InputMaybe<Ta_Rule_Notification_Append_Input>;
  _delete_at_path?: InputMaybe<Ta_Rule_Notification_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ta_Rule_Notification_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ta_Rule_Notification_Delete_Key_Input>;
  _prepend?: InputMaybe<Ta_Rule_Notification_Prepend_Input>;
  _set?: InputMaybe<Ta_Rule_Notification_Set_Input>;
  where: Ta_Rule_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Rule_Notification_By_PkArgs = {
  _append?: InputMaybe<Ta_Rule_Notification_Append_Input>;
  _delete_at_path?: InputMaybe<Ta_Rule_Notification_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ta_Rule_Notification_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ta_Rule_Notification_Delete_Key_Input>;
  _prepend?: InputMaybe<Ta_Rule_Notification_Prepend_Input>;
  _set?: InputMaybe<Ta_Rule_Notification_Set_Input>;
  pk_columns: Ta_Rule_Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Rule_Notification_ManyArgs = {
  updates: Array<Ta_Rule_Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_SensorArgs = {
  _set?: InputMaybe<Ta_Sensor_Set_Input>;
  where: Ta_Sensor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Sensor_By_PkArgs = {
  _set?: InputMaybe<Ta_Sensor_Set_Input>;
  pk_columns: Ta_Sensor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Sensor_ManyArgs = {
  updates: Array<Ta_Sensor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_TagArgs = {
  _set?: InputMaybe<Ta_Tag_Set_Input>;
  where: Ta_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Tag_By_PkArgs = {
  _set?: InputMaybe<Ta_Tag_Set_Input>;
  pk_columns: Ta_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Tag_ManyArgs = {
  updates: Array<Ta_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_UserArgs = {
  _set?: InputMaybe<Ta_User_Set_Input>;
  where: Ta_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_User_By_PkArgs = {
  _set?: InputMaybe<Ta_User_Set_Input>;
  pk_columns: Ta_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_User_Device_TokensArgs = {
  _set?: InputMaybe<Ta_User_Device_Tokens_Set_Input>;
  where: Ta_User_Device_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_User_Device_Tokens_By_PkArgs = {
  _set?: InputMaybe<Ta_User_Device_Tokens_Set_Input>;
  pk_columns: Ta_User_Device_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_User_Device_Tokens_ManyArgs = {
  updates: Array<Ta_User_Device_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_User_ManyArgs = {
  updates: Array<Ta_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_User_OrganisationArgs = {
  _set?: InputMaybe<Ta_User_Organisation_Set_Input>;
  where: Ta_User_Organisation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_User_Organisation_By_PkArgs = {
  _set?: InputMaybe<Ta_User_Organisation_Set_Input>;
  pk_columns: Ta_User_Organisation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_User_Organisation_ManyArgs = {
  updates: Array<Ta_User_Organisation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_UsergroupArgs = {
  _append?: InputMaybe<Ta_Usergroup_Append_Input>;
  _delete_at_path?: InputMaybe<Ta_Usergroup_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ta_Usergroup_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ta_Usergroup_Delete_Key_Input>;
  _prepend?: InputMaybe<Ta_Usergroup_Prepend_Input>;
  _set?: InputMaybe<Ta_Usergroup_Set_Input>;
  where: Ta_Usergroup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Usergroup_By_PkArgs = {
  _append?: InputMaybe<Ta_Usergroup_Append_Input>;
  _delete_at_path?: InputMaybe<Ta_Usergroup_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ta_Usergroup_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ta_Usergroup_Delete_Key_Input>;
  _prepend?: InputMaybe<Ta_Usergroup_Prepend_Input>;
  _set?: InputMaybe<Ta_Usergroup_Set_Input>;
  pk_columns: Ta_Usergroup_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Usergroup_ManyArgs = {
  updates: Array<Ta_Usergroup_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_ZoneArgs = {
  _inc?: InputMaybe<Ta_Zone_Inc_Input>;
  _set?: InputMaybe<Ta_Zone_Set_Input>;
  where: Ta_Zone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Zone_By_PkArgs = {
  _inc?: InputMaybe<Ta_Zone_Inc_Input>;
  _set?: InputMaybe<Ta_Zone_Set_Input>;
  pk_columns: Ta_Zone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ta_Zone_ManyArgs = {
  updates: Array<Ta_Zone_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "audit.event" */
  audit_event: Array<Audit_Event>;
  /** fetch data from the table: "audit.event" using primary key columns */
  audit_event_by_pk?: Maybe<Audit_Event>;
  /** fetch data from the table: "ta_activation" */
  ta_activation: Array<Ta_Activation>;
  /** fetch data from the table: "ta_activation" using primary key columns */
  ta_activation_by_pk?: Maybe<Ta_Activation>;
  /** fetch data from the table: "ta_associated_escalation_group" */
  ta_associated_escalation_group: Array<Ta_Associated_Escalation_Group>;
  /** fetch data from the table: "ta_associated_escalation_group" using primary key columns */
  ta_associated_escalation_group_by_pk?: Maybe<Ta_Associated_Escalation_Group>;
  /** fetch data from the table: "ta_associated_sensor" */
  ta_associated_sensor: Array<Ta_Associated_Sensor>;
  /** fetch data from the table: "ta_associated_sensor" using primary key columns */
  ta_associated_sensor_by_pk?: Maybe<Ta_Associated_Sensor>;
  /** An array relationship */
  ta_batch_history: Array<Ta_Batch_History>;
  /** fetch data from the table: "ta_batch_history" using primary key columns */
  ta_batch_history_by_pk?: Maybe<Ta_Batch_History>;
  /** An array relationship */
  ta_citizen: Array<Ta_Citizen>;
  /** fetch data from the table: "ta_citizen" using primary key columns */
  ta_citizen_by_pk?: Maybe<Ta_Citizen>;
  /** fetch data from the table: "ta_citizen_device" */
  ta_citizen_device: Array<Ta_Citizen_Device>;
  /** fetch aggregated fields from the table: "ta_citizen_device" */
  ta_citizen_device_aggregate: Ta_Citizen_Device_Aggregate;
  /** fetch data from the table: "ta_citizen_device" using primary key columns */
  ta_citizen_device_by_pk?: Maybe<Ta_Citizen_Device>;
  /** fetch data from the table: "ta_citizen_gateway" */
  ta_citizen_gateway: Array<Ta_Citizen_Gateway>;
  /** fetch data from the table: "ta_citizen_gateway" using primary key columns */
  ta_citizen_gateway_by_pk?: Maybe<Ta_Citizen_Gateway>;
  /** fetch data from the table: "ta_citizen_user" */
  ta_citizen_user: Array<Ta_Citizen_User>;
  /** fetch data from the table: "ta_citizen_user" using primary key columns */
  ta_citizen_user_by_pk?: Maybe<Ta_Citizen_User>;
  /** fetch data from the table: "ta_device" */
  ta_device: Array<Ta_Device>;
  /** fetch data from the table: "ta_device" using primary key columns */
  ta_device_by_pk?: Maybe<Ta_Device>;
  /** fetch data from the table: "ta_device_count" */
  ta_device_count: Array<Ta_Device_Count>;
  /** fetch data from the table: "ta_device_count" using primary key columns */
  ta_device_count_by_pk?: Maybe<Ta_Device_Count>;
  /** fetch data from the table: "ta_device_online_history" */
  ta_device_online_history: Array<Ta_Device_Online_History>;
  /** fetch data from the table: "ta_device_online_history" using primary key columns */
  ta_device_online_history_by_pk?: Maybe<Ta_Device_Online_History>;
  /** An array relationship */
  ta_floors: Array<Ta_Floors>;
  /** fetch data from the table: "ta_floors" using primary key columns */
  ta_floors_by_pk?: Maybe<Ta_Floors>;
  /** fetch data from the table: "ta_gateway" */
  ta_gateway: Array<Ta_Gateway>;
  /** fetch data from the table: "ta_gateway" using primary key columns */
  ta_gateway_by_pk?: Maybe<Ta_Gateway>;
  /** fetch data from the table: "ta_gateway_log" */
  ta_gateway_log: Array<Ta_Gateway_Log>;
  /** fetch data from the table: "ta_gateway_online_history" */
  ta_gateway_online_history: Array<Ta_Gateway_Online_History>;
  /** fetch data from the table: "ta_gateway_online_history" using primary key columns */
  ta_gateway_online_history_by_pk?: Maybe<Ta_Gateway_Online_History>;
  /** fetch data from the table: "ta_maintenance" */
  ta_maintenance: Array<Ta_Maintenance>;
  /** fetch data from the table: "ta_maintenance" using primary key columns */
  ta_maintenance_by_pk?: Maybe<Ta_Maintenance>;
  /** fetch data from the table: "ta_maintenance_type" */
  ta_maintenance_type: Array<Ta_Maintenance_Type>;
  /** fetch data from the table: "ta_maintenance_type" using primary key columns */
  ta_maintenance_type_by_pk?: Maybe<Ta_Maintenance_Type>;
  /** fetch data from the table: "ta_mqtt_command" */
  ta_mqtt_command: Array<Ta_Mqtt_Command>;
  /** fetch data from the table: "ta_mqtt_command" using primary key columns */
  ta_mqtt_command_by_pk?: Maybe<Ta_Mqtt_Command>;
  /** fetch data from the table: "ta_notification" */
  ta_notification: Array<Ta_Notification>;
  /** fetch aggregated fields from the table: "ta_notification" */
  ta_notification_aggregate: Ta_Notification_Aggregate;
  /** fetch data from the table: "ta_notification" using primary key columns */
  ta_notification_by_pk?: Maybe<Ta_Notification>;
  /** fetch data from the table: "ta_notification_log" */
  ta_notification_log: Array<Ta_Notification_Log>;
  /** fetch data from the table: "ta_notification_log" using primary key columns */
  ta_notification_log_by_pk?: Maybe<Ta_Notification_Log>;
  /** fetch data from the table: "ta_notification_log_type" */
  ta_notification_log_type: Array<Ta_Notification_Log_Type>;
  /** fetch data from the table: "ta_notification_log_type" using primary key columns */
  ta_notification_log_type_by_pk?: Maybe<Ta_Notification_Log_Type>;
  /** An array relationship */
  ta_notification_notes: Array<Ta_Notification_Notes>;
  /** fetch data from the table: "ta_notification_notes" using primary key columns */
  ta_notification_notes_by_pk?: Maybe<Ta_Notification_Notes>;
  /** fetch data from the table: "ta_notification_reminder" */
  ta_notification_reminder: Array<Ta_Notification_Reminder>;
  /** fetch data from the table: "ta_notification_reminder" using primary key columns */
  ta_notification_reminder_by_pk?: Maybe<Ta_Notification_Reminder>;
  /** fetch data from the table: "ta_notification_user" */
  ta_notification_user: Array<Ta_Notification_User>;
  /** fetch aggregated fields from the table: "ta_notification_user" */
  ta_notification_user_aggregate: Ta_Notification_User_Aggregate;
  /** fetch data from the table: "ta_notification_user" using primary key columns */
  ta_notification_user_by_pk?: Maybe<Ta_Notification_User>;
  /** fetch data from the table: "ta_operation_modes" */
  ta_operation_modes: Array<Ta_Operation_Modes>;
  /** fetch data from the table: "ta_operation_modes" using primary key columns */
  ta_operation_modes_by_pk?: Maybe<Ta_Operation_Modes>;
  /** fetch data from the table: "ta_organisation" */
  ta_organisation: Array<Ta_Organisation>;
  /** fetch data from the table: "ta_organisation" using primary key columns */
  ta_organisation_by_pk?: Maybe<Ta_Organisation>;
  /** fetch data from the table: "ta_organisation_status" */
  ta_organisation_status: Array<Ta_Organisation_Status>;
  /** fetch data from the table: "ta_organisation_status" using primary key columns */
  ta_organisation_status_by_pk?: Maybe<Ta_Organisation_Status>;
  /** fetch data from the table: "ta_package" */
  ta_package: Array<Ta_Package>;
  /** fetch data from the table: "ta_package" using primary key columns */
  ta_package_by_pk?: Maybe<Ta_Package>;
  /** fetch data from the table: "ta_package_count" */
  ta_package_count: Array<Ta_Package_Count>;
  /** fetch data from the table: "ta_package_count" using primary key columns */
  ta_package_count_by_pk?: Maybe<Ta_Package_Count>;
  /** An array relationship */
  ta_package_overrides: Array<Ta_Package_Overrides>;
  /** fetch data from the table: "ta_package_overrides" using primary key columns */
  ta_package_overrides_by_pk?: Maybe<Ta_Package_Overrides>;
  /** fetch data from the table: "ta_permission" */
  ta_permission: Array<Ta_Permission>;
  /** fetch data from the table: "ta_permission" using primary key columns */
  ta_permission_by_pk?: Maybe<Ta_Permission>;
  /** fetch data from the table: "ta_permission_type" */
  ta_permission_type: Array<Ta_Permission_Type>;
  /** fetch data from the table: "ta_permission_type" using primary key columns */
  ta_permission_type_by_pk?: Maybe<Ta_Permission_Type>;
  /** fetch data from the table: "ta_personal_device" */
  ta_personal_device: Array<Ta_Personal_Device>;
  /** fetch data from the table: "ta_personal_device" using primary key columns */
  ta_personal_device_by_pk?: Maybe<Ta_Personal_Device>;
  /** fetch data from the table: "ta_personal_device_log" */
  ta_personal_device_log: Array<Ta_Personal_Device_Log>;
  /** fetch data from the table: "ta_personal_device_log" using primary key columns */
  ta_personal_device_log_by_pk?: Maybe<Ta_Personal_Device_Log>;
  /** fetch data from the table: "ta_relationship_to_tag" */
  ta_relationship_to_tag: Array<Ta_Relationship_To_Tag>;
  /** fetch data from the table: "ta_relationship_to_tag" using primary key columns */
  ta_relationship_to_tag_by_pk?: Maybe<Ta_Relationship_To_Tag>;
  /** fetch data from the table: "ta_rule_notification" */
  ta_rule_notification: Array<Ta_Rule_Notification>;
  /** fetch data from the table: "ta_rule_notification" using primary key columns */
  ta_rule_notification_by_pk?: Maybe<Ta_Rule_Notification>;
  /** fetch data from the table: "ta_rule_notification_user" */
  ta_rule_notification_user: Array<Ta_Rule_Notification_User>;
  /** fetch data from the table: "ta_rule_notification_user" using primary key columns */
  ta_rule_notification_user_by_pk?: Maybe<Ta_Rule_Notification_User>;
  /** fetch data from the table: "ta_scenario_count" */
  ta_scenario_count: Array<Ta_Scenario_Count>;
  /** fetch data from the table: "ta_scenario_count" using primary key columns */
  ta_scenario_count_by_pk?: Maybe<Ta_Scenario_Count>;
  /** fetch data from the table: "ta_sensor" */
  ta_sensor: Array<Ta_Sensor>;
  /** fetch data from the table: "ta_sensor" using primary key columns */
  ta_sensor_by_pk?: Maybe<Ta_Sensor>;
  /** fetch data from the table: "ta_sensor_measurement" */
  ta_sensor_measurement: Array<Ta_Sensor_Measurement>;
  /** fetch data from the table: "ta_sensor_measurement" using primary key columns */
  ta_sensor_measurement_by_pk?: Maybe<Ta_Sensor_Measurement>;
  /** fetch data from the table: "ta_sms_log" */
  ta_sms_log: Array<Ta_Sms_Log>;
  /** fetch data from the table: "ta_sms_log" using primary key columns */
  ta_sms_log_by_pk?: Maybe<Ta_Sms_Log>;
  /** fetch data from the table: "ta_supplier" */
  ta_supplier: Array<Ta_Supplier>;
  /** fetch data from the table: "ta_supplier" using primary key columns */
  ta_supplier_by_pk?: Maybe<Ta_Supplier>;
  /** fetch data from the table: "ta_supplier_user" */
  ta_supplier_user: Array<Ta_Supplier_User>;
  /** fetch data from the table: "ta_supplier_user" using primary key columns */
  ta_supplier_user_by_pk?: Maybe<Ta_Supplier_User>;
  /** fetch data from the table: "ta_tag" */
  ta_tag: Array<Ta_Tag>;
  /** fetch data from the table: "ta_tag" using primary key columns */
  ta_tag_by_pk?: Maybe<Ta_Tag>;
  /** fetch data from the table: "ta_tag_package" */
  ta_tag_package: Array<Ta_Tag_Package>;
  /** fetch data from the table: "ta_tag_package" using primary key columns */
  ta_tag_package_by_pk?: Maybe<Ta_Tag_Package>;
  /** fetch data from the table: "ta_tag_rule_notification" */
  ta_tag_rule_notification: Array<Ta_Tag_Rule_Notification>;
  /** fetch data from the table: "ta_tag_rule_notification" using primary key columns */
  ta_tag_rule_notification_by_pk?: Maybe<Ta_Tag_Rule_Notification>;
  /** fetch data from the table: "ta_tracker" */
  ta_tracker: Array<Ta_Tracker>;
  /** fetch data from the table: "ta_tracker" using primary key columns */
  ta_tracker_by_pk?: Maybe<Ta_Tracker>;
  /** fetch data from the table: "ta_tracker_log" */
  ta_tracker_log: Array<Ta_Tracker_Log>;
  /** fetch data from the table: "ta_tracker_log" using primary key columns */
  ta_tracker_log_by_pk?: Maybe<Ta_Tracker_Log>;
  /** fetch data from the table: "ta_tracker_measurement" */
  ta_tracker_measurement: Array<Ta_Tracker_Measurement>;
  /** fetch aggregated fields from the table: "ta_tracker_measurement" */
  ta_tracker_measurement_aggregate: Ta_Tracker_Measurement_Aggregate;
  /** fetch data from the table: "ta_tracker_measurement" using primary key columns */
  ta_tracker_measurement_by_pk?: Maybe<Ta_Tracker_Measurement>;
  /** fetch data from the table: "ta_user" */
  ta_user: Array<Ta_User>;
  /** fetch data from the table: "ta_user" using primary key columns */
  ta_user_by_pk?: Maybe<Ta_User>;
  /** An array relationship */
  ta_user_device_tokens: Array<Ta_User_Device_Tokens>;
  /** fetch data from the table: "ta_user_device_tokens" using primary key columns */
  ta_user_device_tokens_by_pk?: Maybe<Ta_User_Device_Tokens>;
  /** fetch data from the table: "ta_user_insight" */
  ta_user_insight: Array<Ta_User_Insight>;
  /** fetch data from the table: "ta_user_insight" using primary key columns */
  ta_user_insight_by_pk?: Maybe<Ta_User_Insight>;
  /** fetch data from the table: "ta_user_insight_type" */
  ta_user_insight_type: Array<Ta_User_Insight_Type>;
  /** fetch data from the table: "ta_user_insight_type" using primary key columns */
  ta_user_insight_type_by_pk?: Maybe<Ta_User_Insight_Type>;
  /** fetch data from the table: "ta_user_organisation" */
  ta_user_organisation: Array<Ta_User_Organisation>;
  /** fetch data from the table: "ta_user_organisation" using primary key columns */
  ta_user_organisation_by_pk?: Maybe<Ta_User_Organisation>;
  /** fetch data from the table: "ta_usergroup" */
  ta_usergroup: Array<Ta_Usergroup>;
  /** fetch data from the table: "ta_usergroup" using primary key columns */
  ta_usergroup_by_pk?: Maybe<Ta_Usergroup>;
  /** An array relationship */
  ta_usergroup_citizen: Array<Ta_Usergroup_Citizen>;
  /** fetch data from the table: "ta_usergroup_citizen" using primary key columns */
  ta_usergroup_citizen_by_pk?: Maybe<Ta_Usergroup_Citizen>;
  /** fetch data from the table: "ta_usergroup_user" */
  ta_usergroup_user: Array<Ta_Usergroup_User>;
  /** fetch data from the table: "ta_usergroup_user" using primary key columns */
  ta_usergroup_user_by_pk?: Maybe<Ta_Usergroup_User>;
  /** fetch data from the table: "ta_zone" */
  ta_zone: Array<Ta_Zone>;
  /** fetch data from the table: "ta_zone" using primary key columns */
  ta_zone_by_pk?: Maybe<Ta_Zone>;
  /** fetch data from the table: "view_default_scenarios" */
  view_default_scenarios: Array<View_Default_Scenarios>;
  /** fetch data from the table: "view_feature_subscription_device" */
  view_feature_subscription_device: Array<View_Feature_Subscription_Device>;
  /** fetch data from the table: "view_feature_subscription_package" */
  view_feature_subscription_package: Array<View_Feature_Subscription_Package>;
  /** fetch data from the table: "view_feature_user_insight" */
  view_feature_user_insight: Array<View_Feature_User_Insight>;
  /** fetch data from the table: "view_tag_rule_config" */
  view_tag_rule_config: Array<View_Tag_Rule_Config>;
  /** An array relationship */
  view_user_permissions: Array<View_User_Permissions>;
  /** An array relationship */
  view_user_residents: Array<View_User_Residents>;
};


export type Query_RootAudit_EventArgs = {
  distinct_on?: InputMaybe<Array<Audit_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Event_Order_By>>;
  where?: InputMaybe<Audit_Event_Bool_Exp>;
};


export type Query_RootAudit_Event_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_ActivationArgs = {
  distinct_on?: InputMaybe<Array<Ta_Activation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Activation_Order_By>>;
  where?: InputMaybe<Ta_Activation_Bool_Exp>;
};


export type Query_RootTa_Activation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Associated_Escalation_GroupArgs = {
  distinct_on?: InputMaybe<Array<Ta_Associated_Escalation_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Associated_Escalation_Group_Order_By>>;
  where?: InputMaybe<Ta_Associated_Escalation_Group_Bool_Exp>;
};


export type Query_RootTa_Associated_Escalation_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Associated_SensorArgs = {
  distinct_on?: InputMaybe<Array<Ta_Associated_Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Associated_Sensor_Order_By>>;
  where?: InputMaybe<Ta_Associated_Sensor_Bool_Exp>;
};


export type Query_RootTa_Associated_Sensor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Batch_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Ta_Batch_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Batch_History_Order_By>>;
  where?: InputMaybe<Ta_Batch_History_Bool_Exp>;
};


export type Query_RootTa_Batch_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_CitizenArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Bool_Exp>;
};


export type Query_RootTa_Citizen_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Citizen_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


export type Query_RootTa_Citizen_Device_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


export type Query_RootTa_Citizen_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Citizen_GatewayArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Gateway_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Gateway_Bool_Exp>;
};


export type Query_RootTa_Citizen_Gateway_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Citizen_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_User_Order_By>>;
  where?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
};


export type Query_RootTa_Citizen_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Order_By>>;
  where?: InputMaybe<Ta_Device_Bool_Exp>;
};


export type Query_RootTa_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Device_CountArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Count_Order_By>>;
  where?: InputMaybe<Ta_Device_Count_Bool_Exp>;
};


export type Query_RootTa_Device_Count_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Device_Online_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Online_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Online_History_Order_By>>;
  where?: InputMaybe<Ta_Device_Online_History_Bool_Exp>;
};


export type Query_RootTa_Device_Online_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_FloorsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Floors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Floors_Order_By>>;
  where?: InputMaybe<Ta_Floors_Bool_Exp>;
};


export type Query_RootTa_Floors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_GatewayArgs = {
  distinct_on?: InputMaybe<Array<Ta_Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Gateway_Order_By>>;
  where?: InputMaybe<Ta_Gateway_Bool_Exp>;
};


export type Query_RootTa_Gateway_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Gateway_LogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Gateway_Log_Order_By>>;
  where?: InputMaybe<Ta_Gateway_Log_Bool_Exp>;
};


export type Query_RootTa_Gateway_Online_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Ta_Gateway_Online_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Gateway_Online_History_Order_By>>;
  where?: InputMaybe<Ta_Gateway_Online_History_Bool_Exp>;
};


export type Query_RootTa_Gateway_Online_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_MaintenanceArgs = {
  distinct_on?: InputMaybe<Array<Ta_Maintenance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Maintenance_Order_By>>;
  where?: InputMaybe<Ta_Maintenance_Bool_Exp>;
};


export type Query_RootTa_Maintenance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Maintenance_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ta_Maintenance_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Maintenance_Type_Order_By>>;
  where?: InputMaybe<Ta_Maintenance_Type_Bool_Exp>;
};


export type Query_RootTa_Maintenance_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTa_Mqtt_CommandArgs = {
  distinct_on?: InputMaybe<Array<Ta_Mqtt_Command_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Mqtt_Command_Order_By>>;
  where?: InputMaybe<Ta_Mqtt_Command_Bool_Exp>;
};


export type Query_RootTa_Mqtt_Command_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Order_By>>;
  where?: InputMaybe<Ta_Notification_Bool_Exp>;
};


export type Query_RootTa_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Order_By>>;
  where?: InputMaybe<Ta_Notification_Bool_Exp>;
};


export type Query_RootTa_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Notification_LogArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Log_Order_By>>;
  where?: InputMaybe<Ta_Notification_Log_Bool_Exp>;
};


export type Query_RootTa_Notification_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Notification_Log_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Log_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Log_Type_Order_By>>;
  where?: InputMaybe<Ta_Notification_Log_Type_Bool_Exp>;
};


export type Query_RootTa_Notification_Log_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTa_Notification_NotesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Notes_Order_By>>;
  where?: InputMaybe<Ta_Notification_Notes_Bool_Exp>;
};


export type Query_RootTa_Notification_Notes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Notification_ReminderArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Reminder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Reminder_Order_By>>;
  where?: InputMaybe<Ta_Notification_Reminder_Bool_Exp>;
};


export type Query_RootTa_Notification_Reminder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Notification_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Notification_User_Bool_Exp>;
};


export type Query_RootTa_Notification_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Notification_User_Bool_Exp>;
};


export type Query_RootTa_Notification_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Operation_ModesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Operation_Modes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Operation_Modes_Order_By>>;
  where?: InputMaybe<Ta_Operation_Modes_Bool_Exp>;
};


export type Query_RootTa_Operation_Modes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_OrganisationArgs = {
  distinct_on?: InputMaybe<Array<Ta_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Organisation_Order_By>>;
  where?: InputMaybe<Ta_Organisation_Bool_Exp>;
};


export type Query_RootTa_Organisation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Organisation_StatusArgs = {
  distinct_on?: InputMaybe<Array<Ta_Organisation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Organisation_Status_Order_By>>;
  where?: InputMaybe<Ta_Organisation_Status_Bool_Exp>;
};


export type Query_RootTa_Organisation_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTa_PackageArgs = {
  distinct_on?: InputMaybe<Array<Ta_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Package_Order_By>>;
  where?: InputMaybe<Ta_Package_Bool_Exp>;
};


export type Query_RootTa_Package_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Package_CountArgs = {
  distinct_on?: InputMaybe<Array<Ta_Package_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Package_Count_Order_By>>;
  where?: InputMaybe<Ta_Package_Count_Bool_Exp>;
};


export type Query_RootTa_Package_Count_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Package_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Package_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Package_Overrides_Order_By>>;
  where?: InputMaybe<Ta_Package_Overrides_Bool_Exp>;
};


export type Query_RootTa_Package_Overrides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Ta_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Permission_Order_By>>;
  where?: InputMaybe<Ta_Permission_Bool_Exp>;
};


export type Query_RootTa_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Permission_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ta_Permission_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Permission_Type_Order_By>>;
  where?: InputMaybe<Ta_Permission_Type_Bool_Exp>;
};


export type Query_RootTa_Permission_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTa_Personal_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Ta_Personal_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Personal_Device_Order_By>>;
  where?: InputMaybe<Ta_Personal_Device_Bool_Exp>;
};


export type Query_RootTa_Personal_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Personal_Device_LogArgs = {
  distinct_on?: InputMaybe<Array<Ta_Personal_Device_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Personal_Device_Log_Order_By>>;
  where?: InputMaybe<Ta_Personal_Device_Log_Bool_Exp>;
};


export type Query_RootTa_Personal_Device_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Relationship_To_TagArgs = {
  distinct_on?: InputMaybe<Array<Ta_Relationship_To_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Relationship_To_Tag_Order_By>>;
  where?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
};


export type Query_RootTa_Relationship_To_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Rule_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Ta_Rule_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Rule_Notification_Order_By>>;
  where?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
};


export type Query_RootTa_Rule_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Rule_Notification_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_Rule_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Rule_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Rule_Notification_User_Bool_Exp>;
};


export type Query_RootTa_Rule_Notification_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Scenario_CountArgs = {
  distinct_on?: InputMaybe<Array<Ta_Scenario_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Scenario_Count_Order_By>>;
  where?: InputMaybe<Ta_Scenario_Count_Bool_Exp>;
};


export type Query_RootTa_Scenario_Count_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_SensorArgs = {
  distinct_on?: InputMaybe<Array<Ta_Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Sensor_Order_By>>;
  where?: InputMaybe<Ta_Sensor_Bool_Exp>;
};


export type Query_RootTa_Sensor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Sensor_MeasurementArgs = {
  distinct_on?: InputMaybe<Array<Ta_Sensor_Measurement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Sensor_Measurement_Order_By>>;
  where?: InputMaybe<Ta_Sensor_Measurement_Bool_Exp>;
};


export type Query_RootTa_Sensor_Measurement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Sms_LogArgs = {
  distinct_on?: InputMaybe<Array<Ta_Sms_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Sms_Log_Order_By>>;
  where?: InputMaybe<Ta_Sms_Log_Bool_Exp>;
};


export type Query_RootTa_Sms_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_SupplierArgs = {
  distinct_on?: InputMaybe<Array<Ta_Supplier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Supplier_Order_By>>;
  where?: InputMaybe<Ta_Supplier_Bool_Exp>;
};


export type Query_RootTa_Supplier_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Supplier_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_Supplier_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Supplier_User_Order_By>>;
  where?: InputMaybe<Ta_Supplier_User_Bool_Exp>;
};


export type Query_RootTa_Supplier_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_TagArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Order_By>>;
  where?: InputMaybe<Ta_Tag_Bool_Exp>;
};


export type Query_RootTa_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Tag_PackageArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Package_Order_By>>;
  where?: InputMaybe<Ta_Tag_Package_Bool_Exp>;
};


export type Query_RootTa_Tag_Package_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Tag_Rule_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Rule_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Rule_Notification_Order_By>>;
  where?: InputMaybe<Ta_Tag_Rule_Notification_Bool_Exp>;
};


export type Query_RootTa_Tag_Rule_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_TrackerArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Bool_Exp>;
};


export type Query_RootTa_Tracker_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Tracker_LogArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Log_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Log_Bool_Exp>;
};


export type Query_RootTa_Tracker_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Tracker_MeasurementArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Measurement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Measurement_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
};


export type Query_RootTa_Tracker_Measurement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Measurement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Measurement_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
};


export type Query_RootTa_Tracker_Measurement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Order_By>>;
  where?: InputMaybe<Ta_User_Bool_Exp>;
};


export type Query_RootTa_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_User_Device_TokensArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Device_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Device_Tokens_Order_By>>;
  where?: InputMaybe<Ta_User_Device_Tokens_Bool_Exp>;
};


export type Query_RootTa_User_Device_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_User_InsightArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Insight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Insight_Order_By>>;
  where?: InputMaybe<Ta_User_Insight_Bool_Exp>;
};


export type Query_RootTa_User_Insight_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_User_Insight_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Insight_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Insight_Type_Order_By>>;
  where?: InputMaybe<Ta_User_Insight_Type_Bool_Exp>;
};


export type Query_RootTa_User_Insight_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTa_User_OrganisationArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


export type Query_RootTa_User_Organisation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_UsergroupArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_Bool_Exp>;
};


export type Query_RootTa_Usergroup_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Usergroup_CitizenArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_Citizen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_Citizen_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
};


export type Query_RootTa_Usergroup_Citizen_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_Usergroup_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_User_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_User_Bool_Exp>;
};


export type Query_RootTa_Usergroup_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTa_ZoneArgs = {
  distinct_on?: InputMaybe<Array<Ta_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Zone_Order_By>>;
  where?: InputMaybe<Ta_Zone_Bool_Exp>;
};


export type Query_RootTa_Zone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootView_Default_ScenariosArgs = {
  distinct_on?: InputMaybe<Array<View_Default_Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Default_Scenarios_Order_By>>;
  where?: InputMaybe<View_Default_Scenarios_Bool_Exp>;
};


export type Query_RootView_Feature_Subscription_DeviceArgs = {
  distinct_on?: InputMaybe<Array<View_Feature_Subscription_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Feature_Subscription_Device_Order_By>>;
  where?: InputMaybe<View_Feature_Subscription_Device_Bool_Exp>;
};


export type Query_RootView_Feature_Subscription_PackageArgs = {
  distinct_on?: InputMaybe<Array<View_Feature_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Feature_Subscription_Package_Order_By>>;
  where?: InputMaybe<View_Feature_Subscription_Package_Bool_Exp>;
};


export type Query_RootView_Feature_User_InsightArgs = {
  distinct_on?: InputMaybe<Array<View_Feature_User_Insight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Feature_User_Insight_Order_By>>;
  where?: InputMaybe<View_Feature_User_Insight_Bool_Exp>;
};


export type Query_RootView_Tag_Rule_ConfigArgs = {
  distinct_on?: InputMaybe<Array<View_Tag_Rule_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Tag_Rule_Config_Order_By>>;
  where?: InputMaybe<View_Tag_Rule_Config_Bool_Exp>;
};


export type Query_RootView_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<View_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Permissions_Order_By>>;
  where?: InputMaybe<View_User_Permissions_Bool_Exp>;
};


export type Query_RootView_User_ResidentsArgs = {
  distinct_on?: InputMaybe<Array<View_User_Residents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Residents_Order_By>>;
  where?: InputMaybe<View_User_Residents_Bool_Exp>;
};

export type Resident_User_Groups = {
  __typename?: 'resident_user_groups';
  association_config?: Maybe<Scalars['AssociatedEscalationGroupConfig']['output']>;
  group_config?: Maybe<Scalars['UserGroupConfig']['output']>;
};

export type Resident_User_Groups_Set_Input = {
  __typename?: 'resident_user_groups_set_input';
  association_config?: Maybe<Scalars['AssociatedEscalationGroupConfig']['output']>;
  group_config?: Maybe<Scalars['UserGroupConfig']['output']>;
};

export type Resident_User_Groups_Stream_Cursor_Value_Input = {
  association_config?: InputMaybe<Scalars['AssociatedEscalationGroupConfig']['input']>;
  group_config?: InputMaybe<Scalars['UserGroupConfig']['input']>;
};

export type Rt_Get_Resident_User_Groups = {
  __typename?: 'rt_get_resident_user_groups';
  association_config?: Maybe<Scalars['AssociatedEscalationGroupConfig']['output']>;
  group_config?: Maybe<Scalars['UserGroupConfig']['output']>;
};

export type Rt_Get_Resident_User_Groups_Set_Input = {
  __typename?: 'rt_get_resident_user_groups_set_input';
  association_config?: Maybe<Scalars['AssociatedEscalationGroupConfig']['output']>;
  group_config?: Maybe<Scalars['UserGroupConfig']['output']>;
};

export type Rt_Get_Resident_User_Groups_Stream_Cursor_Value_Input = {
  association_config?: InputMaybe<Scalars['AssociatedEscalationGroupConfig']['input']>;
  group_config?: InputMaybe<Scalars['UserGroupConfig']['input']>;
};

export type Rt_Get_Usergroup_Users_And_Status = {
  __typename?: 'rt_get_usergroup_users_and_status';
  status?: Maybe<Scalars['rt_get_usergroup_users_and_status_status']['output']>;
  users?: Maybe<Scalars['UserGroupUserList']['output']>;
};

export type Rt_Get_Usergroup_Users_And_Status_Set_Input = {
  __typename?: 'rt_get_usergroup_users_and_status_set_input';
  status?: Maybe<Scalars['rt_get_usergroup_users_and_status_status']['output']>;
  users?: Maybe<Scalars['UserGroupUserList']['output']>;
};

export type Rt_Get_Usergroup_Users_And_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['rt_get_usergroup_users_and_status_status']['input']>;
  users?: InputMaybe<Scalars['UserGroupUserList']['input']>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "audit.event" */
  audit_event: Array<Audit_Event>;
  /** fetch data from the table: "audit.event" using primary key columns */
  audit_event_by_pk?: Maybe<Audit_Event>;
  /** fetch data from the table in a streaming manner: "audit.event" */
  audit_event_stream: Array<Audit_Event>;
  /** fetch data from the table: "ta_activation" */
  ta_activation: Array<Ta_Activation>;
  /** fetch data from the table: "ta_activation" using primary key columns */
  ta_activation_by_pk?: Maybe<Ta_Activation>;
  /** fetch data from the table in a streaming manner: "ta_activation" */
  ta_activation_stream: Array<Ta_Activation>;
  /** fetch data from the table: "ta_associated_escalation_group" */
  ta_associated_escalation_group: Array<Ta_Associated_Escalation_Group>;
  /** fetch data from the table: "ta_associated_escalation_group" using primary key columns */
  ta_associated_escalation_group_by_pk?: Maybe<Ta_Associated_Escalation_Group>;
  /** fetch data from the table in a streaming manner: "ta_associated_escalation_group" */
  ta_associated_escalation_group_stream: Array<Ta_Associated_Escalation_Group>;
  /** fetch data from the table: "ta_associated_sensor" */
  ta_associated_sensor: Array<Ta_Associated_Sensor>;
  /** fetch data from the table: "ta_associated_sensor" using primary key columns */
  ta_associated_sensor_by_pk?: Maybe<Ta_Associated_Sensor>;
  /** fetch data from the table in a streaming manner: "ta_associated_sensor" */
  ta_associated_sensor_stream: Array<Ta_Associated_Sensor>;
  /** An array relationship */
  ta_batch_history: Array<Ta_Batch_History>;
  /** fetch data from the table: "ta_batch_history" using primary key columns */
  ta_batch_history_by_pk?: Maybe<Ta_Batch_History>;
  /** fetch data from the table in a streaming manner: "ta_batch_history" */
  ta_batch_history_stream: Array<Ta_Batch_History>;
  /** An array relationship */
  ta_citizen: Array<Ta_Citizen>;
  /** fetch data from the table: "ta_citizen" using primary key columns */
  ta_citizen_by_pk?: Maybe<Ta_Citizen>;
  /** fetch data from the table: "ta_citizen_device" */
  ta_citizen_device: Array<Ta_Citizen_Device>;
  /** fetch aggregated fields from the table: "ta_citizen_device" */
  ta_citizen_device_aggregate: Ta_Citizen_Device_Aggregate;
  /** fetch data from the table: "ta_citizen_device" using primary key columns */
  ta_citizen_device_by_pk?: Maybe<Ta_Citizen_Device>;
  /** fetch data from the table in a streaming manner: "ta_citizen_device" */
  ta_citizen_device_stream: Array<Ta_Citizen_Device>;
  /** fetch data from the table: "ta_citizen_gateway" */
  ta_citizen_gateway: Array<Ta_Citizen_Gateway>;
  /** fetch data from the table: "ta_citizen_gateway" using primary key columns */
  ta_citizen_gateway_by_pk?: Maybe<Ta_Citizen_Gateway>;
  /** fetch data from the table in a streaming manner: "ta_citizen_gateway" */
  ta_citizen_gateway_stream: Array<Ta_Citizen_Gateway>;
  /** fetch data from the table in a streaming manner: "ta_citizen" */
  ta_citizen_stream: Array<Ta_Citizen>;
  /** fetch data from the table: "ta_citizen_user" */
  ta_citizen_user: Array<Ta_Citizen_User>;
  /** fetch data from the table: "ta_citizen_user" using primary key columns */
  ta_citizen_user_by_pk?: Maybe<Ta_Citizen_User>;
  /** fetch data from the table in a streaming manner: "ta_citizen_user" */
  ta_citizen_user_stream: Array<Ta_Citizen_User>;
  /** fetch data from the table: "ta_device" */
  ta_device: Array<Ta_Device>;
  /** fetch data from the table: "ta_device" using primary key columns */
  ta_device_by_pk?: Maybe<Ta_Device>;
  /** fetch data from the table: "ta_device_count" */
  ta_device_count: Array<Ta_Device_Count>;
  /** fetch data from the table: "ta_device_count" using primary key columns */
  ta_device_count_by_pk?: Maybe<Ta_Device_Count>;
  /** fetch data from the table in a streaming manner: "ta_device_count" */
  ta_device_count_stream: Array<Ta_Device_Count>;
  /** fetch data from the table: "ta_device_online_history" */
  ta_device_online_history: Array<Ta_Device_Online_History>;
  /** fetch data from the table: "ta_device_online_history" using primary key columns */
  ta_device_online_history_by_pk?: Maybe<Ta_Device_Online_History>;
  /** fetch data from the table in a streaming manner: "ta_device_online_history" */
  ta_device_online_history_stream: Array<Ta_Device_Online_History>;
  /** fetch data from the table in a streaming manner: "ta_device" */
  ta_device_stream: Array<Ta_Device>;
  /** An array relationship */
  ta_floors: Array<Ta_Floors>;
  /** fetch data from the table: "ta_floors" using primary key columns */
  ta_floors_by_pk?: Maybe<Ta_Floors>;
  /** fetch data from the table in a streaming manner: "ta_floors" */
  ta_floors_stream: Array<Ta_Floors>;
  /** fetch data from the table: "ta_gateway" */
  ta_gateway: Array<Ta_Gateway>;
  /** fetch data from the table: "ta_gateway" using primary key columns */
  ta_gateway_by_pk?: Maybe<Ta_Gateway>;
  /** fetch data from the table: "ta_gateway_log" */
  ta_gateway_log: Array<Ta_Gateway_Log>;
  /** fetch data from the table: "ta_gateway_online_history" */
  ta_gateway_online_history: Array<Ta_Gateway_Online_History>;
  /** fetch data from the table: "ta_gateway_online_history" using primary key columns */
  ta_gateway_online_history_by_pk?: Maybe<Ta_Gateway_Online_History>;
  /** fetch data from the table in a streaming manner: "ta_gateway_online_history" */
  ta_gateway_online_history_stream: Array<Ta_Gateway_Online_History>;
  /** fetch data from the table in a streaming manner: "ta_gateway" */
  ta_gateway_stream: Array<Ta_Gateway>;
  /** fetch data from the table: "ta_maintenance" */
  ta_maintenance: Array<Ta_Maintenance>;
  /** fetch data from the table: "ta_maintenance" using primary key columns */
  ta_maintenance_by_pk?: Maybe<Ta_Maintenance>;
  /** fetch data from the table in a streaming manner: "ta_maintenance" */
  ta_maintenance_stream: Array<Ta_Maintenance>;
  /** fetch data from the table: "ta_maintenance_type" */
  ta_maintenance_type: Array<Ta_Maintenance_Type>;
  /** fetch data from the table: "ta_maintenance_type" using primary key columns */
  ta_maintenance_type_by_pk?: Maybe<Ta_Maintenance_Type>;
  /** fetch data from the table in a streaming manner: "ta_maintenance_type" */
  ta_maintenance_type_stream: Array<Ta_Maintenance_Type>;
  /** fetch data from the table: "ta_mqtt_command" */
  ta_mqtt_command: Array<Ta_Mqtt_Command>;
  /** fetch data from the table: "ta_mqtt_command" using primary key columns */
  ta_mqtt_command_by_pk?: Maybe<Ta_Mqtt_Command>;
  /** fetch data from the table in a streaming manner: "ta_mqtt_command" */
  ta_mqtt_command_stream: Array<Ta_Mqtt_Command>;
  /** fetch data from the table: "ta_notification" */
  ta_notification: Array<Ta_Notification>;
  /** fetch aggregated fields from the table: "ta_notification" */
  ta_notification_aggregate: Ta_Notification_Aggregate;
  /** fetch data from the table: "ta_notification" using primary key columns */
  ta_notification_by_pk?: Maybe<Ta_Notification>;
  /** fetch data from the table: "ta_notification_log" */
  ta_notification_log: Array<Ta_Notification_Log>;
  /** fetch data from the table: "ta_notification_log" using primary key columns */
  ta_notification_log_by_pk?: Maybe<Ta_Notification_Log>;
  /** fetch data from the table in a streaming manner: "ta_notification_log" */
  ta_notification_log_stream: Array<Ta_Notification_Log>;
  /** fetch data from the table: "ta_notification_log_type" */
  ta_notification_log_type: Array<Ta_Notification_Log_Type>;
  /** fetch data from the table: "ta_notification_log_type" using primary key columns */
  ta_notification_log_type_by_pk?: Maybe<Ta_Notification_Log_Type>;
  /** fetch data from the table in a streaming manner: "ta_notification_log_type" */
  ta_notification_log_type_stream: Array<Ta_Notification_Log_Type>;
  /** An array relationship */
  ta_notification_notes: Array<Ta_Notification_Notes>;
  /** fetch data from the table: "ta_notification_notes" using primary key columns */
  ta_notification_notes_by_pk?: Maybe<Ta_Notification_Notes>;
  /** fetch data from the table in a streaming manner: "ta_notification_notes" */
  ta_notification_notes_stream: Array<Ta_Notification_Notes>;
  /** fetch data from the table: "ta_notification_reminder" */
  ta_notification_reminder: Array<Ta_Notification_Reminder>;
  /** fetch data from the table: "ta_notification_reminder" using primary key columns */
  ta_notification_reminder_by_pk?: Maybe<Ta_Notification_Reminder>;
  /** fetch data from the table in a streaming manner: "ta_notification_reminder" */
  ta_notification_reminder_stream: Array<Ta_Notification_Reminder>;
  /** fetch data from the table in a streaming manner: "ta_notification" */
  ta_notification_stream: Array<Ta_Notification>;
  /** fetch data from the table: "ta_notification_user" */
  ta_notification_user: Array<Ta_Notification_User>;
  /** fetch aggregated fields from the table: "ta_notification_user" */
  ta_notification_user_aggregate: Ta_Notification_User_Aggregate;
  /** fetch data from the table: "ta_notification_user" using primary key columns */
  ta_notification_user_by_pk?: Maybe<Ta_Notification_User>;
  /** fetch data from the table in a streaming manner: "ta_notification_user" */
  ta_notification_user_stream: Array<Ta_Notification_User>;
  /** fetch data from the table: "ta_operation_modes" */
  ta_operation_modes: Array<Ta_Operation_Modes>;
  /** fetch data from the table: "ta_operation_modes" using primary key columns */
  ta_operation_modes_by_pk?: Maybe<Ta_Operation_Modes>;
  /** fetch data from the table in a streaming manner: "ta_operation_modes" */
  ta_operation_modes_stream: Array<Ta_Operation_Modes>;
  /** fetch data from the table: "ta_organisation" */
  ta_organisation: Array<Ta_Organisation>;
  /** fetch data from the table: "ta_organisation" using primary key columns */
  ta_organisation_by_pk?: Maybe<Ta_Organisation>;
  /** fetch data from the table: "ta_organisation_status" */
  ta_organisation_status: Array<Ta_Organisation_Status>;
  /** fetch data from the table: "ta_organisation_status" using primary key columns */
  ta_organisation_status_by_pk?: Maybe<Ta_Organisation_Status>;
  /** fetch data from the table in a streaming manner: "ta_organisation_status" */
  ta_organisation_status_stream: Array<Ta_Organisation_Status>;
  /** fetch data from the table in a streaming manner: "ta_organisation" */
  ta_organisation_stream: Array<Ta_Organisation>;
  /** fetch data from the table: "ta_package" */
  ta_package: Array<Ta_Package>;
  /** fetch data from the table: "ta_package" using primary key columns */
  ta_package_by_pk?: Maybe<Ta_Package>;
  /** fetch data from the table: "ta_package_count" */
  ta_package_count: Array<Ta_Package_Count>;
  /** fetch data from the table: "ta_package_count" using primary key columns */
  ta_package_count_by_pk?: Maybe<Ta_Package_Count>;
  /** fetch data from the table in a streaming manner: "ta_package_count" */
  ta_package_count_stream: Array<Ta_Package_Count>;
  /** An array relationship */
  ta_package_overrides: Array<Ta_Package_Overrides>;
  /** fetch data from the table: "ta_package_overrides" using primary key columns */
  ta_package_overrides_by_pk?: Maybe<Ta_Package_Overrides>;
  /** fetch data from the table in a streaming manner: "ta_package_overrides" */
  ta_package_overrides_stream: Array<Ta_Package_Overrides>;
  /** fetch data from the table in a streaming manner: "ta_package" */
  ta_package_stream: Array<Ta_Package>;
  /** fetch data from the table: "ta_permission" */
  ta_permission: Array<Ta_Permission>;
  /** fetch data from the table: "ta_permission" using primary key columns */
  ta_permission_by_pk?: Maybe<Ta_Permission>;
  /** fetch data from the table in a streaming manner: "ta_permission" */
  ta_permission_stream: Array<Ta_Permission>;
  /** fetch data from the table: "ta_permission_type" */
  ta_permission_type: Array<Ta_Permission_Type>;
  /** fetch data from the table: "ta_permission_type" using primary key columns */
  ta_permission_type_by_pk?: Maybe<Ta_Permission_Type>;
  /** fetch data from the table in a streaming manner: "ta_permission_type" */
  ta_permission_type_stream: Array<Ta_Permission_Type>;
  /** fetch data from the table: "ta_personal_device" */
  ta_personal_device: Array<Ta_Personal_Device>;
  /** fetch data from the table: "ta_personal_device" using primary key columns */
  ta_personal_device_by_pk?: Maybe<Ta_Personal_Device>;
  /** fetch data from the table: "ta_personal_device_log" */
  ta_personal_device_log: Array<Ta_Personal_Device_Log>;
  /** fetch data from the table: "ta_personal_device_log" using primary key columns */
  ta_personal_device_log_by_pk?: Maybe<Ta_Personal_Device_Log>;
  /** fetch data from the table in a streaming manner: "ta_personal_device_log" */
  ta_personal_device_log_stream: Array<Ta_Personal_Device_Log>;
  /** fetch data from the table in a streaming manner: "ta_personal_device" */
  ta_personal_device_stream: Array<Ta_Personal_Device>;
  /** fetch data from the table: "ta_relationship_to_tag" */
  ta_relationship_to_tag: Array<Ta_Relationship_To_Tag>;
  /** fetch data from the table: "ta_relationship_to_tag" using primary key columns */
  ta_relationship_to_tag_by_pk?: Maybe<Ta_Relationship_To_Tag>;
  /** fetch data from the table in a streaming manner: "ta_relationship_to_tag" */
  ta_relationship_to_tag_stream: Array<Ta_Relationship_To_Tag>;
  /** fetch data from the table: "ta_rule_notification" */
  ta_rule_notification: Array<Ta_Rule_Notification>;
  /** fetch data from the table: "ta_rule_notification" using primary key columns */
  ta_rule_notification_by_pk?: Maybe<Ta_Rule_Notification>;
  /** fetch data from the table in a streaming manner: "ta_rule_notification" */
  ta_rule_notification_stream: Array<Ta_Rule_Notification>;
  /** fetch data from the table: "ta_rule_notification_user" */
  ta_rule_notification_user: Array<Ta_Rule_Notification_User>;
  /** fetch data from the table: "ta_rule_notification_user" using primary key columns */
  ta_rule_notification_user_by_pk?: Maybe<Ta_Rule_Notification_User>;
  /** fetch data from the table in a streaming manner: "ta_rule_notification_user" */
  ta_rule_notification_user_stream: Array<Ta_Rule_Notification_User>;
  /** fetch data from the table: "ta_scenario_count" */
  ta_scenario_count: Array<Ta_Scenario_Count>;
  /** fetch data from the table: "ta_scenario_count" using primary key columns */
  ta_scenario_count_by_pk?: Maybe<Ta_Scenario_Count>;
  /** fetch data from the table in a streaming manner: "ta_scenario_count" */
  ta_scenario_count_stream: Array<Ta_Scenario_Count>;
  /** fetch data from the table: "ta_sensor" */
  ta_sensor: Array<Ta_Sensor>;
  /** fetch data from the table: "ta_sensor" using primary key columns */
  ta_sensor_by_pk?: Maybe<Ta_Sensor>;
  /** fetch data from the table: "ta_sensor_measurement" */
  ta_sensor_measurement: Array<Ta_Sensor_Measurement>;
  /** fetch data from the table: "ta_sensor_measurement" using primary key columns */
  ta_sensor_measurement_by_pk?: Maybe<Ta_Sensor_Measurement>;
  /** fetch data from the table in a streaming manner: "ta_sensor_measurement" */
  ta_sensor_measurement_stream: Array<Ta_Sensor_Measurement>;
  /** fetch data from the table in a streaming manner: "ta_sensor" */
  ta_sensor_stream: Array<Ta_Sensor>;
  /** fetch data from the table: "ta_sms_log" */
  ta_sms_log: Array<Ta_Sms_Log>;
  /** fetch data from the table: "ta_sms_log" using primary key columns */
  ta_sms_log_by_pk?: Maybe<Ta_Sms_Log>;
  /** fetch data from the table in a streaming manner: "ta_sms_log" */
  ta_sms_log_stream: Array<Ta_Sms_Log>;
  /** fetch data from the table: "ta_supplier" */
  ta_supplier: Array<Ta_Supplier>;
  /** fetch data from the table: "ta_supplier" using primary key columns */
  ta_supplier_by_pk?: Maybe<Ta_Supplier>;
  /** fetch data from the table in a streaming manner: "ta_supplier" */
  ta_supplier_stream: Array<Ta_Supplier>;
  /** fetch data from the table: "ta_supplier_user" */
  ta_supplier_user: Array<Ta_Supplier_User>;
  /** fetch data from the table: "ta_supplier_user" using primary key columns */
  ta_supplier_user_by_pk?: Maybe<Ta_Supplier_User>;
  /** fetch data from the table in a streaming manner: "ta_supplier_user" */
  ta_supplier_user_stream: Array<Ta_Supplier_User>;
  /** fetch data from the table: "ta_tag" */
  ta_tag: Array<Ta_Tag>;
  /** fetch data from the table: "ta_tag" using primary key columns */
  ta_tag_by_pk?: Maybe<Ta_Tag>;
  /** fetch data from the table: "ta_tag_package" */
  ta_tag_package: Array<Ta_Tag_Package>;
  /** fetch data from the table: "ta_tag_package" using primary key columns */
  ta_tag_package_by_pk?: Maybe<Ta_Tag_Package>;
  /** fetch data from the table in a streaming manner: "ta_tag_package" */
  ta_tag_package_stream: Array<Ta_Tag_Package>;
  /** fetch data from the table: "ta_tag_rule_notification" */
  ta_tag_rule_notification: Array<Ta_Tag_Rule_Notification>;
  /** fetch data from the table: "ta_tag_rule_notification" using primary key columns */
  ta_tag_rule_notification_by_pk?: Maybe<Ta_Tag_Rule_Notification>;
  /** fetch data from the table in a streaming manner: "ta_tag_rule_notification" */
  ta_tag_rule_notification_stream: Array<Ta_Tag_Rule_Notification>;
  /** fetch data from the table in a streaming manner: "ta_tag" */
  ta_tag_stream: Array<Ta_Tag>;
  /** fetch data from the table: "ta_tracker" */
  ta_tracker: Array<Ta_Tracker>;
  /** fetch data from the table: "ta_tracker" using primary key columns */
  ta_tracker_by_pk?: Maybe<Ta_Tracker>;
  /** fetch data from the table: "ta_tracker_log" */
  ta_tracker_log: Array<Ta_Tracker_Log>;
  /** fetch data from the table: "ta_tracker_log" using primary key columns */
  ta_tracker_log_by_pk?: Maybe<Ta_Tracker_Log>;
  /** fetch data from the table in a streaming manner: "ta_tracker_log" */
  ta_tracker_log_stream: Array<Ta_Tracker_Log>;
  /** fetch data from the table: "ta_tracker_measurement" */
  ta_tracker_measurement: Array<Ta_Tracker_Measurement>;
  /** fetch aggregated fields from the table: "ta_tracker_measurement" */
  ta_tracker_measurement_aggregate: Ta_Tracker_Measurement_Aggregate;
  /** fetch data from the table: "ta_tracker_measurement" using primary key columns */
  ta_tracker_measurement_by_pk?: Maybe<Ta_Tracker_Measurement>;
  /** fetch data from the table in a streaming manner: "ta_tracker_measurement" */
  ta_tracker_measurement_stream: Array<Ta_Tracker_Measurement>;
  /** fetch data from the table in a streaming manner: "ta_tracker" */
  ta_tracker_stream: Array<Ta_Tracker>;
  /** fetch data from the table: "ta_user" */
  ta_user: Array<Ta_User>;
  /** fetch data from the table: "ta_user" using primary key columns */
  ta_user_by_pk?: Maybe<Ta_User>;
  /** An array relationship */
  ta_user_device_tokens: Array<Ta_User_Device_Tokens>;
  /** fetch data from the table: "ta_user_device_tokens" using primary key columns */
  ta_user_device_tokens_by_pk?: Maybe<Ta_User_Device_Tokens>;
  /** fetch data from the table in a streaming manner: "ta_user_device_tokens" */
  ta_user_device_tokens_stream: Array<Ta_User_Device_Tokens>;
  /** fetch data from the table: "ta_user_insight" */
  ta_user_insight: Array<Ta_User_Insight>;
  /** fetch data from the table: "ta_user_insight" using primary key columns */
  ta_user_insight_by_pk?: Maybe<Ta_User_Insight>;
  /** fetch data from the table in a streaming manner: "ta_user_insight" */
  ta_user_insight_stream: Array<Ta_User_Insight>;
  /** fetch data from the table: "ta_user_insight_type" */
  ta_user_insight_type: Array<Ta_User_Insight_Type>;
  /** fetch data from the table: "ta_user_insight_type" using primary key columns */
  ta_user_insight_type_by_pk?: Maybe<Ta_User_Insight_Type>;
  /** fetch data from the table in a streaming manner: "ta_user_insight_type" */
  ta_user_insight_type_stream: Array<Ta_User_Insight_Type>;
  /** fetch data from the table: "ta_user_organisation" */
  ta_user_organisation: Array<Ta_User_Organisation>;
  /** fetch data from the table: "ta_user_organisation" using primary key columns */
  ta_user_organisation_by_pk?: Maybe<Ta_User_Organisation>;
  /** fetch data from the table in a streaming manner: "ta_user_organisation" */
  ta_user_organisation_stream: Array<Ta_User_Organisation>;
  /** fetch data from the table in a streaming manner: "ta_user" */
  ta_user_stream: Array<Ta_User>;
  /** fetch data from the table: "ta_usergroup" */
  ta_usergroup: Array<Ta_Usergroup>;
  /** fetch data from the table: "ta_usergroup" using primary key columns */
  ta_usergroup_by_pk?: Maybe<Ta_Usergroup>;
  /** An array relationship */
  ta_usergroup_citizen: Array<Ta_Usergroup_Citizen>;
  /** fetch data from the table: "ta_usergroup_citizen" using primary key columns */
  ta_usergroup_citizen_by_pk?: Maybe<Ta_Usergroup_Citizen>;
  /** fetch data from the table in a streaming manner: "ta_usergroup_citizen" */
  ta_usergroup_citizen_stream: Array<Ta_Usergroup_Citizen>;
  /** fetch data from the table in a streaming manner: "ta_usergroup" */
  ta_usergroup_stream: Array<Ta_Usergroup>;
  /** fetch data from the table: "ta_usergroup_user" */
  ta_usergroup_user: Array<Ta_Usergroup_User>;
  /** fetch data from the table: "ta_usergroup_user" using primary key columns */
  ta_usergroup_user_by_pk?: Maybe<Ta_Usergroup_User>;
  /** fetch data from the table in a streaming manner: "ta_usergroup_user" */
  ta_usergroup_user_stream: Array<Ta_Usergroup_User>;
  /** fetch data from the table: "ta_zone" */
  ta_zone: Array<Ta_Zone>;
  /** fetch data from the table: "ta_zone" using primary key columns */
  ta_zone_by_pk?: Maybe<Ta_Zone>;
  /** fetch data from the table in a streaming manner: "ta_zone" */
  ta_zone_stream: Array<Ta_Zone>;
  /** fetch data from the table: "view_default_scenarios" */
  view_default_scenarios: Array<View_Default_Scenarios>;
  /** fetch data from the table in a streaming manner: "view_default_scenarios" */
  view_default_scenarios_stream: Array<View_Default_Scenarios>;
  /** fetch data from the table: "view_feature_subscription_device" */
  view_feature_subscription_device: Array<View_Feature_Subscription_Device>;
  /** fetch data from the table in a streaming manner: "view_feature_subscription_device" */
  view_feature_subscription_device_stream: Array<View_Feature_Subscription_Device>;
  /** fetch data from the table: "view_feature_subscription_package" */
  view_feature_subscription_package: Array<View_Feature_Subscription_Package>;
  /** fetch data from the table in a streaming manner: "view_feature_subscription_package" */
  view_feature_subscription_package_stream: Array<View_Feature_Subscription_Package>;
  /** fetch data from the table: "view_feature_user_insight" */
  view_feature_user_insight: Array<View_Feature_User_Insight>;
  /** fetch data from the table in a streaming manner: "view_feature_user_insight" */
  view_feature_user_insight_stream: Array<View_Feature_User_Insight>;
  /** fetch data from the table: "view_tag_rule_config" */
  view_tag_rule_config: Array<View_Tag_Rule_Config>;
  /** fetch data from the table in a streaming manner: "view_tag_rule_config" */
  view_tag_rule_config_stream: Array<View_Tag_Rule_Config>;
  /** An array relationship */
  view_user_permissions: Array<View_User_Permissions>;
  /** fetch data from the table in a streaming manner: "view_user_permissions" */
  view_user_permissions_stream: Array<View_User_Permissions>;
  /** An array relationship */
  view_user_residents: Array<View_User_Residents>;
  /** fetch data from the table in a streaming manner: "view_user_residents" */
  view_user_residents_stream: Array<View_User_Residents>;
};


export type Subscription_RootAudit_EventArgs = {
  distinct_on?: InputMaybe<Array<Audit_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Event_Order_By>>;
  where?: InputMaybe<Audit_Event_Bool_Exp>;
};


export type Subscription_RootAudit_Event_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAudit_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audit_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Event_Bool_Exp>;
};


export type Subscription_RootTa_ActivationArgs = {
  distinct_on?: InputMaybe<Array<Ta_Activation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Activation_Order_By>>;
  where?: InputMaybe<Ta_Activation_Bool_Exp>;
};


export type Subscription_RootTa_Activation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Activation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Activation_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Activation_Bool_Exp>;
};


export type Subscription_RootTa_Associated_Escalation_GroupArgs = {
  distinct_on?: InputMaybe<Array<Ta_Associated_Escalation_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Associated_Escalation_Group_Order_By>>;
  where?: InputMaybe<Ta_Associated_Escalation_Group_Bool_Exp>;
};


export type Subscription_RootTa_Associated_Escalation_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Associated_Escalation_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Associated_Escalation_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Associated_Escalation_Group_Bool_Exp>;
};


export type Subscription_RootTa_Associated_SensorArgs = {
  distinct_on?: InputMaybe<Array<Ta_Associated_Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Associated_Sensor_Order_By>>;
  where?: InputMaybe<Ta_Associated_Sensor_Bool_Exp>;
};


export type Subscription_RootTa_Associated_Sensor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Associated_Sensor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Associated_Sensor_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Associated_Sensor_Bool_Exp>;
};


export type Subscription_RootTa_Batch_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Ta_Batch_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Batch_History_Order_By>>;
  where?: InputMaybe<Ta_Batch_History_Bool_Exp>;
};


export type Subscription_RootTa_Batch_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Batch_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Batch_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Batch_History_Bool_Exp>;
};


export type Subscription_RootTa_CitizenArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Bool_Exp>;
};


export type Subscription_RootTa_Citizen_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Citizen_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


export type Subscription_RootTa_Citizen_Device_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


export type Subscription_RootTa_Citizen_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Citizen_Device_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Citizen_Device_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


export type Subscription_RootTa_Citizen_GatewayArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Gateway_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Gateway_Bool_Exp>;
};


export type Subscription_RootTa_Citizen_Gateway_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Citizen_Gateway_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Citizen_Gateway_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Citizen_Gateway_Bool_Exp>;
};


export type Subscription_RootTa_Citizen_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Citizen_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Citizen_Bool_Exp>;
};


export type Subscription_RootTa_Citizen_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_User_Order_By>>;
  where?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
};


export type Subscription_RootTa_Citizen_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Citizen_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Citizen_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
};


export type Subscription_RootTa_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Order_By>>;
  where?: InputMaybe<Ta_Device_Bool_Exp>;
};


export type Subscription_RootTa_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Device_CountArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Count_Order_By>>;
  where?: InputMaybe<Ta_Device_Count_Bool_Exp>;
};


export type Subscription_RootTa_Device_Count_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Device_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Device_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Device_Count_Bool_Exp>;
};


export type Subscription_RootTa_Device_Online_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Online_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Online_History_Order_By>>;
  where?: InputMaybe<Ta_Device_Online_History_Bool_Exp>;
};


export type Subscription_RootTa_Device_Online_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Device_Online_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Device_Online_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Device_Online_History_Bool_Exp>;
};


export type Subscription_RootTa_Device_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Device_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Device_Bool_Exp>;
};


export type Subscription_RootTa_FloorsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Floors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Floors_Order_By>>;
  where?: InputMaybe<Ta_Floors_Bool_Exp>;
};


export type Subscription_RootTa_Floors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Floors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Floors_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Floors_Bool_Exp>;
};


export type Subscription_RootTa_GatewayArgs = {
  distinct_on?: InputMaybe<Array<Ta_Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Gateway_Order_By>>;
  where?: InputMaybe<Ta_Gateway_Bool_Exp>;
};


export type Subscription_RootTa_Gateway_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Gateway_LogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Gateway_Log_Order_By>>;
  where?: InputMaybe<Ta_Gateway_Log_Bool_Exp>;
};


export type Subscription_RootTa_Gateway_Online_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Ta_Gateway_Online_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Gateway_Online_History_Order_By>>;
  where?: InputMaybe<Ta_Gateway_Online_History_Bool_Exp>;
};


export type Subscription_RootTa_Gateway_Online_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Gateway_Online_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Gateway_Online_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Gateway_Online_History_Bool_Exp>;
};


export type Subscription_RootTa_Gateway_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Gateway_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Gateway_Bool_Exp>;
};


export type Subscription_RootTa_MaintenanceArgs = {
  distinct_on?: InputMaybe<Array<Ta_Maintenance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Maintenance_Order_By>>;
  where?: InputMaybe<Ta_Maintenance_Bool_Exp>;
};


export type Subscription_RootTa_Maintenance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Maintenance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Maintenance_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Maintenance_Bool_Exp>;
};


export type Subscription_RootTa_Maintenance_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ta_Maintenance_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Maintenance_Type_Order_By>>;
  where?: InputMaybe<Ta_Maintenance_Type_Bool_Exp>;
};


export type Subscription_RootTa_Maintenance_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTa_Maintenance_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Maintenance_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Maintenance_Type_Bool_Exp>;
};


export type Subscription_RootTa_Mqtt_CommandArgs = {
  distinct_on?: InputMaybe<Array<Ta_Mqtt_Command_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Mqtt_Command_Order_By>>;
  where?: InputMaybe<Ta_Mqtt_Command_Bool_Exp>;
};


export type Subscription_RootTa_Mqtt_Command_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Mqtt_Command_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Mqtt_Command_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Mqtt_Command_Bool_Exp>;
};


export type Subscription_RootTa_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Order_By>>;
  where?: InputMaybe<Ta_Notification_Bool_Exp>;
};


export type Subscription_RootTa_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Order_By>>;
  where?: InputMaybe<Ta_Notification_Bool_Exp>;
};


export type Subscription_RootTa_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Notification_LogArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Log_Order_By>>;
  where?: InputMaybe<Ta_Notification_Log_Bool_Exp>;
};


export type Subscription_RootTa_Notification_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Notification_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Notification_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Notification_Log_Bool_Exp>;
};


export type Subscription_RootTa_Notification_Log_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Log_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Log_Type_Order_By>>;
  where?: InputMaybe<Ta_Notification_Log_Type_Bool_Exp>;
};


export type Subscription_RootTa_Notification_Log_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTa_Notification_Log_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Notification_Log_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Notification_Log_Type_Bool_Exp>;
};


export type Subscription_RootTa_Notification_NotesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Notes_Order_By>>;
  where?: InputMaybe<Ta_Notification_Notes_Bool_Exp>;
};


export type Subscription_RootTa_Notification_Notes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Notification_Notes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Notification_Notes_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Notification_Notes_Bool_Exp>;
};


export type Subscription_RootTa_Notification_ReminderArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Reminder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Reminder_Order_By>>;
  where?: InputMaybe<Ta_Notification_Reminder_Bool_Exp>;
};


export type Subscription_RootTa_Notification_Reminder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Notification_Reminder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Notification_Reminder_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Notification_Reminder_Bool_Exp>;
};


export type Subscription_RootTa_Notification_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Notification_Bool_Exp>;
};


export type Subscription_RootTa_Notification_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Notification_User_Bool_Exp>;
};


export type Subscription_RootTa_Notification_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Notification_User_Bool_Exp>;
};


export type Subscription_RootTa_Notification_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Notification_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Notification_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Notification_User_Bool_Exp>;
};


export type Subscription_RootTa_Operation_ModesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Operation_Modes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Operation_Modes_Order_By>>;
  where?: InputMaybe<Ta_Operation_Modes_Bool_Exp>;
};


export type Subscription_RootTa_Operation_Modes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Operation_Modes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Operation_Modes_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Operation_Modes_Bool_Exp>;
};


export type Subscription_RootTa_OrganisationArgs = {
  distinct_on?: InputMaybe<Array<Ta_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Organisation_Order_By>>;
  where?: InputMaybe<Ta_Organisation_Bool_Exp>;
};


export type Subscription_RootTa_Organisation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Organisation_StatusArgs = {
  distinct_on?: InputMaybe<Array<Ta_Organisation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Organisation_Status_Order_By>>;
  where?: InputMaybe<Ta_Organisation_Status_Bool_Exp>;
};


export type Subscription_RootTa_Organisation_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTa_Organisation_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Organisation_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Organisation_Status_Bool_Exp>;
};


export type Subscription_RootTa_Organisation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Organisation_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Organisation_Bool_Exp>;
};


export type Subscription_RootTa_PackageArgs = {
  distinct_on?: InputMaybe<Array<Ta_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Package_Order_By>>;
  where?: InputMaybe<Ta_Package_Bool_Exp>;
};


export type Subscription_RootTa_Package_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Package_CountArgs = {
  distinct_on?: InputMaybe<Array<Ta_Package_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Package_Count_Order_By>>;
  where?: InputMaybe<Ta_Package_Count_Bool_Exp>;
};


export type Subscription_RootTa_Package_Count_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Package_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Package_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Package_Count_Bool_Exp>;
};


export type Subscription_RootTa_Package_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Package_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Package_Overrides_Order_By>>;
  where?: InputMaybe<Ta_Package_Overrides_Bool_Exp>;
};


export type Subscription_RootTa_Package_Overrides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Package_Overrides_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Package_Overrides_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Package_Overrides_Bool_Exp>;
};


export type Subscription_RootTa_Package_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Package_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Package_Bool_Exp>;
};


export type Subscription_RootTa_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Ta_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Permission_Order_By>>;
  where?: InputMaybe<Ta_Permission_Bool_Exp>;
};


export type Subscription_RootTa_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Permission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Permission_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Permission_Bool_Exp>;
};


export type Subscription_RootTa_Permission_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ta_Permission_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Permission_Type_Order_By>>;
  where?: InputMaybe<Ta_Permission_Type_Bool_Exp>;
};


export type Subscription_RootTa_Permission_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTa_Permission_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Permission_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Permission_Type_Bool_Exp>;
};


export type Subscription_RootTa_Personal_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Ta_Personal_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Personal_Device_Order_By>>;
  where?: InputMaybe<Ta_Personal_Device_Bool_Exp>;
};


export type Subscription_RootTa_Personal_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Personal_Device_LogArgs = {
  distinct_on?: InputMaybe<Array<Ta_Personal_Device_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Personal_Device_Log_Order_By>>;
  where?: InputMaybe<Ta_Personal_Device_Log_Bool_Exp>;
};


export type Subscription_RootTa_Personal_Device_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Personal_Device_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Personal_Device_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Personal_Device_Log_Bool_Exp>;
};


export type Subscription_RootTa_Personal_Device_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Personal_Device_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Personal_Device_Bool_Exp>;
};


export type Subscription_RootTa_Relationship_To_TagArgs = {
  distinct_on?: InputMaybe<Array<Ta_Relationship_To_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Relationship_To_Tag_Order_By>>;
  where?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
};


export type Subscription_RootTa_Relationship_To_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Relationship_To_Tag_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Relationship_To_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
};


export type Subscription_RootTa_Rule_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Ta_Rule_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Rule_Notification_Order_By>>;
  where?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
};


export type Subscription_RootTa_Rule_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Rule_Notification_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Rule_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
};


export type Subscription_RootTa_Rule_Notification_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_Rule_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Rule_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Rule_Notification_User_Bool_Exp>;
};


export type Subscription_RootTa_Rule_Notification_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Rule_Notification_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Rule_Notification_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Rule_Notification_User_Bool_Exp>;
};


export type Subscription_RootTa_Scenario_CountArgs = {
  distinct_on?: InputMaybe<Array<Ta_Scenario_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Scenario_Count_Order_By>>;
  where?: InputMaybe<Ta_Scenario_Count_Bool_Exp>;
};


export type Subscription_RootTa_Scenario_Count_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Scenario_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Scenario_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Scenario_Count_Bool_Exp>;
};


export type Subscription_RootTa_SensorArgs = {
  distinct_on?: InputMaybe<Array<Ta_Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Sensor_Order_By>>;
  where?: InputMaybe<Ta_Sensor_Bool_Exp>;
};


export type Subscription_RootTa_Sensor_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Sensor_MeasurementArgs = {
  distinct_on?: InputMaybe<Array<Ta_Sensor_Measurement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Sensor_Measurement_Order_By>>;
  where?: InputMaybe<Ta_Sensor_Measurement_Bool_Exp>;
};


export type Subscription_RootTa_Sensor_Measurement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Sensor_Measurement_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Sensor_Measurement_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Sensor_Measurement_Bool_Exp>;
};


export type Subscription_RootTa_Sensor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Sensor_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Sensor_Bool_Exp>;
};


export type Subscription_RootTa_Sms_LogArgs = {
  distinct_on?: InputMaybe<Array<Ta_Sms_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Sms_Log_Order_By>>;
  where?: InputMaybe<Ta_Sms_Log_Bool_Exp>;
};


export type Subscription_RootTa_Sms_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Sms_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Sms_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Sms_Log_Bool_Exp>;
};


export type Subscription_RootTa_SupplierArgs = {
  distinct_on?: InputMaybe<Array<Ta_Supplier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Supplier_Order_By>>;
  where?: InputMaybe<Ta_Supplier_Bool_Exp>;
};


export type Subscription_RootTa_Supplier_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Supplier_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Supplier_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Supplier_Bool_Exp>;
};


export type Subscription_RootTa_Supplier_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_Supplier_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Supplier_User_Order_By>>;
  where?: InputMaybe<Ta_Supplier_User_Bool_Exp>;
};


export type Subscription_RootTa_Supplier_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Supplier_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Supplier_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Supplier_User_Bool_Exp>;
};


export type Subscription_RootTa_TagArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Order_By>>;
  where?: InputMaybe<Ta_Tag_Bool_Exp>;
};


export type Subscription_RootTa_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Tag_PackageArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Package_Order_By>>;
  where?: InputMaybe<Ta_Tag_Package_Bool_Exp>;
};


export type Subscription_RootTa_Tag_Package_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Tag_Package_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Tag_Package_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Tag_Package_Bool_Exp>;
};


export type Subscription_RootTa_Tag_Rule_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Rule_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Rule_Notification_Order_By>>;
  where?: InputMaybe<Ta_Tag_Rule_Notification_Bool_Exp>;
};


export type Subscription_RootTa_Tag_Rule_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Tag_Rule_Notification_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Tag_Rule_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Tag_Rule_Notification_Bool_Exp>;
};


export type Subscription_RootTa_Tag_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Tag_Bool_Exp>;
};


export type Subscription_RootTa_TrackerArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Bool_Exp>;
};


export type Subscription_RootTa_Tracker_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Tracker_LogArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Log_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Log_Bool_Exp>;
};


export type Subscription_RootTa_Tracker_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Tracker_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Tracker_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Tracker_Log_Bool_Exp>;
};


export type Subscription_RootTa_Tracker_MeasurementArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Measurement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Measurement_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
};


export type Subscription_RootTa_Tracker_Measurement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Measurement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Measurement_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
};


export type Subscription_RootTa_Tracker_Measurement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Tracker_Measurement_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Tracker_Measurement_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
};


export type Subscription_RootTa_Tracker_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Tracker_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Tracker_Bool_Exp>;
};


export type Subscription_RootTa_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Order_By>>;
  where?: InputMaybe<Ta_User_Bool_Exp>;
};


export type Subscription_RootTa_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_User_Device_TokensArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Device_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Device_Tokens_Order_By>>;
  where?: InputMaybe<Ta_User_Device_Tokens_Bool_Exp>;
};


export type Subscription_RootTa_User_Device_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_User_Device_Tokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_User_Device_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_User_Device_Tokens_Bool_Exp>;
};


export type Subscription_RootTa_User_InsightArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Insight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Insight_Order_By>>;
  where?: InputMaybe<Ta_User_Insight_Bool_Exp>;
};


export type Subscription_RootTa_User_Insight_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_User_Insight_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_User_Insight_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_User_Insight_Bool_Exp>;
};


export type Subscription_RootTa_User_Insight_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Insight_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Insight_Type_Order_By>>;
  where?: InputMaybe<Ta_User_Insight_Type_Bool_Exp>;
};


export type Subscription_RootTa_User_Insight_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTa_User_Insight_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_User_Insight_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_User_Insight_Type_Bool_Exp>;
};


export type Subscription_RootTa_User_OrganisationArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


export type Subscription_RootTa_User_Organisation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_User_Organisation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_User_Organisation_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


export type Subscription_RootTa_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_User_Bool_Exp>;
};


export type Subscription_RootTa_UsergroupArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_Bool_Exp>;
};


export type Subscription_RootTa_Usergroup_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Usergroup_CitizenArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_Citizen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_Citizen_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
};


export type Subscription_RootTa_Usergroup_Citizen_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Usergroup_Citizen_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Usergroup_Citizen_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
};


export type Subscription_RootTa_Usergroup_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Usergroup_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Usergroup_Bool_Exp>;
};


export type Subscription_RootTa_Usergroup_UserArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_User_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_User_Bool_Exp>;
};


export type Subscription_RootTa_Usergroup_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Usergroup_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Usergroup_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Usergroup_User_Bool_Exp>;
};


export type Subscription_RootTa_ZoneArgs = {
  distinct_on?: InputMaybe<Array<Ta_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Zone_Order_By>>;
  where?: InputMaybe<Ta_Zone_Bool_Exp>;
};


export type Subscription_RootTa_Zone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTa_Zone_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ta_Zone_Stream_Cursor_Input>>;
  where?: InputMaybe<Ta_Zone_Bool_Exp>;
};


export type Subscription_RootView_Default_ScenariosArgs = {
  distinct_on?: InputMaybe<Array<View_Default_Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Default_Scenarios_Order_By>>;
  where?: InputMaybe<View_Default_Scenarios_Bool_Exp>;
};


export type Subscription_RootView_Default_Scenarios_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<View_Default_Scenarios_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Default_Scenarios_Bool_Exp>;
};


export type Subscription_RootView_Feature_Subscription_DeviceArgs = {
  distinct_on?: InputMaybe<Array<View_Feature_Subscription_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Feature_Subscription_Device_Order_By>>;
  where?: InputMaybe<View_Feature_Subscription_Device_Bool_Exp>;
};


export type Subscription_RootView_Feature_Subscription_Device_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<View_Feature_Subscription_Device_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Feature_Subscription_Device_Bool_Exp>;
};


export type Subscription_RootView_Feature_Subscription_PackageArgs = {
  distinct_on?: InputMaybe<Array<View_Feature_Subscription_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Feature_Subscription_Package_Order_By>>;
  where?: InputMaybe<View_Feature_Subscription_Package_Bool_Exp>;
};


export type Subscription_RootView_Feature_Subscription_Package_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<View_Feature_Subscription_Package_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Feature_Subscription_Package_Bool_Exp>;
};


export type Subscription_RootView_Feature_User_InsightArgs = {
  distinct_on?: InputMaybe<Array<View_Feature_User_Insight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Feature_User_Insight_Order_By>>;
  where?: InputMaybe<View_Feature_User_Insight_Bool_Exp>;
};


export type Subscription_RootView_Feature_User_Insight_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<View_Feature_User_Insight_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Feature_User_Insight_Bool_Exp>;
};


export type Subscription_RootView_Tag_Rule_ConfigArgs = {
  distinct_on?: InputMaybe<Array<View_Tag_Rule_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Tag_Rule_Config_Order_By>>;
  where?: InputMaybe<View_Tag_Rule_Config_Bool_Exp>;
};


export type Subscription_RootView_Tag_Rule_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<View_Tag_Rule_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Tag_Rule_Config_Bool_Exp>;
};


export type Subscription_RootView_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<View_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Permissions_Order_By>>;
  where?: InputMaybe<View_User_Permissions_Bool_Exp>;
};


export type Subscription_RootView_User_Permissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<View_User_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<View_User_Permissions_Bool_Exp>;
};


export type Subscription_RootView_User_ResidentsArgs = {
  distinct_on?: InputMaybe<Array<View_User_Residents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Residents_Order_By>>;
  where?: InputMaybe<View_User_Residents_Bool_Exp>;
};


export type Subscription_RootView_User_Residents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<View_User_Residents_Stream_Cursor_Input>>;
  where?: InputMaybe<View_User_Residents_Bool_Exp>;
};

/** columns and relationships of "ta_activation" */
export type Ta_Activation = {
  __typename?: 'ta_activation';
  activated_at?: Maybe<Scalars['timestamptz']['output']>;
  activation_code: Scalars['String']['output'];
  citizen_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_citizen?: Maybe<Ta_Citizen>;
  /** An object relationship */
  ta_tracker?: Maybe<Ta_Tracker>;
  tracker_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Boolean expression to filter rows from the table "ta_activation". All fields are combined with a logical 'AND'. */
export type Ta_Activation_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Activation_Bool_Exp>>;
  _not?: InputMaybe<Ta_Activation_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Activation_Bool_Exp>>;
  activated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  activation_code?: InputMaybe<String_Comparison_Exp>;
  citizen_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_citizen?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_tracker?: InputMaybe<Ta_Tracker_Bool_Exp>;
  tracker_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_activation" */
export enum Ta_Activation_Constraint {
  /** unique or primary key constraint on columns "activation_code" */
  TaActivationActivationCodeKey = 'ta_activation_activation_code_key',
  /** unique or primary key constraint on columns "citizen_id" */
  TaActivationCitizenIdKey = 'ta_activation_citizen_id_key',
  /** unique or primary key constraint on columns "id" */
  TaActivationPkey = 'ta_activation_pkey',
  /** unique or primary key constraint on columns "tracker_id" */
  TaActivationTrackerIdKey = 'ta_activation_tracker_id_key'
}

/** input type for inserting data into table "ta_activation" */
export type Ta_Activation_Insert_Input = {
  activated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  activation_code?: InputMaybe<Scalars['String']['input']>;
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ta_citizen?: InputMaybe<Ta_Citizen_Obj_Rel_Insert_Input>;
  ta_tracker?: InputMaybe<Ta_Tracker_Obj_Rel_Insert_Input>;
  tracker_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "ta_activation" */
export type Ta_Activation_Mutation_Response = {
  __typename?: 'ta_activation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Activation>;
};

/** input type for inserting object relation for remote table "ta_activation" */
export type Ta_Activation_Obj_Rel_Insert_Input = {
  data: Ta_Activation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Activation_On_Conflict>;
};

/** on_conflict condition type for table "ta_activation" */
export type Ta_Activation_On_Conflict = {
  constraint: Ta_Activation_Constraint;
  update_columns?: Array<Ta_Activation_Update_Column>;
  where?: InputMaybe<Ta_Activation_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_activation". */
export type Ta_Activation_Order_By = {
  activated_at?: InputMaybe<Order_By>;
  activation_code?: InputMaybe<Order_By>;
  citizen_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ta_citizen?: InputMaybe<Ta_Citizen_Order_By>;
  ta_tracker?: InputMaybe<Ta_Tracker_Order_By>;
  tracker_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_activation */
export type Ta_Activation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_activation" */
export enum Ta_Activation_Select_Column {
  /** column name */
  ActivatedAt = 'activated_at',
  /** column name */
  ActivationCode = 'activation_code',
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TrackerId = 'tracker_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ta_activation" */
export type Ta_Activation_Set_Input = {
  activated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  activation_code?: InputMaybe<Scalars['String']['input']>;
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  tracker_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "ta_activation" */
export type Ta_Activation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Activation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Activation_Stream_Cursor_Value_Input = {
  activated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  activation_code?: InputMaybe<Scalars['String']['input']>;
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tracker_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "ta_activation" */
export enum Ta_Activation_Update_Column {
  /** column name */
  ActivatedAt = 'activated_at',
  /** column name */
  ActivationCode = 'activation_code',
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  TrackerId = 'tracker_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ta_Activation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Activation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Activation_Bool_Exp;
};

/** columns and relationships of "ta_associated_escalation_group" */
export type Ta_Associated_Escalation_Group = {
  __typename?: 'ta_associated_escalation_group';
  associated_group_id: Scalars['uuid']['output'];
  /** An object relationship */
  associated_usergroup?: Maybe<Ta_Usergroup>;
  config?: Maybe<Scalars['AssociatedEscalationGroupConfig']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_usergroup: Ta_Usergroup;
  /** An object relationship */
  ta_usergroup_users?: Maybe<Ta_Usergroup_User>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "ta_associated_escalation_group" */
export type Ta_Associated_Escalation_Group_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Associated_Escalation_Group_Max_Order_By>;
  min?: InputMaybe<Ta_Associated_Escalation_Group_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ta_Associated_Escalation_Group_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "ta_associated_escalation_group" */
export type Ta_Associated_Escalation_Group_Arr_Rel_Insert_Input = {
  data: Array<Ta_Associated_Escalation_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Associated_Escalation_Group_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_associated_escalation_group". All fields are combined with a logical 'AND'. */
export type Ta_Associated_Escalation_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Associated_Escalation_Group_Bool_Exp>>;
  _not?: InputMaybe<Ta_Associated_Escalation_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Associated_Escalation_Group_Bool_Exp>>;
  associated_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  associated_usergroup?: InputMaybe<Ta_Usergroup_Bool_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  group_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Bool_Exp>;
  ta_usergroup_users?: InputMaybe<Ta_Usergroup_User_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_associated_escalation_group" */
export enum Ta_Associated_Escalation_Group_Constraint {
  /** unique or primary key constraint on columns "associated_group_id", "group_id" */
  TaAssociatedEscalationGroupGroupIdAssociatedGroupIdKey = 'ta_associated_escalation_group_group_id_associated_group_id_key',
  /** unique or primary key constraint on columns "id" */
  TaAssociatedEscalationGroupPkey = 'ta_associated_escalation_group_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ta_Associated_Escalation_Group_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ta_Associated_Escalation_Group_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ta_Associated_Escalation_Group_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "ta_associated_escalation_group" */
export type Ta_Associated_Escalation_Group_Insert_Input = {
  associated_group_id?: InputMaybe<Scalars['uuid']['input']>;
  associated_usergroup?: InputMaybe<Ta_Usergroup_Obj_Rel_Insert_Input>;
  config?: InputMaybe<Scalars['jsonb']['input']>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Obj_Rel_Insert_Input>;
  ta_usergroup_users?: InputMaybe<Ta_Usergroup_User_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "ta_associated_escalation_group" */
export type Ta_Associated_Escalation_Group_Max_Order_By = {
  associated_group_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_associated_escalation_group" */
export type Ta_Associated_Escalation_Group_Min_Order_By = {
  associated_group_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_associated_escalation_group" */
export type Ta_Associated_Escalation_Group_Mutation_Response = {
  __typename?: 'ta_associated_escalation_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Associated_Escalation_Group>;
};

/** on_conflict condition type for table "ta_associated_escalation_group" */
export type Ta_Associated_Escalation_Group_On_Conflict = {
  constraint: Ta_Associated_Escalation_Group_Constraint;
  update_columns?: Array<Ta_Associated_Escalation_Group_Update_Column>;
  where?: InputMaybe<Ta_Associated_Escalation_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_associated_escalation_group". */
export type Ta_Associated_Escalation_Group_Order_By = {
  associated_group_id?: InputMaybe<Order_By>;
  associated_usergroup?: InputMaybe<Ta_Usergroup_Order_By>;
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Order_By>;
  ta_usergroup_users?: InputMaybe<Ta_Usergroup_User_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_associated_escalation_group */
export type Ta_Associated_Escalation_Group_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ta_Associated_Escalation_Group_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ta_associated_escalation_group" */
export enum Ta_Associated_Escalation_Group_Select_Column {
  /** column name */
  AssociatedGroupId = 'associated_group_id',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ta_associated_escalation_group" */
export type Ta_Associated_Escalation_Group_Set_Input = {
  __typename?: 'ta_associated_escalation_group_set_input';
  associated_group_id?: Maybe<Scalars['uuid']['output']>;
  config?: Maybe<Scalars['AssociatedEscalationGroupConfig']['output']>;
  group_id?: Maybe<Scalars['uuid']['output']>;
};

/** Streaming cursor of the table "ta_associated_escalation_group" */
export type Ta_Associated_Escalation_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Associated_Escalation_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Associated_Escalation_Group_Stream_Cursor_Value_Input = {
  associated_group_id?: InputMaybe<Scalars['uuid']['input']>;
  config?: InputMaybe<Scalars['AssociatedEscalationGroupConfig']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "ta_associated_escalation_group" */
export enum Ta_Associated_Escalation_Group_Update_Column {
  /** column name */
  AssociatedGroupId = 'associated_group_id',
  /** column name */
  Config = 'config',
  /** column name */
  GroupId = 'group_id'
}

export type Ta_Associated_Escalation_Group_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ta_Associated_Escalation_Group_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ta_Associated_Escalation_Group_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ta_Associated_Escalation_Group_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ta_Associated_Escalation_Group_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ta_Associated_Escalation_Group_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Associated_Escalation_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Associated_Escalation_Group_Bool_Exp;
};

/** columns and relationships of "ta_associated_sensor" */
export type Ta_Associated_Sensor = {
  __typename?: 'ta_associated_sensor';
  id: Scalars['uuid']['output'];
  rule_notification_id: Scalars['uuid']['output'];
  sensor_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_rule_notification: Ta_Rule_Notification;
  /** An object relationship */
  ta_sensor: Ta_Sensor;
};

/** order by aggregate values of table "ta_associated_sensor" */
export type Ta_Associated_Sensor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Associated_Sensor_Max_Order_By>;
  min?: InputMaybe<Ta_Associated_Sensor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ta_associated_sensor" */
export type Ta_Associated_Sensor_Arr_Rel_Insert_Input = {
  data: Array<Ta_Associated_Sensor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Associated_Sensor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_associated_sensor". All fields are combined with a logical 'AND'. */
export type Ta_Associated_Sensor_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Associated_Sensor_Bool_Exp>>;
  _not?: InputMaybe<Ta_Associated_Sensor_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Associated_Sensor_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rule_notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_rule_notification?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
  ta_sensor?: InputMaybe<Ta_Sensor_Bool_Exp>;
};

/** unique or primary key constraints on table "ta_associated_sensor" */
export enum Ta_Associated_Sensor_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaAssociatedSensorPkey = 'ta_associated_sensor_pkey',
  /** unique or primary key constraint on columns "rule_notification_id", "sensor_id" */
  TaAssociatedSensorRuleNotificationIdSensorIdKey = 'ta_associated_sensor_rule_notification_id_sensor_id_key'
}

/** input type for inserting data into table "ta_associated_sensor" */
export type Ta_Associated_Sensor_Insert_Input = {
  rule_notification_id?: InputMaybe<Scalars['uuid']['input']>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_rule_notification?: InputMaybe<Ta_Rule_Notification_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "ta_associated_sensor" */
export type Ta_Associated_Sensor_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  rule_notification_id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_associated_sensor" */
export type Ta_Associated_Sensor_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  rule_notification_id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_associated_sensor" */
export type Ta_Associated_Sensor_Mutation_Response = {
  __typename?: 'ta_associated_sensor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Associated_Sensor>;
};

/** on_conflict condition type for table "ta_associated_sensor" */
export type Ta_Associated_Sensor_On_Conflict = {
  constraint: Ta_Associated_Sensor_Constraint;
  update_columns?: Array<Ta_Associated_Sensor_Update_Column>;
  where?: InputMaybe<Ta_Associated_Sensor_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_associated_sensor". */
export type Ta_Associated_Sensor_Order_By = {
  id?: InputMaybe<Order_By>;
  rule_notification_id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  ta_rule_notification?: InputMaybe<Ta_Rule_Notification_Order_By>;
  ta_sensor?: InputMaybe<Ta_Sensor_Order_By>;
};

/** primary key columns input for table: ta_associated_sensor */
export type Ta_Associated_Sensor_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_associated_sensor" */
export enum Ta_Associated_Sensor_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RuleNotificationId = 'rule_notification_id',
  /** column name */
  SensorId = 'sensor_id'
}

/** input type for updating data in table "ta_associated_sensor" */
export type Ta_Associated_Sensor_Set_Input = {
  rule_notification_id?: InputMaybe<Scalars['uuid']['input']>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "ta_associated_sensor" */
export type Ta_Associated_Sensor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Associated_Sensor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Associated_Sensor_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  rule_notification_id?: InputMaybe<Scalars['uuid']['input']>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "ta_associated_sensor" */
export enum Ta_Associated_Sensor_Update_Column {
  /** column name */
  RuleNotificationId = 'rule_notification_id',
  /** column name */
  SensorId = 'sensor_id'
}

export type Ta_Associated_Sensor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Associated_Sensor_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Associated_Sensor_Bool_Exp;
};

/** columns and relationships of "ta_batch_history" */
export type Ta_Batch_History = {
  __typename?: 'ta_batch_history';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  job: Scalars['String']['output'];
  organisation_id: Scalars['uuid']['output'];
  status?: Maybe<Scalars['BatchJobStatus']['output']>;
  success: Scalars['Boolean']['output'];
  /** An object relationship */
  ta_organisation: Ta_Organisation;
};

/** order by aggregate values of table "ta_batch_history" */
export type Ta_Batch_History_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Batch_History_Max_Order_By>;
  min?: InputMaybe<Ta_Batch_History_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_batch_history". All fields are combined with a logical 'AND'. */
export type Ta_Batch_History_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Batch_History_Bool_Exp>>;
  _not?: InputMaybe<Ta_Batch_History_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Batch_History_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Jsonb_Comparison_Exp>;
  success?: InputMaybe<Boolean_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
};

/** order by max() on columns of table "ta_batch_history" */
export type Ta_Batch_History_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_batch_history" */
export type Ta_Batch_History_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_batch_history". */
export type Ta_Batch_History_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  success?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
};

/** select columns of table "ta_batch_history" */
export enum Ta_Batch_History_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Job = 'job',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Status = 'status',
  /** column name */
  Success = 'success'
}

export type Ta_Batch_History_Set_Input = {
  __typename?: 'ta_batch_history_set_input';
  status?: Maybe<Scalars['BatchJobStatus']['output']>;
};

/** Streaming cursor of the table "ta_batch_history" */
export type Ta_Batch_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Batch_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Batch_History_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['BatchJobStatus']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "ta_citizen" */
export type Ta_Citizen = {
  __typename?: 'ta_citizen';
  activated: Scalars['Boolean']['output'];
  activation_code?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  citizen_address?: Maybe<Scalars['String']['output']>;
  citizen_group?: Maybe<Scalars['String']['output']>;
  citizen_gw_online?: Maybe<Scalars['Boolean']['output']>;
  citizen_gw_serial?: Maybe<Scalars['String']['output']>;
  citizen_image_file?: Maybe<Scalars['String']['output']>;
  citizen_name: Scalars['String']['output'];
  citizen_user_role?: Maybe<Scalars['UserResidentRelationshipType']['output']>;
  id: Scalars['uuid']['output'];
  is_common_area: Scalars['Boolean']['output'];
  measure_view?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  ta_activation?: Maybe<Ta_Activation>;
  /** An array relationship */
  ta_citizen_devices: Array<Ta_Citizen_Device>;
  /** An aggregate relationship */
  ta_citizen_devices_aggregate: Ta_Citizen_Device_Aggregate;
  /** An array relationship */
  ta_citizen_gateways: Array<Ta_Citizen_Gateway>;
  /** An array relationship */
  ta_citizen_users: Array<Ta_Citizen_User>;
  /** An array relationship */
  ta_notifications: Array<Ta_Notification>;
  /** An aggregate relationship */
  ta_notifications_aggregate: Ta_Notification_Aggregate;
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  /** An array relationship */
  ta_organisation_users: Array<Ta_User_Organisation>;
  /** An array relationship */
  ta_relationship_to_tags: Array<Ta_Relationship_To_Tag>;
  /** An array relationship */
  ta_trackers: Array<Ta_Tracker>;
  /** An object relationship */
  ta_user?: Maybe<Ta_User>;
  /** An array relationship */
  ta_user_organisations: Array<Ta_User_Organisation>;
  /** An array relationship */
  ta_usergroup_citizens: Array<Ta_Usergroup_Citizen>;
  /** An object relationship */
  ta_zone?: Maybe<Ta_Zone>;
  updated_at: Scalars['timestamp']['output'];
  updated_by_userid?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  view_user_residents: Array<View_User_Residents>;
  zone_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenTa_Citizen_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenTa_Citizen_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenTa_Citizen_GatewaysArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Gateway_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Gateway_Bool_Exp>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenTa_Citizen_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_User_Order_By>>;
  where?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenTa_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Order_By>>;
  where?: InputMaybe<Ta_Notification_Bool_Exp>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenTa_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Order_By>>;
  where?: InputMaybe<Ta_Notification_Bool_Exp>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenTa_Organisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenTa_Relationship_To_TagsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Relationship_To_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Relationship_To_Tag_Order_By>>;
  where?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenTa_TrackersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Bool_Exp>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenTa_User_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenTa_Usergroup_CitizensArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_Citizen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_Citizen_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
};


/** columns and relationships of "ta_citizen" */
export type Ta_CitizenView_User_ResidentsArgs = {
  distinct_on?: InputMaybe<Array<View_User_Residents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Residents_Order_By>>;
  where?: InputMaybe<View_User_Residents_Bool_Exp>;
};

/** order by aggregate values of table "ta_citizen" */
export type Ta_Citizen_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Citizen_Max_Order_By>;
  min?: InputMaybe<Ta_Citizen_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_citizen". All fields are combined with a logical 'AND'. */
export type Ta_Citizen_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Citizen_Bool_Exp>>;
  _not?: InputMaybe<Ta_Citizen_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Citizen_Bool_Exp>>;
  activated?: InputMaybe<Boolean_Comparison_Exp>;
  activation_code?: InputMaybe<String_Comparison_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  citizen_address?: InputMaybe<String_Comparison_Exp>;
  citizen_group?: InputMaybe<String_Comparison_Exp>;
  citizen_gw_online?: InputMaybe<Boolean_Comparison_Exp>;
  citizen_gw_serial?: InputMaybe<String_Comparison_Exp>;
  citizen_image_file?: InputMaybe<String_Comparison_Exp>;
  citizen_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_common_area?: InputMaybe<Boolean_Comparison_Exp>;
  measure_view?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_activation?: InputMaybe<Ta_Activation_Bool_Exp>;
  ta_citizen_devices?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
  ta_citizen_devices_aggregate?: InputMaybe<Ta_Citizen_Device_Aggregate_Bool_Exp>;
  ta_citizen_gateways?: InputMaybe<Ta_Citizen_Gateway_Bool_Exp>;
  ta_citizen_users?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
  ta_notifications?: InputMaybe<Ta_Notification_Bool_Exp>;
  ta_notifications_aggregate?: InputMaybe<Ta_Notification_Aggregate_Bool_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  ta_relationship_to_tags?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
  ta_trackers?: InputMaybe<Ta_Tracker_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  ta_user_organisations?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  ta_usergroup_citizens?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
  ta_zone?: InputMaybe<Ta_Zone_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by_userid?: InputMaybe<Uuid_Comparison_Exp>;
  view_user_residents?: InputMaybe<View_User_Residents_Bool_Exp>;
  zone_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_citizen" */
export enum Ta_Citizen_Constraint {
  /** unique or primary key constraint on columns "activation_code" */
  TaCitizenActivationCodeKey = 'ta_citizen_activation_code_key',
  /** unique or primary key constraint on columns "id" */
  TaCitizenPkey = 'ta_citizen_pkey',
  /** unique or primary key constraint on columns "zone_id" */
  TaCitizenZoneIdKey = 'ta_citizen_zone_id_key'
}

/** columns and relationships of "ta_citizen_device" */
export type Ta_Citizen_Device = {
  __typename?: 'ta_citizen_device';
  citizen_id: Scalars['uuid']['output'];
  device_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_citizen: Ta_Citizen;
  /** An array relationship */
  ta_citizen_users: Array<Ta_Citizen_User>;
  /** An object relationship */
  ta_device: Ta_Device;
  /** An array relationship */
  ta_usergroup_citizen: Array<Ta_Usergroup_Citizen>;
  /** An object relationship */
  ta_usergroup_citizens?: Maybe<Ta_Usergroup_Citizen>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "ta_citizen_device" */
export type Ta_Citizen_DeviceTa_Citizen_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_User_Order_By>>;
  where?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
};


/** columns and relationships of "ta_citizen_device" */
export type Ta_Citizen_DeviceTa_Usergroup_CitizenArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_Citizen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_Citizen_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
};

/** aggregated selection of "ta_citizen_device" */
export type Ta_Citizen_Device_Aggregate = {
  __typename?: 'ta_citizen_device_aggregate';
  aggregate?: Maybe<Ta_Citizen_Device_Aggregate_Fields>;
  nodes: Array<Ta_Citizen_Device>;
};

export type Ta_Citizen_Device_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ta_Citizen_Device_Aggregate_Bool_Exp_Count>;
};

export type Ta_Citizen_Device_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ta_citizen_device" */
export type Ta_Citizen_Device_Aggregate_Fields = {
  __typename?: 'ta_citizen_device_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ta_Citizen_Device_Max_Fields>;
  min?: Maybe<Ta_Citizen_Device_Min_Fields>;
};


/** aggregate fields of "ta_citizen_device" */
export type Ta_Citizen_Device_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ta_citizen_device" */
export type Ta_Citizen_Device_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Citizen_Device_Max_Order_By>;
  min?: InputMaybe<Ta_Citizen_Device_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ta_citizen_device" */
export type Ta_Citizen_Device_Arr_Rel_Insert_Input = {
  data: Array<Ta_Citizen_Device_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Citizen_Device_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_citizen_device". All fields are combined with a logical 'AND'. */
export type Ta_Citizen_Device_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Citizen_Device_Bool_Exp>>;
  _not?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Citizen_Device_Bool_Exp>>;
  citizen_id?: InputMaybe<Uuid_Comparison_Exp>;
  device_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_citizen?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_citizen_users?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
  ta_device?: InputMaybe<Ta_Device_Bool_Exp>;
  ta_usergroup_citizen?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
  ta_usergroup_citizens?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_citizen_device" */
export enum Ta_Citizen_Device_Constraint {
  /** unique or primary key constraint on columns "citizen_id", "device_id" */
  TaCitizenDeviceCitizenIdDeviceIdKey = 'ta_citizen_device_citizen_id_device_id_key',
  /** unique or primary key constraint on columns "device_id" */
  TaCitizenDeviceDeviceIdKey = 'ta_citizen_device_device_id_key',
  /** unique or primary key constraint on columns "id" */
  TaCitizenDevicePkey = 'ta_citizen_device_pkey'
}

/** input type for inserting data into table "ta_citizen_device" */
export type Ta_Citizen_Device_Insert_Input = {
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_citizen?: InputMaybe<Ta_Citizen_Obj_Rel_Insert_Input>;
  ta_citizen_users?: InputMaybe<Ta_Citizen_User_Arr_Rel_Insert_Input>;
  ta_device?: InputMaybe<Ta_Device_Obj_Rel_Insert_Input>;
  ta_usergroup_citizen?: InputMaybe<Ta_Usergroup_Citizen_Arr_Rel_Insert_Input>;
  ta_usergroup_citizens?: InputMaybe<Ta_Usergroup_Citizen_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ta_Citizen_Device_Max_Fields = {
  __typename?: 'ta_citizen_device_max_fields';
  citizen_id?: Maybe<Scalars['uuid']['output']>;
  device_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "ta_citizen_device" */
export type Ta_Citizen_Device_Max_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ta_Citizen_Device_Min_Fields = {
  __typename?: 'ta_citizen_device_min_fields';
  citizen_id?: Maybe<Scalars['uuid']['output']>;
  device_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "ta_citizen_device" */
export type Ta_Citizen_Device_Min_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_citizen_device" */
export type Ta_Citizen_Device_Mutation_Response = {
  __typename?: 'ta_citizen_device_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Citizen_Device>;
};

/** on_conflict condition type for table "ta_citizen_device" */
export type Ta_Citizen_Device_On_Conflict = {
  constraint: Ta_Citizen_Device_Constraint;
  update_columns?: Array<Ta_Citizen_Device_Update_Column>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_citizen_device". */
export type Ta_Citizen_Device_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ta_citizen?: InputMaybe<Ta_Citizen_Order_By>;
  ta_citizen_users_aggregate?: InputMaybe<Ta_Citizen_User_Aggregate_Order_By>;
  ta_device?: InputMaybe<Ta_Device_Order_By>;
  ta_usergroup_citizen_aggregate?: InputMaybe<Ta_Usergroup_Citizen_Aggregate_Order_By>;
  ta_usergroup_citizens?: InputMaybe<Ta_Usergroup_Citizen_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_citizen_device */
export type Ta_Citizen_Device_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_citizen_device" */
export enum Ta_Citizen_Device_Select_Column {
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ta_citizen_device" */
export type Ta_Citizen_Device_Set_Input = {
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "ta_citizen_device" */
export type Ta_Citizen_Device_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Citizen_Device_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Citizen_Device_Stream_Cursor_Value_Input = {
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "ta_citizen_device" */
export enum Ta_Citizen_Device_Update_Column {
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  DeviceId = 'device_id'
}

export type Ta_Citizen_Device_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Citizen_Device_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Citizen_Device_Bool_Exp;
};

/** columns and relationships of "ta_citizen_gateway" */
export type Ta_Citizen_Gateway = {
  __typename?: 'ta_citizen_gateway';
  archived: Scalars['Boolean']['output'];
  citizen_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  gateway_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_citizen: Ta_Citizen;
  /** An array relationship */
  ta_citizen_users: Array<Ta_Citizen_User>;
  /** An object relationship */
  ta_gateway: Ta_Gateway;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  view_user_residents: Array<View_User_Residents>;
};


/** columns and relationships of "ta_citizen_gateway" */
export type Ta_Citizen_GatewayTa_Citizen_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_User_Order_By>>;
  where?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
};


/** columns and relationships of "ta_citizen_gateway" */
export type Ta_Citizen_GatewayView_User_ResidentsArgs = {
  distinct_on?: InputMaybe<Array<View_User_Residents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Residents_Order_By>>;
  where?: InputMaybe<View_User_Residents_Bool_Exp>;
};

/** order by aggregate values of table "ta_citizen_gateway" */
export type Ta_Citizen_Gateway_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Citizen_Gateway_Max_Order_By>;
  min?: InputMaybe<Ta_Citizen_Gateway_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ta_citizen_gateway" */
export type Ta_Citizen_Gateway_Arr_Rel_Insert_Input = {
  data: Array<Ta_Citizen_Gateway_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Citizen_Gateway_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_citizen_gateway". All fields are combined with a logical 'AND'. */
export type Ta_Citizen_Gateway_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Citizen_Gateway_Bool_Exp>>;
  _not?: InputMaybe<Ta_Citizen_Gateway_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Citizen_Gateway_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  citizen_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gateway_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_citizen?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_citizen_users?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
  ta_gateway?: InputMaybe<Ta_Gateway_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  view_user_residents?: InputMaybe<View_User_Residents_Bool_Exp>;
};

/** unique or primary key constraints on table "ta_citizen_gateway" */
export enum Ta_Citizen_Gateway_Constraint {
  /** unique or primary key constraint on columns "gateway_id", "citizen_id" */
  TaCitizenGatewayCitizenIdGatewayIdKey = 'ta_citizen_gateway_citizen_id_gateway_id_key',
  /** unique or primary key constraint on columns "id" */
  TaCitizenGatewayPkey = 'ta_citizen_gateway_pkey'
}

/** input type for inserting data into table "ta_citizen_gateway" */
export type Ta_Citizen_Gateway_Insert_Input = {
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  gateway_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_citizen?: InputMaybe<Ta_Citizen_Obj_Rel_Insert_Input>;
  ta_citizen_users?: InputMaybe<Ta_Citizen_User_Arr_Rel_Insert_Input>;
  ta_gateway?: InputMaybe<Ta_Gateway_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "ta_citizen_gateway" */
export type Ta_Citizen_Gateway_Max_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_citizen_gateway" */
export type Ta_Citizen_Gateway_Min_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_citizen_gateway" */
export type Ta_Citizen_Gateway_Mutation_Response = {
  __typename?: 'ta_citizen_gateway_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Citizen_Gateway>;
};

/** on_conflict condition type for table "ta_citizen_gateway" */
export type Ta_Citizen_Gateway_On_Conflict = {
  constraint: Ta_Citizen_Gateway_Constraint;
  update_columns?: Array<Ta_Citizen_Gateway_Update_Column>;
  where?: InputMaybe<Ta_Citizen_Gateway_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_citizen_gateway". */
export type Ta_Citizen_Gateway_Order_By = {
  archived?: InputMaybe<Order_By>;
  citizen_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ta_citizen?: InputMaybe<Ta_Citizen_Order_By>;
  ta_citizen_users_aggregate?: InputMaybe<Ta_Citizen_User_Aggregate_Order_By>;
  ta_gateway?: InputMaybe<Ta_Gateway_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  view_user_residents_aggregate?: InputMaybe<View_User_Residents_Aggregate_Order_By>;
};

/** primary key columns input for table: ta_citizen_gateway */
export type Ta_Citizen_Gateway_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_citizen_gateway" */
export enum Ta_Citizen_Gateway_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GatewayId = 'gateway_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ta_citizen_gateway" */
export type Ta_Citizen_Gateway_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  gateway_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "ta_citizen_gateway" */
export type Ta_Citizen_Gateway_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Citizen_Gateway_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Citizen_Gateway_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gateway_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "ta_citizen_gateway" */
export enum Ta_Citizen_Gateway_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  GatewayId = 'gateway_id'
}

export type Ta_Citizen_Gateway_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Citizen_Gateway_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Citizen_Gateway_Bool_Exp;
};

/** input type for inserting data into table "ta_citizen" */
export type Ta_Citizen_Insert_Input = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activation_code?: InputMaybe<Scalars['String']['input']>;
  citizen_address?: InputMaybe<Scalars['String']['input']>;
  citizen_group?: InputMaybe<Scalars['String']['input']>;
  citizen_gw_online?: InputMaybe<Scalars['Boolean']['input']>;
  citizen_gw_serial?: InputMaybe<Scalars['String']['input']>;
  citizen_image_file?: InputMaybe<Scalars['String']['input']>;
  citizen_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_common_area?: InputMaybe<Scalars['Boolean']['input']>;
  measure_view?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_activation?: InputMaybe<Ta_Activation_Obj_Rel_Insert_Input>;
  ta_citizen_devices?: InputMaybe<Ta_Citizen_Device_Arr_Rel_Insert_Input>;
  ta_citizen_gateways?: InputMaybe<Ta_Citizen_Gateway_Arr_Rel_Insert_Input>;
  ta_citizen_users?: InputMaybe<Ta_Citizen_User_Arr_Rel_Insert_Input>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Arr_Rel_Insert_Input>;
  ta_relationship_to_tags?: InputMaybe<Ta_Relationship_To_Tag_Arr_Rel_Insert_Input>;
  ta_trackers?: InputMaybe<Ta_Tracker_Arr_Rel_Insert_Input>;
  ta_user_organisations?: InputMaybe<Ta_User_Organisation_Arr_Rel_Insert_Input>;
  ta_usergroup_citizens?: InputMaybe<Ta_Usergroup_Citizen_Arr_Rel_Insert_Input>;
  ta_zone?: InputMaybe<Ta_Zone_Obj_Rel_Insert_Input>;
  zone_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "ta_citizen" */
export type Ta_Citizen_Max_Order_By = {
  activation_code?: InputMaybe<Order_By>;
  citizen_address?: InputMaybe<Order_By>;
  citizen_group?: InputMaybe<Order_By>;
  citizen_gw_serial?: InputMaybe<Order_By>;
  citizen_image_file?: InputMaybe<Order_By>;
  citizen_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measure_view?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_citizen" */
export type Ta_Citizen_Min_Order_By = {
  activation_code?: InputMaybe<Order_By>;
  citizen_address?: InputMaybe<Order_By>;
  citizen_group?: InputMaybe<Order_By>;
  citizen_gw_serial?: InputMaybe<Order_By>;
  citizen_image_file?: InputMaybe<Order_By>;
  citizen_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measure_view?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_citizen" */
export type Ta_Citizen_Mutation_Response = {
  __typename?: 'ta_citizen_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Citizen>;
};

/** input type for inserting object relation for remote table "ta_citizen" */
export type Ta_Citizen_Obj_Rel_Insert_Input = {
  data: Ta_Citizen_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Citizen_On_Conflict>;
};

/** on_conflict condition type for table "ta_citizen" */
export type Ta_Citizen_On_Conflict = {
  constraint: Ta_Citizen_Constraint;
  update_columns?: Array<Ta_Citizen_Update_Column>;
  where?: InputMaybe<Ta_Citizen_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_citizen". */
export type Ta_Citizen_Order_By = {
  activated?: InputMaybe<Order_By>;
  activation_code?: InputMaybe<Order_By>;
  archived?: InputMaybe<Order_By>;
  citizen_address?: InputMaybe<Order_By>;
  citizen_group?: InputMaybe<Order_By>;
  citizen_gw_online?: InputMaybe<Order_By>;
  citizen_gw_serial?: InputMaybe<Order_By>;
  citizen_image_file?: InputMaybe<Order_By>;
  citizen_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_common_area?: InputMaybe<Order_By>;
  measure_view?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  ta_activation?: InputMaybe<Ta_Activation_Order_By>;
  ta_citizen_devices_aggregate?: InputMaybe<Ta_Citizen_Device_Aggregate_Order_By>;
  ta_citizen_gateways_aggregate?: InputMaybe<Ta_Citizen_Gateway_Aggregate_Order_By>;
  ta_citizen_users_aggregate?: InputMaybe<Ta_Citizen_User_Aggregate_Order_By>;
  ta_notifications_aggregate?: InputMaybe<Ta_Notification_Aggregate_Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_organisation_users_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  ta_relationship_to_tags_aggregate?: InputMaybe<Ta_Relationship_To_Tag_Aggregate_Order_By>;
  ta_trackers_aggregate?: InputMaybe<Ta_Tracker_Aggregate_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  ta_user_organisations_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  ta_usergroup_citizens_aggregate?: InputMaybe<Ta_Usergroup_Citizen_Aggregate_Order_By>;
  ta_zone?: InputMaybe<Ta_Zone_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
  view_user_residents_aggregate?: InputMaybe<View_User_Residents_Aggregate_Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_citizen */
export type Ta_Citizen_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_citizen" */
export enum Ta_Citizen_Select_Column {
  /** column name */
  Activated = 'activated',
  /** column name */
  ActivationCode = 'activation_code',
  /** column name */
  Archived = 'archived',
  /** column name */
  CitizenAddress = 'citizen_address',
  /** column name */
  CitizenGroup = 'citizen_group',
  /** column name */
  CitizenGwOnline = 'citizen_gw_online',
  /** column name */
  CitizenGwSerial = 'citizen_gw_serial',
  /** column name */
  CitizenImageFile = 'citizen_image_file',
  /** column name */
  CitizenName = 'citizen_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsCommonArea = 'is_common_area',
  /** column name */
  MeasureView = 'measure_view',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserid = 'updated_by_userid',
  /** column name */
  ZoneId = 'zone_id'
}

/** input type for updating data in table "ta_citizen" */
export type Ta_Citizen_Set_Input = {
  __typename?: 'ta_citizen_set_input';
  archived?: Maybe<Scalars['Boolean']['output']>;
  citizen_address?: Maybe<Scalars['String']['output']>;
  citizen_name?: Maybe<Scalars['String']['output']>;
  citizen_user_role?: Maybe<Scalars['UserResidentRelationshipType']['output']>;
  is_common_area?: Maybe<Scalars['Boolean']['output']>;
  zone_id?: Maybe<Scalars['uuid']['output']>;
};

/** Streaming cursor of the table "ta_citizen" */
export type Ta_Citizen_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Citizen_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Citizen_Stream_Cursor_Value_Input = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activation_code?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  citizen_address?: InputMaybe<Scalars['String']['input']>;
  citizen_group?: InputMaybe<Scalars['String']['input']>;
  citizen_gw_online?: InputMaybe<Scalars['Boolean']['input']>;
  citizen_gw_serial?: InputMaybe<Scalars['String']['input']>;
  citizen_image_file?: InputMaybe<Scalars['String']['input']>;
  citizen_name?: InputMaybe<Scalars['String']['input']>;
  citizen_user_role?: InputMaybe<Scalars['UserResidentRelationshipType']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_common_area?: InputMaybe<Scalars['Boolean']['input']>;
  measure_view?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by_userid?: InputMaybe<Scalars['uuid']['input']>;
  zone_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "ta_citizen" */
export enum Ta_Citizen_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CitizenAddress = 'citizen_address',
  /** column name */
  CitizenName = 'citizen_name',
  /** column name */
  IsCommonArea = 'is_common_area',
  /** column name */
  ZoneId = 'zone_id'
}

export type Ta_Citizen_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Citizen_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Citizen_Bool_Exp;
};

/** columns and relationships of "ta_citizen_user" */
export type Ta_Citizen_User = {
  __typename?: 'ta_citizen_user';
  archived: Scalars['Boolean']['output'];
  citizen_id: Scalars['uuid']['output'];
  citizen_user_role?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  short_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  taUserByUpdatedByUserid?: Maybe<Ta_User>;
  /** An object relationship */
  ta_citizen: Ta_Citizen;
  /** An object relationship */
  ta_user: Ta_User;
  updated_at: Scalars['timestamp']['output'];
  updated_by_userid?: Maybe<Scalars['uuid']['output']>;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "ta_citizen_user" */
export type Ta_Citizen_User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Citizen_User_Max_Order_By>;
  min?: InputMaybe<Ta_Citizen_User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ta_citizen_user" */
export type Ta_Citizen_User_Arr_Rel_Insert_Input = {
  data: Array<Ta_Citizen_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Citizen_User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_citizen_user". All fields are combined with a logical 'AND'. */
export type Ta_Citizen_User_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Citizen_User_Bool_Exp>>;
  _not?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Citizen_User_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  citizen_id?: InputMaybe<Uuid_Comparison_Exp>;
  citizen_user_role?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  taUserByUpdatedByUserid?: InputMaybe<Ta_User_Bool_Exp>;
  ta_citizen?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by_userid?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_citizen_user" */
export enum Ta_Citizen_User_Constraint {
  /** unique or primary key constraint on columns "user_id", "citizen_id" */
  TaCitizenUserCitizenIdUserIdKey = 'ta_citizen_user_citizen_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  TaCitizenUserPkey = 'ta_citizen_user_pkey'
}

/** input type for inserting data into table "ta_citizen_user" */
export type Ta_Citizen_User_Insert_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  citizen_user_role?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  ta_citizen?: InputMaybe<Ta_Citizen_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "ta_citizen_user" */
export type Ta_Citizen_User_Max_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  citizen_user_role?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_citizen_user" */
export type Ta_Citizen_User_Min_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  citizen_user_role?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_citizen_user" */
export type Ta_Citizen_User_Mutation_Response = {
  __typename?: 'ta_citizen_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Citizen_User>;
};

/** on_conflict condition type for table "ta_citizen_user" */
export type Ta_Citizen_User_On_Conflict = {
  constraint: Ta_Citizen_User_Constraint;
  update_columns?: Array<Ta_Citizen_User_Update_Column>;
  where?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_citizen_user". */
export type Ta_Citizen_User_Order_By = {
  archived?: InputMaybe<Order_By>;
  citizen_id?: InputMaybe<Order_By>;
  citizen_user_role?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  taUserByUpdatedByUserid?: InputMaybe<Ta_User_Order_By>;
  ta_citizen?: InputMaybe<Ta_Citizen_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_citizen_user */
export type Ta_Citizen_User_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_citizen_user" */
export enum Ta_Citizen_User_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  CitizenUserRole = 'citizen_user_role',
  /** column name */
  Id = 'id',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserid = 'updated_by_userid',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "ta_citizen_user" */
export type Ta_Citizen_User_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  citizen_user_role?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ta_citizen_user" */
export type Ta_Citizen_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Citizen_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Citizen_User_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  citizen_user_role?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by_userid?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "ta_citizen_user" */
export enum Ta_Citizen_User_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  CitizenUserRole = 'citizen_user_role',
  /** column name */
  ShortName = 'short_name'
}

export type Ta_Citizen_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Citizen_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Citizen_User_Bool_Exp;
};

/** columns and relationships of "ta_device" */
export type Ta_Device = {
  __typename?: 'ta_device';
  active: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_name?: Maybe<Scalars['String']['output']>;
  device_id?: Maybe<Scalars['String']['output']>;
  discovered?: Maybe<Scalars['Boolean']['output']>;
  eui: Scalars['String']['output'];
  floor_id?: Maybe<Scalars['uuid']['output']>;
  gateway_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  location?: Maybe<Scalars['String']['output']>;
  manufacturer_name?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['ta_device_metadata_type']['output']>;
  model_identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notes_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  serial_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  ta_citizen_devices: Array<Ta_Citizen_Device>;
  /** An aggregate relationship */
  ta_citizen_devices_aggregate: Ta_Citizen_Device_Aggregate;
  /** An array relationship */
  ta_device_online_histories: Array<Ta_Device_Online_History>;
  /** An object relationship */
  ta_floor?: Maybe<Ta_Floors>;
  /** An object relationship */
  ta_gateway?: Maybe<Ta_Gateway>;
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  /** An array relationship */
  ta_organisation_users: Array<Ta_User_Organisation>;
  /** An array relationship */
  ta_relationship_to_tags: Array<Ta_Relationship_To_Tag>;
  /** An array relationship */
  ta_sensors: Array<Ta_Sensor>;
  /** An array relationship */
  ta_sms_logs: Array<Ta_Sms_Log>;
  /** An object relationship */
  ta_zone?: Maybe<Ta_Zone>;
  template_hash?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['numeric']['output']>;
  view_template?: Maybe<Scalars['ta_device_view_template_type']['output']>;
  zone_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "ta_device" */
export type Ta_DeviceTa_Citizen_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


/** columns and relationships of "ta_device" */
export type Ta_DeviceTa_Citizen_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


/** columns and relationships of "ta_device" */
export type Ta_DeviceTa_Device_Online_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Online_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Online_History_Order_By>>;
  where?: InputMaybe<Ta_Device_Online_History_Bool_Exp>;
};


/** columns and relationships of "ta_device" */
export type Ta_DeviceTa_Organisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


/** columns and relationships of "ta_device" */
export type Ta_DeviceTa_Relationship_To_TagsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Relationship_To_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Relationship_To_Tag_Order_By>>;
  where?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
};


/** columns and relationships of "ta_device" */
export type Ta_DeviceTa_SensorsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Sensor_Order_By>>;
  where?: InputMaybe<Ta_Sensor_Bool_Exp>;
};


/** columns and relationships of "ta_device" */
export type Ta_DeviceTa_Sms_LogsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Sms_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Sms_Log_Order_By>>;
  where?: InputMaybe<Ta_Sms_Log_Bool_Exp>;
};

/** order by aggregate values of table "ta_device" */
export type Ta_Device_Aggregate_Order_By = {
  avg?: InputMaybe<Ta_Device_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Device_Max_Order_By>;
  min?: InputMaybe<Ta_Device_Min_Order_By>;
  stddev?: InputMaybe<Ta_Device_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ta_Device_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ta_Device_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ta_Device_Sum_Order_By>;
  var_pop?: InputMaybe<Ta_Device_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ta_Device_Var_Samp_Order_By>;
  variance?: InputMaybe<Ta_Device_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ta_device" */
export type Ta_Device_Arr_Rel_Insert_Input = {
  data: Array<Ta_Device_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Device_On_Conflict>;
};

/** order by avg() on columns of table "ta_device" */
export type Ta_Device_Avg_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ta_device". All fields are combined with a logical 'AND'. */
export type Ta_Device_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Device_Bool_Exp>>;
  _not?: InputMaybe<Ta_Device_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Device_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  default_name?: InputMaybe<String_Comparison_Exp>;
  device_id?: InputMaybe<String_Comparison_Exp>;
  discovered?: InputMaybe<Boolean_Comparison_Exp>;
  eui?: InputMaybe<String_Comparison_Exp>;
  floor_id?: InputMaybe<Uuid_Comparison_Exp>;
  gateway_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  manufacturer_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Json_Comparison_Exp>;
  model_identifier?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  notes_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  online?: InputMaybe<Boolean_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  position?: InputMaybe<String_Comparison_Exp>;
  room?: InputMaybe<String_Comparison_Exp>;
  serial_number?: InputMaybe<String_Comparison_Exp>;
  ta_citizen_devices?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
  ta_citizen_devices_aggregate?: InputMaybe<Ta_Citizen_Device_Aggregate_Bool_Exp>;
  ta_device_online_histories?: InputMaybe<Ta_Device_Online_History_Bool_Exp>;
  ta_floor?: InputMaybe<Ta_Floors_Bool_Exp>;
  ta_gateway?: InputMaybe<Ta_Gateway_Bool_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  ta_relationship_to_tags?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
  ta_sensors?: InputMaybe<Ta_Sensor_Bool_Exp>;
  ta_sms_logs?: InputMaybe<Ta_Sms_Log_Bool_Exp>;
  ta_zone?: InputMaybe<Ta_Zone_Bool_Exp>;
  template_hash?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  version?: InputMaybe<Numeric_Comparison_Exp>;
  view_template?: InputMaybe<Json_Comparison_Exp>;
  zone_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_device" */
export enum Ta_Device_Constraint {
  /** unique or primary key constraint on columns "eui" */
  TaDeviceEuiKey = 'ta_device_eui_key',
  /** unique or primary key constraint on columns "id" */
  TaDeviceIdKey = 'ta_device_id_key',
  /** unique or primary key constraint on columns "id" */
  TaDevicePkey = 'ta_device_pkey',
  /** unique or primary key constraint on columns "serial_number" */
  TaDeviceSerialNumberKey = 'ta_device_serial_number_key'
}

/** columns and relationships of "ta_device_count" */
export type Ta_Device_Count = {
  __typename?: 'ta_device_count';
  created_at: Scalars['timestamp']['output'];
  eui: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  in_use: Scalars['Boolean']['output'];
  operation_mode: Scalars['String']['output'];
  organisation_id: Scalars['uuid']['output'];
  resident_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ta_organisation: Ta_Organisation;
  updated_at: Scalars['timestamp']['output'];
};

/** order by aggregate values of table "ta_device_count" */
export type Ta_Device_Count_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Device_Count_Max_Order_By>;
  min?: InputMaybe<Ta_Device_Count_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_device_count". All fields are combined with a logical 'AND'. */
export type Ta_Device_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Device_Count_Bool_Exp>>;
  _not?: InputMaybe<Ta_Device_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Device_Count_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  eui?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_use?: InputMaybe<Boolean_Comparison_Exp>;
  operation_mode?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  resident_name?: InputMaybe<String_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** order by max() on columns of table "ta_device_count" */
export type Ta_Device_Count_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  eui?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation_mode?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  resident_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_device_count" */
export type Ta_Device_Count_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  eui?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation_mode?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  resident_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_device_count". */
export type Ta_Device_Count_Order_By = {
  created_at?: InputMaybe<Order_By>;
  eui?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_use?: InputMaybe<Order_By>;
  operation_mode?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  resident_name?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ta_device_count" */
export enum Ta_Device_Count_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Eui = 'eui',
  /** column name */
  Id = 'id',
  /** column name */
  InUse = 'in_use',
  /** column name */
  OperationMode = 'operation_mode',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ResidentName = 'resident_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "ta_device_count" */
export type Ta_Device_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Device_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Device_Count_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  eui?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_use?: InputMaybe<Scalars['Boolean']['input']>;
  operation_mode?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  resident_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** input type for inserting data into table "ta_device" */
export type Ta_Device_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  default_name?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  discovered?: InputMaybe<Scalars['Boolean']['input']>;
  eui?: InputMaybe<Scalars['String']['input']>;
  floor_id?: InputMaybe<Scalars['uuid']['input']>;
  gateway_id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manufacturer_name?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['json']['input']>;
  model_identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  room?: InputMaybe<Scalars['String']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  ta_citizen_devices?: InputMaybe<Ta_Citizen_Device_Arr_Rel_Insert_Input>;
  ta_floor?: InputMaybe<Ta_Floors_Obj_Rel_Insert_Input>;
  ta_gateway?: InputMaybe<Ta_Gateway_Obj_Rel_Insert_Input>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Arr_Rel_Insert_Input>;
  ta_relationship_to_tags?: InputMaybe<Ta_Relationship_To_Tag_Arr_Rel_Insert_Input>;
  ta_zone?: InputMaybe<Ta_Zone_Obj_Rel_Insert_Input>;
  template_hash?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['numeric']['input']>;
  view_template?: InputMaybe<Scalars['json']['input']>;
  zone_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "ta_device" */
export type Ta_Device_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_name?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  eui?: InputMaybe<Order_By>;
  floor_id?: InputMaybe<Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  manufacturer_name?: InputMaybe<Order_By>;
  model_identifier?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  notes_updated_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  template_hash?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_device" */
export type Ta_Device_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_name?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  eui?: InputMaybe<Order_By>;
  floor_id?: InputMaybe<Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  manufacturer_name?: InputMaybe<Order_By>;
  model_identifier?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  notes_updated_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  template_hash?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_device" */
export type Ta_Device_Mutation_Response = {
  __typename?: 'ta_device_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Device>;
};

/** input type for inserting object relation for remote table "ta_device" */
export type Ta_Device_Obj_Rel_Insert_Input = {
  data: Ta_Device_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Device_On_Conflict>;
};

/** on_conflict condition type for table "ta_device" */
export type Ta_Device_On_Conflict = {
  constraint: Ta_Device_Constraint;
  update_columns?: Array<Ta_Device_Update_Column>;
  where?: InputMaybe<Ta_Device_Bool_Exp>;
};

/** columns and relationships of "ta_device_online_history" */
export type Ta_Device_Online_History = {
  __typename?: 'ta_device_online_history';
  device_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  online: Scalars['Boolean']['output'];
  /** An object relationship */
  ta_device: Ta_Device;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "ta_device_online_history" */
export type Ta_Device_Online_History_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Device_Online_History_Max_Order_By>;
  min?: InputMaybe<Ta_Device_Online_History_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_device_online_history". All fields are combined with a logical 'AND'. */
export type Ta_Device_Online_History_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Device_Online_History_Bool_Exp>>;
  _not?: InputMaybe<Ta_Device_Online_History_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Device_Online_History_Bool_Exp>>;
  device_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  online?: InputMaybe<Boolean_Comparison_Exp>;
  ta_device?: InputMaybe<Ta_Device_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "ta_device_online_history" */
export type Ta_Device_Online_History_Max_Order_By = {
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_device_online_history" */
export type Ta_Device_Online_History_Min_Order_By = {
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_device_online_history". */
export type Ta_Device_Online_History_Order_By = {
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  online?: InputMaybe<Order_By>;
  ta_device?: InputMaybe<Ta_Device_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ta_device_online_history" */
export enum Ta_Device_Online_History_Select_Column {
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  Online = 'online',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "ta_device_online_history" */
export type Ta_Device_Online_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Device_Online_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Device_Online_History_Stream_Cursor_Value_Input = {
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Ordering options when selecting data from "ta_device". */
export type Ta_Device_Order_By = {
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  default_name?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  discovered?: InputMaybe<Order_By>;
  eui?: InputMaybe<Order_By>;
  floor_id?: InputMaybe<Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  manufacturer_name?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  model_identifier?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  notes_updated_at?: InputMaybe<Order_By>;
  online?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  ta_citizen_devices_aggregate?: InputMaybe<Ta_Citizen_Device_Aggregate_Order_By>;
  ta_device_online_histories_aggregate?: InputMaybe<Ta_Device_Online_History_Aggregate_Order_By>;
  ta_floor?: InputMaybe<Ta_Floors_Order_By>;
  ta_gateway?: InputMaybe<Ta_Gateway_Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_organisation_users_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  ta_relationship_to_tags_aggregate?: InputMaybe<Ta_Relationship_To_Tag_Aggregate_Order_By>;
  ta_sensors_aggregate?: InputMaybe<Ta_Sensor_Aggregate_Order_By>;
  ta_sms_logs_aggregate?: InputMaybe<Ta_Sms_Log_Aggregate_Order_By>;
  ta_zone?: InputMaybe<Ta_Zone_Order_By>;
  template_hash?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
  view_template?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_device */
export type Ta_Device_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_device" */
export enum Ta_Device_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultName = 'default_name',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Discovered = 'discovered',
  /** column name */
  Eui = 'eui',
  /** column name */
  FloorId = 'floor_id',
  /** column name */
  GatewayId = 'gateway_id',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  ManufacturerName = 'manufacturer_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ModelIdentifier = 'model_identifier',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  NotesUpdatedAt = 'notes_updated_at',
  /** column name */
  Online = 'online',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Position = 'position',
  /** column name */
  Room = 'room',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  TemplateHash = 'template_hash',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version',
  /** column name */
  ViewTemplate = 'view_template',
  /** column name */
  ZoneId = 'zone_id'
}

/** input type for updating data in table "ta_device" */
export type Ta_Device_Set_Input = {
  __typename?: 'ta_device_set_input';
  active?: Maybe<Scalars['Boolean']['output']>;
  discovered?: Maybe<Scalars['Boolean']['output']>;
  floor_id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['ta_device_metadata_type']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notes_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  view_template?: Maybe<Scalars['ta_device_view_template_type']['output']>;
  zone_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by stddev() on columns of table "ta_device" */
export type Ta_Device_Stddev_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ta_device" */
export type Ta_Device_Stddev_Pop_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ta_device" */
export type Ta_Device_Stddev_Samp_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ta_device" */
export type Ta_Device_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Device_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Device_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_name?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  discovered?: InputMaybe<Scalars['Boolean']['input']>;
  eui?: InputMaybe<Scalars['String']['input']>;
  floor_id?: InputMaybe<Scalars['uuid']['input']>;
  gateway_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manufacturer_name?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['ta_device_metadata_type']['input']>;
  model_identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notes_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  room?: InputMaybe<Scalars['String']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  template_hash?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['numeric']['input']>;
  view_template?: InputMaybe<Scalars['ta_device_view_template_type']['input']>;
  zone_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "ta_device" */
export type Ta_Device_Sum_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** update columns of table "ta_device" */
export enum Ta_Device_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Discovered = 'discovered',
  /** column name */
  FloorId = 'floor_id',
  /** column name */
  Location = 'location',
  /** column name */
  Notes = 'notes',
  /** column name */
  NotesUpdatedAt = 'notes_updated_at',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Position = 'position',
  /** column name */
  Room = 'room',
  /** column name */
  ViewTemplate = 'view_template',
  /** column name */
  ZoneId = 'zone_id'
}

export type Ta_Device_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Device_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Device_Bool_Exp;
};

/** order by var_pop() on columns of table "ta_device" */
export type Ta_Device_Var_Pop_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ta_device" */
export type Ta_Device_Var_Samp_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ta_device" */
export type Ta_Device_Variance_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** columns and relationships of "ta_floors" */
export type Ta_Floors = {
  __typename?: 'ta_floors';
  coordinates?: Maybe<Scalars['jsonb']['output']>;
  floor_number: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  ta_devices: Array<Ta_Device>;
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  /** An array relationship */
  ta_zones: Array<Ta_Zone>;
};


/** columns and relationships of "ta_floors" */
export type Ta_FloorsCoordinatesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "ta_floors" */
export type Ta_FloorsTa_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Order_By>>;
  where?: InputMaybe<Ta_Device_Bool_Exp>;
};


/** columns and relationships of "ta_floors" */
export type Ta_FloorsTa_ZonesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Zone_Order_By>>;
  where?: InputMaybe<Ta_Zone_Bool_Exp>;
};

/** order by aggregate values of table "ta_floors" */
export type Ta_Floors_Aggregate_Order_By = {
  avg?: InputMaybe<Ta_Floors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Floors_Max_Order_By>;
  min?: InputMaybe<Ta_Floors_Min_Order_By>;
  stddev?: InputMaybe<Ta_Floors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ta_Floors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ta_Floors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ta_Floors_Sum_Order_By>;
  var_pop?: InputMaybe<Ta_Floors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ta_Floors_Var_Samp_Order_By>;
  variance?: InputMaybe<Ta_Floors_Variance_Order_By>;
};

/** order by avg() on columns of table "ta_floors" */
export type Ta_Floors_Avg_Order_By = {
  floor_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ta_floors". All fields are combined with a logical 'AND'. */
export type Ta_Floors_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Floors_Bool_Exp>>;
  _not?: InputMaybe<Ta_Floors_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Floors_Bool_Exp>>;
  coordinates?: InputMaybe<Jsonb_Comparison_Exp>;
  floor_number?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_devices?: InputMaybe<Ta_Device_Bool_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_zones?: InputMaybe<Ta_Zone_Bool_Exp>;
};

/** unique or primary key constraints on table "ta_floors" */
export enum Ta_Floors_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaFloorsPkey = 'ta_floors_pkey'
}

/** input type for incrementing numeric columns in table "ta_floors" */
export type Ta_Floors_Inc_Input = {
  floor_number?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "ta_floors" */
export type Ta_Floors_Insert_Input = {
  coordinates?: InputMaybe<Scalars['jsonb']['input']>;
  floor_number?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_devices?: InputMaybe<Ta_Device_Arr_Rel_Insert_Input>;
  ta_zones?: InputMaybe<Ta_Zone_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "ta_floors" */
export type Ta_Floors_Max_Order_By = {
  floor_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_floors" */
export type Ta_Floors_Min_Order_By = {
  floor_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_floors" */
export type Ta_Floors_Mutation_Response = {
  __typename?: 'ta_floors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Floors>;
};

/** input type for inserting object relation for remote table "ta_floors" */
export type Ta_Floors_Obj_Rel_Insert_Input = {
  data: Ta_Floors_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Floors_On_Conflict>;
};

/** on_conflict condition type for table "ta_floors" */
export type Ta_Floors_On_Conflict = {
  constraint: Ta_Floors_Constraint;
  update_columns?: Array<Ta_Floors_Update_Column>;
  where?: InputMaybe<Ta_Floors_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_floors". */
export type Ta_Floors_Order_By = {
  coordinates?: InputMaybe<Order_By>;
  floor_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  ta_devices_aggregate?: InputMaybe<Ta_Device_Aggregate_Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_zones_aggregate?: InputMaybe<Ta_Zone_Aggregate_Order_By>;
};

/** primary key columns input for table: ta_floors */
export type Ta_Floors_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_floors" */
export enum Ta_Floors_Select_Column {
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  FloorNumber = 'floor_number',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id'
}

/** input type for updating data in table "ta_floors" */
export type Ta_Floors_Set_Input = {
  floor_number?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "ta_floors" */
export type Ta_Floors_Stddev_Order_By = {
  floor_number?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ta_floors" */
export type Ta_Floors_Stddev_Pop_Order_By = {
  floor_number?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ta_floors" */
export type Ta_Floors_Stddev_Samp_Order_By = {
  floor_number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ta_floors" */
export type Ta_Floors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Floors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Floors_Stream_Cursor_Value_Input = {
  coordinates?: InputMaybe<Scalars['jsonb']['input']>;
  floor_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "ta_floors" */
export type Ta_Floors_Sum_Order_By = {
  floor_number?: InputMaybe<Order_By>;
};

/** update columns of table "ta_floors" */
export enum Ta_Floors_Update_Column {
  /** column name */
  FloorNumber = 'floor_number',
  /** column name */
  Name = 'name'
}

export type Ta_Floors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ta_Floors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Floors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Floors_Bool_Exp;
};

/** order by var_pop() on columns of table "ta_floors" */
export type Ta_Floors_Var_Pop_Order_By = {
  floor_number?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ta_floors" */
export type Ta_Floors_Var_Samp_Order_By = {
  floor_number?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ta_floors" */
export type Ta_Floors_Variance_Order_By = {
  floor_number?: InputMaybe<Order_By>;
};

/** columns and relationships of "ta_gateway" */
export type Ta_Gateway = {
  __typename?: 'ta_gateway';
  active: Scalars['Boolean']['output'];
  archived: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  fw_version?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  installation_notes?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  online: Scalars['Boolean']['output'];
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  serial: Scalars['String']['output'];
  /** An array relationship */
  ta_citizen_gateways: Array<Ta_Citizen_Gateway>;
  /** An array relationship */
  ta_devices: Array<Ta_Device>;
  /** An array relationship */
  ta_gateway_online_histories: Array<Ta_Gateway_Online_History>;
  /** An array relationship */
  ta_mqtt_commands: Array<Ta_Mqtt_Command>;
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  /** An array relationship */
  ta_organisation_users: Array<Ta_User_Organisation>;
  /** An object relationship */
  ta_supplier?: Maybe<Ta_Supplier>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "ta_gateway" */
export type Ta_GatewayTa_Citizen_GatewaysArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Gateway_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Gateway_Bool_Exp>;
};


/** columns and relationships of "ta_gateway" */
export type Ta_GatewayTa_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Order_By>>;
  where?: InputMaybe<Ta_Device_Bool_Exp>;
};


/** columns and relationships of "ta_gateway" */
export type Ta_GatewayTa_Gateway_Online_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Gateway_Online_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Gateway_Online_History_Order_By>>;
  where?: InputMaybe<Ta_Gateway_Online_History_Bool_Exp>;
};


/** columns and relationships of "ta_gateway" */
export type Ta_GatewayTa_Mqtt_CommandsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Mqtt_Command_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Mqtt_Command_Order_By>>;
  where?: InputMaybe<Ta_Mqtt_Command_Bool_Exp>;
};


/** columns and relationships of "ta_gateway" */
export type Ta_GatewayTa_Organisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};

/** order by aggregate values of table "ta_gateway" */
export type Ta_Gateway_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Gateway_Max_Order_By>;
  min?: InputMaybe<Ta_Gateway_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_gateway". All fields are combined with a logical 'AND'. */
export type Ta_Gateway_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Gateway_Bool_Exp>>;
  _not?: InputMaybe<Ta_Gateway_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Gateway_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fw_version?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  installation_notes?: InputMaybe<String_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  online?: InputMaybe<Boolean_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  serial?: InputMaybe<String_Comparison_Exp>;
  ta_citizen_gateways?: InputMaybe<Ta_Citizen_Gateway_Bool_Exp>;
  ta_devices?: InputMaybe<Ta_Device_Bool_Exp>;
  ta_gateway_online_histories?: InputMaybe<Ta_Gateway_Online_History_Bool_Exp>;
  ta_mqtt_commands?: InputMaybe<Ta_Mqtt_Command_Bool_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  ta_supplier?: InputMaybe<Ta_Supplier_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_gateway" */
export enum Ta_Gateway_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaGatewayPkey = 'ta_gateway_pkey',
  /** unique or primary key constraint on columns "serial" */
  TaGatewaySerialKey = 'ta_gateway_serial_key',
  /** unique or primary key constraint on columns "ssh_port" */
  TaGatewaySshPortKey = 'ta_gateway_ssh_port_key'
}

/** input type for inserting data into table "ta_gateway" */
export type Ta_Gateway_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  installation_notes?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  ta_citizen_gateways?: InputMaybe<Ta_Citizen_Gateway_Arr_Rel_Insert_Input>;
  ta_devices?: InputMaybe<Ta_Device_Arr_Rel_Insert_Input>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "ta_gateway_log" */
export type Ta_Gateway_Log = {
  __typename?: 'ta_gateway_log';
  /** An object relationship */
  ta_gateway: Ta_Gateway;
};

/** Boolean expression to filter rows from the table "ta_gateway_log". All fields are combined with a logical 'AND'. */
export type Ta_Gateway_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Gateway_Log_Bool_Exp>>;
  _not?: InputMaybe<Ta_Gateway_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Gateway_Log_Bool_Exp>>;
  ta_gateway?: InputMaybe<Ta_Gateway_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_gateway_log". */
export type Ta_Gateway_Log_Order_By = {
  ta_gateway?: InputMaybe<Ta_Gateway_Order_By>;
};

/** order by max() on columns of table "ta_gateway" */
export type Ta_Gateway_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fw_version?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installation_notes?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  serial?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_gateway" */
export type Ta_Gateway_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fw_version?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installation_notes?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  serial?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_gateway" */
export type Ta_Gateway_Mutation_Response = {
  __typename?: 'ta_gateway_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Gateway>;
};

/** input type for inserting object relation for remote table "ta_gateway" */
export type Ta_Gateway_Obj_Rel_Insert_Input = {
  data: Ta_Gateway_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Gateway_On_Conflict>;
};

/** on_conflict condition type for table "ta_gateway" */
export type Ta_Gateway_On_Conflict = {
  constraint: Ta_Gateway_Constraint;
  update_columns?: Array<Ta_Gateway_Update_Column>;
  where?: InputMaybe<Ta_Gateway_Bool_Exp>;
};

/** columns and relationships of "ta_gateway_online_history" */
export type Ta_Gateway_Online_History = {
  __typename?: 'ta_gateway_online_history';
  gateway_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  online: Scalars['Boolean']['output'];
  /** An object relationship */
  ta_gateway: Ta_Gateway;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "ta_gateway_online_history" */
export type Ta_Gateway_Online_History_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Gateway_Online_History_Max_Order_By>;
  min?: InputMaybe<Ta_Gateway_Online_History_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_gateway_online_history". All fields are combined with a logical 'AND'. */
export type Ta_Gateway_Online_History_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Gateway_Online_History_Bool_Exp>>;
  _not?: InputMaybe<Ta_Gateway_Online_History_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Gateway_Online_History_Bool_Exp>>;
  gateway_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  online?: InputMaybe<Boolean_Comparison_Exp>;
  ta_gateway?: InputMaybe<Ta_Gateway_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "ta_gateway_online_history" */
export type Ta_Gateway_Online_History_Max_Order_By = {
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_gateway_online_history" */
export type Ta_Gateway_Online_History_Min_Order_By = {
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_gateway_online_history". */
export type Ta_Gateway_Online_History_Order_By = {
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  online?: InputMaybe<Order_By>;
  ta_gateway?: InputMaybe<Ta_Gateway_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ta_gateway_online_history" */
export enum Ta_Gateway_Online_History_Select_Column {
  /** column name */
  GatewayId = 'gateway_id',
  /** column name */
  Id = 'id',
  /** column name */
  Online = 'online',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "ta_gateway_online_history" */
export type Ta_Gateway_Online_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Gateway_Online_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Gateway_Online_History_Stream_Cursor_Value_Input = {
  gateway_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Ordering options when selecting data from "ta_gateway". */
export type Ta_Gateway_Order_By = {
  active?: InputMaybe<Order_By>;
  archived?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fw_version?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installation_notes?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  online?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  serial?: InputMaybe<Order_By>;
  ta_citizen_gateways_aggregate?: InputMaybe<Ta_Citizen_Gateway_Aggregate_Order_By>;
  ta_devices_aggregate?: InputMaybe<Ta_Device_Aggregate_Order_By>;
  ta_gateway_online_histories_aggregate?: InputMaybe<Ta_Gateway_Online_History_Aggregate_Order_By>;
  ta_mqtt_commands_aggregate?: InputMaybe<Ta_Mqtt_Command_Aggregate_Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_organisation_users_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  ta_supplier?: InputMaybe<Ta_Supplier_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_gateway */
export type Ta_Gateway_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_gateway" */
export enum Ta_Gateway_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Archived = 'archived',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FwVersion = 'fw_version',
  /** column name */
  Id = 'id',
  /** column name */
  InstallationNotes = 'installation_notes',
  /** column name */
  Model = 'model',
  /** column name */
  Online = 'online',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Serial = 'serial',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ta_gateway" */
export type Ta_Gateway_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  installation_notes?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "ta_gateway" */
export type Ta_Gateway_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Gateway_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Gateway_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fw_version?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_notes?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "ta_gateway" */
export enum Ta_Gateway_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Archived = 'archived',
  /** column name */
  InstallationNotes = 'installation_notes',
  /** column name */
  OrganisationId = 'organisation_id'
}

export type Ta_Gateway_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Gateway_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Gateway_Bool_Exp;
};

/** columns and relationships of "ta_maintenance" */
export type Ta_Maintenance = {
  __typename?: 'ta_maintenance';
  display_end: Scalars['timestamp']['output'];
  display_start: Scalars['timestamp']['output'];
  group_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  language: Scalars['String']['output'];
  maintenance_end?: Maybe<Scalars['timestamp']['output']>;
  maintenance_start?: Maybe<Scalars['timestamp']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  published: Scalars['Boolean']['output'];
  show_in_app: Scalars['Boolean']['output'];
  show_in_web: Scalars['Boolean']['output'];
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  text: Scalars['String']['output'];
  type: Ta_Maintenance_Type_Enum;
};

/** Boolean expression to filter rows from the table "ta_maintenance". All fields are combined with a logical 'AND'. */
export type Ta_Maintenance_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Maintenance_Bool_Exp>>;
  _not?: InputMaybe<Ta_Maintenance_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Maintenance_Bool_Exp>>;
  display_end?: InputMaybe<Timestamp_Comparison_Exp>;
  display_start?: InputMaybe<Timestamp_Comparison_Exp>;
  group_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  maintenance_end?: InputMaybe<Timestamp_Comparison_Exp>;
  maintenance_start?: InputMaybe<Timestamp_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  show_in_app?: InputMaybe<Boolean_Comparison_Exp>;
  show_in_web?: InputMaybe<Boolean_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Ta_Maintenance_Type_Enum_Comparison_Exp>;
};

/** Ordering options when selecting data from "ta_maintenance". */
export type Ta_Maintenance_Order_By = {
  display_end?: InputMaybe<Order_By>;
  display_start?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  maintenance_end?: InputMaybe<Order_By>;
  maintenance_start?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  show_in_app?: InputMaybe<Order_By>;
  show_in_web?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  text?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "ta_maintenance" */
export enum Ta_Maintenance_Select_Column {
  /** column name */
  DisplayEnd = 'display_end',
  /** column name */
  DisplayStart = 'display_start',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  MaintenanceEnd = 'maintenance_end',
  /** column name */
  MaintenanceStart = 'maintenance_start',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Published = 'published',
  /** column name */
  ShowInApp = 'show_in_app',
  /** column name */
  ShowInWeb = 'show_in_web',
  /** column name */
  Text = 'text',
  /** column name */
  Type = 'type'
}

/** Streaming cursor of the table "ta_maintenance" */
export type Ta_Maintenance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Maintenance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Maintenance_Stream_Cursor_Value_Input = {
  display_end?: InputMaybe<Scalars['timestamp']['input']>;
  display_start?: InputMaybe<Scalars['timestamp']['input']>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  maintenance_end?: InputMaybe<Scalars['timestamp']['input']>;
  maintenance_start?: InputMaybe<Scalars['timestamp']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  show_in_app?: InputMaybe<Scalars['Boolean']['input']>;
  show_in_web?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Ta_Maintenance_Type_Enum>;
};

/** columns and relationships of "ta_maintenance_type" */
export type Ta_Maintenance_Type = {
  __typename?: 'ta_maintenance_type';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "ta_maintenance_type". All fields are combined with a logical 'AND'. */
export type Ta_Maintenance_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Maintenance_Type_Bool_Exp>>;
  _not?: InputMaybe<Ta_Maintenance_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Maintenance_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Ta_Maintenance_Type_Enum {
  /** Error, eg an ongoing outage */
  Error = 'error',
  /** Informational announcement */
  Info = 'info',
  /** Positive announcement, eg new features */
  Success = 'success',
  /** Warning, eg planned maintenance */
  Warning = 'warning'
}

/** Boolean expression to compare columns of type "ta_maintenance_type_enum". All fields are combined with logical 'AND'. */
export type Ta_Maintenance_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ta_Maintenance_Type_Enum>;
  _in?: InputMaybe<Array<Ta_Maintenance_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Ta_Maintenance_Type_Enum>;
  _nin?: InputMaybe<Array<Ta_Maintenance_Type_Enum>>;
};

/** Ordering options when selecting data from "ta_maintenance_type". */
export type Ta_Maintenance_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "ta_maintenance_type" */
export enum Ta_Maintenance_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "ta_maintenance_type" */
export type Ta_Maintenance_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Maintenance_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Maintenance_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ta_mqtt_command" */
export type Ta_Mqtt_Command = {
  __typename?: 'ta_mqtt_command';
  created_at: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  gateway_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  message_id: Scalars['String']['output'];
  /** An object relationship */
  ta_gateway: Ta_Gateway;
  type: Scalars['String']['output'];
};


/** columns and relationships of "ta_mqtt_command" */
export type Ta_Mqtt_CommandDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "ta_mqtt_command" */
export type Ta_Mqtt_Command_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Mqtt_Command_Max_Order_By>;
  min?: InputMaybe<Ta_Mqtt_Command_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_mqtt_command". All fields are combined with a logical 'AND'. */
export type Ta_Mqtt_Command_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Mqtt_Command_Bool_Exp>>;
  _not?: InputMaybe<Ta_Mqtt_Command_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Mqtt_Command_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  gateway_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message_id?: InputMaybe<String_Comparison_Exp>;
  ta_gateway?: InputMaybe<Ta_Gateway_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ta_mqtt_command" */
export type Ta_Mqtt_Command_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_mqtt_command" */
export type Ta_Mqtt_Command_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_mqtt_command". */
export type Ta_Mqtt_Command_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  gateway_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  ta_gateway?: InputMaybe<Ta_Gateway_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "ta_mqtt_command" */
export enum Ta_Mqtt_Command_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  GatewayId = 'gateway_id',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Type = 'type'
}

/** Streaming cursor of the table "ta_mqtt_command" */
export type Ta_Mqtt_Command_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Mqtt_Command_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Mqtt_Command_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  gateway_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ta_notification" */
export type Ta_Notification = {
  __typename?: 'ta_notification';
  checked?: Maybe<Scalars['timestamp']['output']>;
  citizen_id?: Maybe<Scalars['uuid']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  config: Scalars['RuleConfig']['output'];
  created_at: Scalars['timestamp']['output'];
  follow_up_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  note?: Maybe<Scalars['String']['output']>;
  notification_text?: Maybe<Scalars['String']['output']>;
  processed_at?: Maybe<Scalars['timestamptz']['output']>;
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  ta_citizen?: Maybe<Ta_Citizen>;
  /** An array relationship */
  ta_notification_logs: Array<Ta_Notification_Log>;
  /** An array relationship */
  ta_notification_notes: Array<Ta_Notification_Notes>;
  /** An array relationship */
  ta_notification_reminders: Array<Ta_Notification_Reminder>;
  /** An array relationship */
  ta_notification_users: Array<Ta_Notification_User>;
  /** An aggregate relationship */
  ta_notification_users_aggregate: Ta_Notification_User_Aggregate;
  /** An object relationship */
  ta_rule_notification: Ta_Rule_Notification;
  ta_rule_notification_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_sensor?: Maybe<Ta_Sensor>;
  variables?: Maybe<Scalars['NotificationVariables']['output']>;
  /** An array relationship */
  view_user_residents: Array<View_User_Residents>;
};


/** columns and relationships of "ta_notification" */
export type Ta_NotificationTa_Notification_LogsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Log_Order_By>>;
  where?: InputMaybe<Ta_Notification_Log_Bool_Exp>;
};


/** columns and relationships of "ta_notification" */
export type Ta_NotificationTa_Notification_NotesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Notes_Order_By>>;
  where?: InputMaybe<Ta_Notification_Notes_Bool_Exp>;
};


/** columns and relationships of "ta_notification" */
export type Ta_NotificationTa_Notification_RemindersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Reminder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Reminder_Order_By>>;
  where?: InputMaybe<Ta_Notification_Reminder_Bool_Exp>;
};


/** columns and relationships of "ta_notification" */
export type Ta_NotificationTa_Notification_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Notification_User_Bool_Exp>;
};


/** columns and relationships of "ta_notification" */
export type Ta_NotificationTa_Notification_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Notification_User_Bool_Exp>;
};


/** columns and relationships of "ta_notification" */
export type Ta_NotificationView_User_ResidentsArgs = {
  distinct_on?: InputMaybe<Array<View_User_Residents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Residents_Order_By>>;
  where?: InputMaybe<View_User_Residents_Bool_Exp>;
};

/** aggregated selection of "ta_notification" */
export type Ta_Notification_Aggregate = {
  __typename?: 'ta_notification_aggregate';
  aggregate?: Maybe<Ta_Notification_Aggregate_Fields>;
  nodes: Array<Ta_Notification>;
};

export type Ta_Notification_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ta_Notification_Aggregate_Bool_Exp_Count>;
};

export type Ta_Notification_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ta_Notification_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ta_notification" */
export type Ta_Notification_Aggregate_Fields = {
  __typename?: 'ta_notification_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ta_Notification_Max_Fields>;
  min?: Maybe<Ta_Notification_Min_Fields>;
};


/** aggregate fields of "ta_notification" */
export type Ta_Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ta_notification" */
export type Ta_Notification_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Notification_Max_Order_By>;
  min?: InputMaybe<Ta_Notification_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_notification". All fields are combined with a logical 'AND'. */
export type Ta_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Notification_Bool_Exp>>;
  _not?: InputMaybe<Ta_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Notification_Bool_Exp>>;
  checked?: InputMaybe<Timestamp_Comparison_Exp>;
  citizen_id?: InputMaybe<Uuid_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  follow_up_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  notification_text?: InputMaybe<String_Comparison_Exp>;
  processed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_citizen?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_notification_logs?: InputMaybe<Ta_Notification_Log_Bool_Exp>;
  ta_notification_notes?: InputMaybe<Ta_Notification_Notes_Bool_Exp>;
  ta_notification_reminders?: InputMaybe<Ta_Notification_Reminder_Bool_Exp>;
  ta_notification_users?: InputMaybe<Ta_Notification_User_Bool_Exp>;
  ta_notification_users_aggregate?: InputMaybe<Ta_Notification_User_Aggregate_Bool_Exp>;
  ta_rule_notification?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
  ta_rule_notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_sensor?: InputMaybe<Ta_Sensor_Bool_Exp>;
  variables?: InputMaybe<Jsonb_Comparison_Exp>;
  view_user_residents?: InputMaybe<View_User_Residents_Bool_Exp>;
};

/** columns and relationships of "ta_notification_log" */
export type Ta_Notification_Log = {
  __typename?: 'ta_notification_log';
  id: Scalars['uuid']['output'];
  notification_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  ta_notification?: Maybe<Ta_Notification>;
  /** An object relationship */
  ta_notification_log_type: Ta_Notification_Log_Type;
  /** An object relationship */
  ta_user: Ta_User;
  /** An object relationship */
  ta_user_device_token?: Maybe<Ta_User_Device_Tokens>;
  type?: Maybe<Scalars['NotificationLogType']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_device_token_id?: Maybe<Scalars['uuid']['output']>;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "ta_notification_log" */
export type Ta_Notification_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Notification_Log_Max_Order_By>;
  min?: InputMaybe<Ta_Notification_Log_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_notification_log". All fields are combined with a logical 'AND'. */
export type Ta_Notification_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Notification_Log_Bool_Exp>>;
  _not?: InputMaybe<Ta_Notification_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Notification_Log_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_notification?: InputMaybe<Ta_Notification_Bool_Exp>;
  ta_notification_log_type?: InputMaybe<Ta_Notification_Log_Type_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  ta_user_device_token?: InputMaybe<Ta_User_Device_Tokens_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_device_token_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "ta_notification_log" */
export type Ta_Notification_Log_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_device_token_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_notification_log" */
export type Ta_Notification_Log_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_device_token_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_notification_log". */
export type Ta_Notification_Log_Order_By = {
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  ta_notification?: InputMaybe<Ta_Notification_Order_By>;
  ta_notification_log_type?: InputMaybe<Ta_Notification_Log_Type_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  ta_user_device_token?: InputMaybe<Ta_User_Device_Tokens_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_device_token_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "ta_notification_log" */
export enum Ta_Notification_Log_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserDeviceTokenId = 'user_device_token_id',
  /** column name */
  UserId = 'user_id'
}

export type Ta_Notification_Log_Set_Input = {
  __typename?: 'ta_notification_log_set_input';
  type?: Maybe<Scalars['NotificationLogType']['output']>;
};

/** Streaming cursor of the table "ta_notification_log" */
export type Ta_Notification_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Notification_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Notification_Log_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['NotificationLogType']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_device_token_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "ta_notification_log_type" */
export type Ta_Notification_Log_Type = {
  __typename?: 'ta_notification_log_type';
  comment: Scalars['String']['output'];
  /** An array relationship */
  ta_notification_logs: Array<Ta_Notification_Log>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "ta_notification_log_type" */
export type Ta_Notification_Log_TypeTa_Notification_LogsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Log_Order_By>>;
  where?: InputMaybe<Ta_Notification_Log_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ta_notification_log_type". All fields are combined with a logical 'AND'. */
export type Ta_Notification_Log_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Notification_Log_Type_Bool_Exp>>;
  _not?: InputMaybe<Ta_Notification_Log_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Notification_Log_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  ta_notification_logs?: InputMaybe<Ta_Notification_Log_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "ta_notification_log_type". */
export type Ta_Notification_Log_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  ta_notification_logs_aggregate?: InputMaybe<Ta_Notification_Log_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "ta_notification_log_type" */
export enum Ta_Notification_Log_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "ta_notification_log_type" */
export type Ta_Notification_Log_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Notification_Log_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Notification_Log_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Ta_Notification_Max_Fields = {
  __typename?: 'ta_notification_max_fields';
  checked?: Maybe<Scalars['timestamp']['output']>;
  citizen_id?: Maybe<Scalars['uuid']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  follow_up_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  notification_text?: Maybe<Scalars['String']['output']>;
  processed_at?: Maybe<Scalars['timestamptz']['output']>;
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  ta_rule_notification_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "ta_notification" */
export type Ta_Notification_Max_Order_By = {
  checked?: InputMaybe<Order_By>;
  citizen_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  follow_up_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  notification_text?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  ta_rule_notification_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ta_Notification_Min_Fields = {
  __typename?: 'ta_notification_min_fields';
  checked?: Maybe<Scalars['timestamp']['output']>;
  citizen_id?: Maybe<Scalars['uuid']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  follow_up_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  notification_text?: Maybe<Scalars['String']['output']>;
  processed_at?: Maybe<Scalars['timestamptz']['output']>;
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  ta_rule_notification_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "ta_notification" */
export type Ta_Notification_Min_Order_By = {
  checked?: InputMaybe<Order_By>;
  citizen_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  follow_up_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  notification_text?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  ta_rule_notification_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ta_notification_notes" */
export type Ta_Notification_Notes = {
  __typename?: 'ta_notification_notes';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  note: Scalars['String']['output'];
  notification_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_notification: Ta_Notification;
  /** An object relationship */
  ta_user: Ta_User;
  /** An array relationship */
  ta_user_organisations: Array<Ta_User_Organisation>;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "ta_notification_notes" */
export type Ta_Notification_NotesTa_User_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};

/** order by aggregate values of table "ta_notification_notes" */
export type Ta_Notification_Notes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Notification_Notes_Max_Order_By>;
  min?: InputMaybe<Ta_Notification_Notes_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_notification_notes". All fields are combined with a logical 'AND'. */
export type Ta_Notification_Notes_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Notification_Notes_Bool_Exp>>;
  _not?: InputMaybe<Ta_Notification_Notes_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Notification_Notes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_notification?: InputMaybe<Ta_Notification_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  ta_user_organisations?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_notification_notes" */
export enum Ta_Notification_Notes_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaNotificationNotesPkey = 'ta_notification_notes_pkey'
}

/** input type for inserting data into table "ta_notification_notes" */
export type Ta_Notification_Notes_Insert_Input = {
  note?: InputMaybe<Scalars['String']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_user_organisations?: InputMaybe<Ta_User_Organisation_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "ta_notification_notes" */
export type Ta_Notification_Notes_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_notification_notes" */
export type Ta_Notification_Notes_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_notification_notes" */
export type Ta_Notification_Notes_Mutation_Response = {
  __typename?: 'ta_notification_notes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Notification_Notes>;
};

/** on_conflict condition type for table "ta_notification_notes" */
export type Ta_Notification_Notes_On_Conflict = {
  constraint: Ta_Notification_Notes_Constraint;
  update_columns?: Array<Ta_Notification_Notes_Update_Column>;
  where?: InputMaybe<Ta_Notification_Notes_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_notification_notes". */
export type Ta_Notification_Notes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  ta_notification?: InputMaybe<Ta_Notification_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  ta_user_organisations_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "ta_notification_notes" */
export enum Ta_Notification_Notes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "ta_notification_notes" */
export type Ta_Notification_Notes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Notification_Notes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Notification_Notes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "ta_notification_notes" (current role has no relevant permissions) */
export enum Ta_Notification_Notes_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** Ordering options when selecting data from "ta_notification". */
export type Ta_Notification_Order_By = {
  checked?: InputMaybe<Order_By>;
  citizen_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  follow_up_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  notification_text?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  ta_citizen?: InputMaybe<Ta_Citizen_Order_By>;
  ta_notification_logs_aggregate?: InputMaybe<Ta_Notification_Log_Aggregate_Order_By>;
  ta_notification_notes_aggregate?: InputMaybe<Ta_Notification_Notes_Aggregate_Order_By>;
  ta_notification_reminders_aggregate?: InputMaybe<Ta_Notification_Reminder_Aggregate_Order_By>;
  ta_notification_users_aggregate?: InputMaybe<Ta_Notification_User_Aggregate_Order_By>;
  ta_rule_notification?: InputMaybe<Ta_Rule_Notification_Order_By>;
  ta_rule_notification_id?: InputMaybe<Order_By>;
  ta_sensor?: InputMaybe<Ta_Sensor_Order_By>;
  variables?: InputMaybe<Order_By>;
  view_user_residents_aggregate?: InputMaybe<View_User_Residents_Aggregate_Order_By>;
};

/** columns and relationships of "ta_notification_reminder" */
export type Ta_Notification_Reminder = {
  __typename?: 'ta_notification_reminder';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_notification: Ta_Notification;
  ta_notification_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "ta_notification_reminder" */
export type Ta_Notification_Reminder_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Notification_Reminder_Max_Order_By>;
  min?: InputMaybe<Ta_Notification_Reminder_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_notification_reminder". All fields are combined with a logical 'AND'. */
export type Ta_Notification_Reminder_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Notification_Reminder_Bool_Exp>>;
  _not?: InputMaybe<Ta_Notification_Reminder_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Notification_Reminder_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_notification?: InputMaybe<Ta_Notification_Bool_Exp>;
  ta_notification_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "ta_notification_reminder" */
export type Ta_Notification_Reminder_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ta_notification_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_notification_reminder" */
export type Ta_Notification_Reminder_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ta_notification_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_notification_reminder". */
export type Ta_Notification_Reminder_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ta_notification?: InputMaybe<Ta_Notification_Order_By>;
  ta_notification_id?: InputMaybe<Order_By>;
};

/** select columns of table "ta_notification_reminder" */
export enum Ta_Notification_Reminder_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TaNotificationId = 'ta_notification_id'
}

/** Streaming cursor of the table "ta_notification_reminder" */
export type Ta_Notification_Reminder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Notification_Reminder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Notification_Reminder_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ta_notification_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** select columns of table "ta_notification" */
export enum Ta_Notification_Select_Column {
  /** column name */
  Checked = 'checked',
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  Comment = 'comment',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FollowUpAt = 'follow_up_at',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  NotificationText = 'notification_text',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  TaRuleNotificationId = 'ta_rule_notification_id',
  /** column name */
  Variables = 'variables'
}

export type Ta_Notification_Set_Input = {
  __typename?: 'ta_notification_set_input';
  config?: Maybe<Scalars['RuleConfig']['output']>;
  variables?: Maybe<Scalars['NotificationVariables']['output']>;
};

/** Streaming cursor of the table "ta_notification" */
export type Ta_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Notification_Stream_Cursor_Value_Input = {
  checked?: InputMaybe<Scalars['timestamp']['input']>;
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['RuleConfig']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  follow_up_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notification_text?: InputMaybe<Scalars['String']['input']>;
  processed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_rule_notification_id?: InputMaybe<Scalars['uuid']['input']>;
  variables?: InputMaybe<Scalars['NotificationVariables']['input']>;
};

/** columns and relationships of "ta_notification_user" */
export type Ta_Notification_User = {
  __typename?: 'ta_notification_user';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  accepted_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  all_ta_users: Array<Ta_Notification_User>;
  /** An aggregate relationship */
  all_ta_users_aggregate: Ta_Notification_User_Aggregate;
  escalation_level?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  notification_id: Scalars['uuid']['output'];
  state?: Maybe<Scalars['NotificationUserState']['output']>;
  state_updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  ta_notification: Ta_Notification;
  /** An object relationship */
  ta_user: Ta_User;
  updated_at: Scalars['timestamp']['output'];
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "ta_notification_user" */
export type Ta_Notification_UserAll_Ta_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Notification_User_Bool_Exp>;
};


/** columns and relationships of "ta_notification_user" */
export type Ta_Notification_UserAll_Ta_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Notification_User_Bool_Exp>;
};

/** aggregated selection of "ta_notification_user" */
export type Ta_Notification_User_Aggregate = {
  __typename?: 'ta_notification_user_aggregate';
  aggregate?: Maybe<Ta_Notification_User_Aggregate_Fields>;
  nodes: Array<Ta_Notification_User>;
};

export type Ta_Notification_User_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ta_Notification_User_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ta_Notification_User_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ta_Notification_User_Aggregate_Bool_Exp_Count>;
};

export type Ta_Notification_User_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ta_Notification_User_Select_Column_Ta_Notification_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ta_Notification_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ta_Notification_User_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ta_Notification_User_Select_Column_Ta_Notification_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ta_Notification_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ta_Notification_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ta_Notification_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ta_notification_user" */
export type Ta_Notification_User_Aggregate_Fields = {
  __typename?: 'ta_notification_user_aggregate_fields';
  avg?: Maybe<Ta_Notification_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ta_Notification_User_Max_Fields>;
  min?: Maybe<Ta_Notification_User_Min_Fields>;
  stddev?: Maybe<Ta_Notification_User_Stddev_Fields>;
  stddev_pop?: Maybe<Ta_Notification_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ta_Notification_User_Stddev_Samp_Fields>;
  sum?: Maybe<Ta_Notification_User_Sum_Fields>;
  var_pop?: Maybe<Ta_Notification_User_Var_Pop_Fields>;
  var_samp?: Maybe<Ta_Notification_User_Var_Samp_Fields>;
  variance?: Maybe<Ta_Notification_User_Variance_Fields>;
};


/** aggregate fields of "ta_notification_user" */
export type Ta_Notification_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ta_notification_user" */
export type Ta_Notification_User_Aggregate_Order_By = {
  avg?: InputMaybe<Ta_Notification_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Notification_User_Max_Order_By>;
  min?: InputMaybe<Ta_Notification_User_Min_Order_By>;
  stddev?: InputMaybe<Ta_Notification_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ta_Notification_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ta_Notification_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ta_Notification_User_Sum_Order_By>;
  var_pop?: InputMaybe<Ta_Notification_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ta_Notification_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Ta_Notification_User_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ta_Notification_User_Avg_Fields = {
  __typename?: 'ta_notification_user_avg_fields';
  escalation_level?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ta_notification_user" */
export type Ta_Notification_User_Avg_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ta_notification_user". All fields are combined with a logical 'AND'. */
export type Ta_Notification_User_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Notification_User_Bool_Exp>>;
  _not?: InputMaybe<Ta_Notification_User_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Notification_User_Bool_Exp>>;
  accepted?: InputMaybe<Boolean_Comparison_Exp>;
  accepted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  all_ta_users?: InputMaybe<Ta_Notification_User_Bool_Exp>;
  all_ta_users_aggregate?: InputMaybe<Ta_Notification_User_Aggregate_Bool_Exp>;
  escalation_level?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  ta_notification?: InputMaybe<Ta_Notification_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ta_Notification_User_Max_Fields = {
  __typename?: 'ta_notification_user_max_fields';
  accepted_at?: Maybe<Scalars['timestamp']['output']>;
  escalation_level?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_updated_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "ta_notification_user" */
export type Ta_Notification_User_Max_Order_By = {
  accepted_at?: InputMaybe<Order_By>;
  escalation_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_updated_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ta_Notification_User_Min_Fields = {
  __typename?: 'ta_notification_user_min_fields';
  accepted_at?: Maybe<Scalars['timestamp']['output']>;
  escalation_level?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notification_id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_updated_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "ta_notification_user" */
export type Ta_Notification_User_Min_Order_By = {
  accepted_at?: InputMaybe<Order_By>;
  escalation_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_updated_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_notification_user" */
export type Ta_Notification_User_Mutation_Response = {
  __typename?: 'ta_notification_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Notification_User>;
};

/** Ordering options when selecting data from "ta_notification_user". */
export type Ta_Notification_User_Order_By = {
  accepted?: InputMaybe<Order_By>;
  accepted_at?: InputMaybe<Order_By>;
  all_ta_users_aggregate?: InputMaybe<Ta_Notification_User_Aggregate_Order_By>;
  escalation_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_updated_at?: InputMaybe<Order_By>;
  ta_notification?: InputMaybe<Ta_Notification_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_notification_user */
export type Ta_Notification_User_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_notification_user" */
export enum Ta_Notification_User_Select_Column {
  /** column name */
  Accepted = 'accepted',
  /** column name */
  AcceptedAt = 'accepted_at',
  /** column name */
  EscalationLevel = 'escalation_level',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  State = 'state',
  /** column name */
  StateUpdatedAt = 'state_updated_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "ta_notification_user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ta_notification_user" */
export enum Ta_Notification_User_Select_Column_Ta_Notification_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Accepted = 'accepted'
}

/** select "ta_notification_user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ta_notification_user" */
export enum Ta_Notification_User_Select_Column_Ta_Notification_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Accepted = 'accepted'
}

/** input type for updating data in table "ta_notification_user" */
export type Ta_Notification_User_Set_Input = {
  __typename?: 'ta_notification_user_set_input';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  accepted_at?: Maybe<Scalars['timestamp']['output']>;
  state?: Maybe<Scalars['NotificationUserState']['output']>;
  state_updated_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate stddev on columns */
export type Ta_Notification_User_Stddev_Fields = {
  __typename?: 'ta_notification_user_stddev_fields';
  escalation_level?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ta_notification_user" */
export type Ta_Notification_User_Stddev_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ta_Notification_User_Stddev_Pop_Fields = {
  __typename?: 'ta_notification_user_stddev_pop_fields';
  escalation_level?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ta_notification_user" */
export type Ta_Notification_User_Stddev_Pop_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ta_Notification_User_Stddev_Samp_Fields = {
  __typename?: 'ta_notification_user_stddev_samp_fields';
  escalation_level?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ta_notification_user" */
export type Ta_Notification_User_Stddev_Samp_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ta_notification_user" */
export type Ta_Notification_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Notification_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Notification_User_Stream_Cursor_Value_Input = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  accepted_at?: InputMaybe<Scalars['timestamp']['input']>;
  escalation_level?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['NotificationUserState']['input']>;
  state_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Ta_Notification_User_Sum_Fields = {
  __typename?: 'ta_notification_user_sum_fields';
  escalation_level?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "ta_notification_user" */
export type Ta_Notification_User_Sum_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

export type Ta_Notification_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Notification_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Notification_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ta_Notification_User_Var_Pop_Fields = {
  __typename?: 'ta_notification_user_var_pop_fields';
  escalation_level?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ta_notification_user" */
export type Ta_Notification_User_Var_Pop_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ta_Notification_User_Var_Samp_Fields = {
  __typename?: 'ta_notification_user_var_samp_fields';
  escalation_level?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ta_notification_user" */
export type Ta_Notification_User_Var_Samp_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ta_Notification_User_Variance_Fields = {
  __typename?: 'ta_notification_user_variance_fields';
  escalation_level?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ta_notification_user" */
export type Ta_Notification_User_Variance_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

export type Ta_Operation_Mode = {
  __typename?: 'ta_operation_mode';
  view_template?: Maybe<Scalars['ta_operation_mode_view_template_type']['output']>;
};

export type Ta_Operation_Mode_Set_Input = {
  __typename?: 'ta_operation_mode_set_input';
  view_template?: Maybe<Scalars['ta_operation_mode_view_template_type']['output']>;
};

export type Ta_Operation_Mode_Stream_Cursor_Value_Input = {
  view_template?: InputMaybe<Scalars['ta_operation_mode_view_template_type']['input']>;
};

/** columns and relationships of "ta_operation_modes" */
export type Ta_Operation_Modes = {
  __typename?: 'ta_operation_modes';
  default: Scalars['Boolean']['output'];
  fixed_location?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  manufacturer: Scalars['String']['output'];
  model_identifier: Scalars['String']['output'];
  operation_mode: Scalars['String']['output'];
  view_template?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "ta_operation_modes" */
export type Ta_Operation_ModesView_TemplateArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "ta_operation_modes". All fields are combined with a logical 'AND'. */
export type Ta_Operation_Modes_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Operation_Modes_Bool_Exp>>;
  _not?: InputMaybe<Ta_Operation_Modes_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Operation_Modes_Bool_Exp>>;
  default?: InputMaybe<Boolean_Comparison_Exp>;
  fixed_location?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  model_identifier?: InputMaybe<String_Comparison_Exp>;
  operation_mode?: InputMaybe<String_Comparison_Exp>;
  view_template?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Ordering options when selecting data from "ta_operation_modes". */
export type Ta_Operation_Modes_Order_By = {
  default?: InputMaybe<Order_By>;
  fixed_location?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  model_identifier?: InputMaybe<Order_By>;
  operation_mode?: InputMaybe<Order_By>;
  view_template?: InputMaybe<Order_By>;
};

/** select columns of table "ta_operation_modes" */
export enum Ta_Operation_Modes_Select_Column {
  /** column name */
  Default = 'default',
  /** column name */
  FixedLocation = 'fixed_location',
  /** column name */
  Id = 'id',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  ModelIdentifier = 'model_identifier',
  /** column name */
  OperationMode = 'operation_mode',
  /** column name */
  ViewTemplate = 'view_template'
}

/** Streaming cursor of the table "ta_operation_modes" */
export type Ta_Operation_Modes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Operation_Modes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Operation_Modes_Stream_Cursor_Value_Input = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  fixed_location?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model_identifier?: InputMaybe<Scalars['String']['input']>;
  operation_mode?: InputMaybe<Scalars['String']['input']>;
  view_template?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "ta_organisation" */
export type Ta_Organisation = {
  __typename?: 'ta_organisation';
  address?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  config?: Maybe<Scalars['OrganisationConfig']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  organisation_timezone?: Maybe<Scalars['String']['output']>;
  parent_organisation_id?: Maybe<Scalars['uuid']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  restricted_config?: Maybe<Scalars['OrganisationRestrictedConfig']['output']>;
  session_timeout?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Ta_Organisation_Status_Enum>;
  supplier_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  ta_batch_history: Array<Ta_Batch_History>;
  /** An array relationship */
  ta_citizens: Array<Ta_Citizen>;
  /** An array relationship */
  ta_device_counts: Array<Ta_Device_Count>;
  /** An array relationship */
  ta_devices: Array<Ta_Device>;
  /** An array relationship */
  ta_floors: Array<Ta_Floors>;
  /** An array relationship */
  ta_gateways: Array<Ta_Gateway>;
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  /** An object relationship */
  ta_organisation_status?: Maybe<Ta_Organisation_Status>;
  /** An array relationship */
  ta_organisations: Array<Ta_Organisation>;
  /** An array relationship */
  ta_package_counts: Array<Ta_Package_Count>;
  /** An array relationship */
  ta_permissions: Array<Ta_Permission>;
  /** An array relationship */
  ta_rule_notifications: Array<Ta_Rule_Notification>;
  /** An array relationship */
  ta_scenario_counts: Array<Ta_Scenario_Count>;
  /** An object relationship */
  ta_supplier?: Maybe<Ta_Supplier>;
  /** An array relationship */
  ta_tags: Array<Ta_Tag>;
  /** An array relationship */
  ta_user_organisations: Array<Ta_User_Organisation>;
  /** An array relationship */
  ta_usergroups: Array<Ta_Usergroup>;
  /** An array relationship */
  ta_zones: Array<Ta_Zone>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_Batch_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Ta_Batch_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Batch_History_Order_By>>;
  where?: InputMaybe<Ta_Batch_History_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_CitizensArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_Device_CountsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Count_Order_By>>;
  where?: InputMaybe<Ta_Device_Count_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Order_By>>;
  where?: InputMaybe<Ta_Device_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_FloorsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Floors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Floors_Order_By>>;
  where?: InputMaybe<Ta_Floors_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_GatewaysArgs = {
  distinct_on?: InputMaybe<Array<Ta_Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Gateway_Order_By>>;
  where?: InputMaybe<Ta_Gateway_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Organisation_Order_By>>;
  where?: InputMaybe<Ta_Organisation_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_Package_CountsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Package_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Package_Count_Order_By>>;
  where?: InputMaybe<Ta_Package_Count_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Permission_Order_By>>;
  where?: InputMaybe<Ta_Permission_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_Rule_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Rule_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Rule_Notification_Order_By>>;
  where?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_Scenario_CountsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Scenario_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Scenario_Count_Order_By>>;
  where?: InputMaybe<Ta_Scenario_Count_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_TagsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Order_By>>;
  where?: InputMaybe<Ta_Tag_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_User_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_UsergroupsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_Bool_Exp>;
};


/** columns and relationships of "ta_organisation" */
export type Ta_OrganisationTa_ZonesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Zone_Order_By>>;
  where?: InputMaybe<Ta_Zone_Bool_Exp>;
};

/** order by aggregate values of table "ta_organisation" */
export type Ta_Organisation_Aggregate_Order_By = {
  avg?: InputMaybe<Ta_Organisation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Organisation_Max_Order_By>;
  min?: InputMaybe<Ta_Organisation_Min_Order_By>;
  stddev?: InputMaybe<Ta_Organisation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ta_Organisation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ta_Organisation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ta_Organisation_Sum_Order_By>;
  var_pop?: InputMaybe<Ta_Organisation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ta_Organisation_Var_Samp_Order_By>;
  variance?: InputMaybe<Ta_Organisation_Variance_Order_By>;
};

/** order by avg() on columns of table "ta_organisation" */
export type Ta_Organisation_Avg_Order_By = {
  session_timeout?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ta_organisation". All fields are combined with a logical 'AND'. */
export type Ta_Organisation_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Organisation_Bool_Exp>>;
  _not?: InputMaybe<Ta_Organisation_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Organisation_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  organisation_timezone?: InputMaybe<String_Comparison_Exp>;
  parent_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  session_timeout?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Ta_Organisation_Status_Enum_Comparison_Exp>;
  supplier_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_batch_history?: InputMaybe<Ta_Batch_History_Bool_Exp>;
  ta_citizens?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_device_counts?: InputMaybe<Ta_Device_Count_Bool_Exp>;
  ta_devices?: InputMaybe<Ta_Device_Bool_Exp>;
  ta_floors?: InputMaybe<Ta_Floors_Bool_Exp>;
  ta_gateways?: InputMaybe<Ta_Gateway_Bool_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_organisation_status?: InputMaybe<Ta_Organisation_Status_Bool_Exp>;
  ta_organisations?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_package_counts?: InputMaybe<Ta_Package_Count_Bool_Exp>;
  ta_permissions?: InputMaybe<Ta_Permission_Bool_Exp>;
  ta_rule_notifications?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
  ta_scenario_counts?: InputMaybe<Ta_Scenario_Count_Bool_Exp>;
  ta_supplier?: InputMaybe<Ta_Supplier_Bool_Exp>;
  ta_tags?: InputMaybe<Ta_Tag_Bool_Exp>;
  ta_user_organisations?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  ta_usergroups?: InputMaybe<Ta_Usergroup_Bool_Exp>;
  ta_zones?: InputMaybe<Ta_Zone_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "ta_organisation" */
export type Ta_Organisation_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organisation_timezone?: InputMaybe<Order_By>;
  parent_organisation_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  session_timeout?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_organisation" */
export type Ta_Organisation_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organisation_timezone?: InputMaybe<Order_By>;
  parent_organisation_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  session_timeout?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_organisation". */
export type Ta_Organisation_Order_By = {
  address?: InputMaybe<Order_By>;
  archived?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organisation_timezone?: InputMaybe<Order_By>;
  parent_organisation_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  session_timeout?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  ta_batch_history_aggregate?: InputMaybe<Ta_Batch_History_Aggregate_Order_By>;
  ta_citizens_aggregate?: InputMaybe<Ta_Citizen_Aggregate_Order_By>;
  ta_device_counts_aggregate?: InputMaybe<Ta_Device_Count_Aggregate_Order_By>;
  ta_devices_aggregate?: InputMaybe<Ta_Device_Aggregate_Order_By>;
  ta_floors_aggregate?: InputMaybe<Ta_Floors_Aggregate_Order_By>;
  ta_gateways_aggregate?: InputMaybe<Ta_Gateway_Aggregate_Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_organisation_status?: InputMaybe<Ta_Organisation_Status_Order_By>;
  ta_organisations_aggregate?: InputMaybe<Ta_Organisation_Aggregate_Order_By>;
  ta_package_counts_aggregate?: InputMaybe<Ta_Package_Count_Aggregate_Order_By>;
  ta_permissions_aggregate?: InputMaybe<Ta_Permission_Aggregate_Order_By>;
  ta_rule_notifications_aggregate?: InputMaybe<Ta_Rule_Notification_Aggregate_Order_By>;
  ta_scenario_counts_aggregate?: InputMaybe<Ta_Scenario_Count_Aggregate_Order_By>;
  ta_supplier?: InputMaybe<Ta_Supplier_Order_By>;
  ta_tags_aggregate?: InputMaybe<Ta_Tag_Aggregate_Order_By>;
  ta_user_organisations_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  ta_usergroups_aggregate?: InputMaybe<Ta_Usergroup_Aggregate_Order_By>;
  ta_zones_aggregate?: InputMaybe<Ta_Zone_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ta_organisation" */
export enum Ta_Organisation_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Archived = 'archived',
  /** column name */
  Config = 'config',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganisationTimezone = 'organisation_timezone',
  /** column name */
  ParentOrganisationId = 'parent_organisation_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  SessionTimeout = 'session_timeout',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierId = 'supplier_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ta_Organisation_Set_Input = {
  __typename?: 'ta_organisation_set_input';
  config?: Maybe<Scalars['OrganisationConfig']['output']>;
  restricted_config?: Maybe<Scalars['OrganisationRestrictedConfig']['output']>;
};

/** columns and relationships of "ta_organisation_status" */
export type Ta_Organisation_Status = {
  __typename?: 'ta_organisation_status';
  comment: Scalars['String']['output'];
  /** An array relationship */
  ta_organisations: Array<Ta_Organisation>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "ta_organisation_status" */
export type Ta_Organisation_StatusTa_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Organisation_Order_By>>;
  where?: InputMaybe<Ta_Organisation_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ta_organisation_status". All fields are combined with a logical 'AND'. */
export type Ta_Organisation_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Organisation_Status_Bool_Exp>>;
  _not?: InputMaybe<Ta_Organisation_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Organisation_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  ta_organisations?: InputMaybe<Ta_Organisation_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Ta_Organisation_Status_Enum {
  /** Organisation stopped using our solution. */
  Churn = 'CHURN',
  /** Is implemented in home, but not a paying customer */
  Onboarding = 'ONBOARDING',
  /** Is implemented in home and is a paying customer */
  Signed = 'SIGNED',
  /** developer are testing, not important */
  Test = 'TEST'
}

/** Boolean expression to compare columns of type "ta_organisation_status_enum". All fields are combined with logical 'AND'. */
export type Ta_Organisation_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ta_Organisation_Status_Enum>;
  _in?: InputMaybe<Array<Ta_Organisation_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Ta_Organisation_Status_Enum>;
  _nin?: InputMaybe<Array<Ta_Organisation_Status_Enum>>;
};

/** Ordering options when selecting data from "ta_organisation_status". */
export type Ta_Organisation_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  ta_organisations_aggregate?: InputMaybe<Ta_Organisation_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "ta_organisation_status" */
export enum Ta_Organisation_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "ta_organisation_status" */
export type Ta_Organisation_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Organisation_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Organisation_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "ta_organisation" */
export type Ta_Organisation_Stddev_Order_By = {
  session_timeout?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ta_organisation" */
export type Ta_Organisation_Stddev_Pop_Order_By = {
  session_timeout?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ta_organisation" */
export type Ta_Organisation_Stddev_Samp_Order_By = {
  session_timeout?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ta_organisation" */
export type Ta_Organisation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Organisation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Organisation_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['OrganisationConfig']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organisation_timezone?: InputMaybe<Scalars['String']['input']>;
  parent_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  restricted_config?: InputMaybe<Scalars['OrganisationRestrictedConfig']['input']>;
  session_timeout?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Ta_Organisation_Status_Enum>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "ta_organisation" */
export type Ta_Organisation_Sum_Order_By = {
  session_timeout?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ta_organisation" */
export type Ta_Organisation_Var_Pop_Order_By = {
  session_timeout?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ta_organisation" */
export type Ta_Organisation_Var_Samp_Order_By = {
  session_timeout?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ta_organisation" */
export type Ta_Organisation_Variance_Order_By = {
  session_timeout?: InputMaybe<Order_By>;
};

/** columns and relationships of "ta_package" */
export type Ta_Package = {
  __typename?: 'ta_package';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  /** An array relationship */
  taPackageOverridesByOverridingPackageId: Array<Ta_Package_Overrides>;
  /** An array relationship */
  ta_package_counts: Array<Ta_Package_Count>;
  /** An array relationship */
  ta_package_overrides: Array<Ta_Package_Overrides>;
  /** An array relationship */
  ta_tag_packages: Array<Ta_Tag_Package>;
};


/** columns and relationships of "ta_package" */
export type Ta_PackageTaPackageOverridesByOverridingPackageIdArgs = {
  distinct_on?: InputMaybe<Array<Ta_Package_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Package_Overrides_Order_By>>;
  where?: InputMaybe<Ta_Package_Overrides_Bool_Exp>;
};


/** columns and relationships of "ta_package" */
export type Ta_PackageTa_Package_CountsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Package_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Package_Count_Order_By>>;
  where?: InputMaybe<Ta_Package_Count_Bool_Exp>;
};


/** columns and relationships of "ta_package" */
export type Ta_PackageTa_Package_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Package_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Package_Overrides_Order_By>>;
  where?: InputMaybe<Ta_Package_Overrides_Bool_Exp>;
};


/** columns and relationships of "ta_package" */
export type Ta_PackageTa_Tag_PackagesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Package_Order_By>>;
  where?: InputMaybe<Ta_Tag_Package_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ta_package". All fields are combined with a logical 'AND'. */
export type Ta_Package_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Package_Bool_Exp>>;
  _not?: InputMaybe<Ta_Package_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Package_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  taPackageOverridesByOverridingPackageId?: InputMaybe<Ta_Package_Overrides_Bool_Exp>;
  ta_package_counts?: InputMaybe<Ta_Package_Count_Bool_Exp>;
  ta_package_overrides?: InputMaybe<Ta_Package_Overrides_Bool_Exp>;
  ta_tag_packages?: InputMaybe<Ta_Tag_Package_Bool_Exp>;
};

/** columns and relationships of "ta_package_count" */
export type Ta_Package_Count = {
  __typename?: 'ta_package_count';
  affected_at: Scalars['timestamp']['output'];
  count: Scalars['numeric']['output'];
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  organisation_id: Scalars['uuid']['output'];
  package_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_organisation: Ta_Organisation;
  /** An object relationship */
  ta_package: Ta_Package;
  /** An array relationship */
  ta_scenario_counts: Array<Ta_Scenario_Count>;
};


/** columns and relationships of "ta_package_count" */
export type Ta_Package_CountTa_Scenario_CountsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Scenario_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Scenario_Count_Order_By>>;
  where?: InputMaybe<Ta_Scenario_Count_Bool_Exp>;
};

/** order by aggregate values of table "ta_package_count" */
export type Ta_Package_Count_Aggregate_Order_By = {
  avg?: InputMaybe<Ta_Package_Count_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Package_Count_Max_Order_By>;
  min?: InputMaybe<Ta_Package_Count_Min_Order_By>;
  stddev?: InputMaybe<Ta_Package_Count_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ta_Package_Count_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ta_Package_Count_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ta_Package_Count_Sum_Order_By>;
  var_pop?: InputMaybe<Ta_Package_Count_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ta_Package_Count_Var_Samp_Order_By>;
  variance?: InputMaybe<Ta_Package_Count_Variance_Order_By>;
};

/** order by avg() on columns of table "ta_package_count" */
export type Ta_Package_Count_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ta_package_count". All fields are combined with a logical 'AND'. */
export type Ta_Package_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Package_Count_Bool_Exp>>;
  _not?: InputMaybe<Ta_Package_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Package_Count_Bool_Exp>>;
  affected_at?: InputMaybe<Timestamp_Comparison_Exp>;
  count?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  package_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_package?: InputMaybe<Ta_Package_Bool_Exp>;
  ta_scenario_counts?: InputMaybe<Ta_Scenario_Count_Bool_Exp>;
};

/** order by max() on columns of table "ta_package_count" */
export type Ta_Package_Count_Max_Order_By = {
  affected_at?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_package_count" */
export type Ta_Package_Count_Min_Order_By = {
  affected_at?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_package_count". */
export type Ta_Package_Count_Order_By = {
  affected_at?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_package?: InputMaybe<Ta_Package_Order_By>;
  ta_scenario_counts_aggregate?: InputMaybe<Ta_Scenario_Count_Aggregate_Order_By>;
};

/** select columns of table "ta_package_count" */
export enum Ta_Package_Count_Select_Column {
  /** column name */
  AffectedAt = 'affected_at',
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PackageId = 'package_id'
}

/** order by stddev() on columns of table "ta_package_count" */
export type Ta_Package_Count_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ta_package_count" */
export type Ta_Package_Count_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ta_package_count" */
export type Ta_Package_Count_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ta_package_count" */
export type Ta_Package_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Package_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Package_Count_Stream_Cursor_Value_Input = {
  affected_at?: InputMaybe<Scalars['timestamp']['input']>;
  count?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  package_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "ta_package_count" */
export type Ta_Package_Count_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ta_package_count" */
export type Ta_Package_Count_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ta_package_count" */
export type Ta_Package_Count_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ta_package_count" */
export type Ta_Package_Count_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_package". */
export type Ta_Package_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  taPackageOverridesByOverridingPackageId_aggregate?: InputMaybe<Ta_Package_Overrides_Aggregate_Order_By>;
  ta_package_counts_aggregate?: InputMaybe<Ta_Package_Count_Aggregate_Order_By>;
  ta_package_overrides_aggregate?: InputMaybe<Ta_Package_Overrides_Aggregate_Order_By>;
  ta_tag_packages_aggregate?: InputMaybe<Ta_Tag_Package_Aggregate_Order_By>;
};

/** columns and relationships of "ta_package_overrides" */
export type Ta_Package_Overrides = {
  __typename?: 'ta_package_overrides';
  id: Scalars['uuid']['output'];
  overridden_package_id: Scalars['uuid']['output'];
  overriding_package_id: Scalars['uuid']['output'];
  /** An object relationship */
  taPackageByOverridingPackageId: Ta_Package;
  /** An object relationship */
  ta_package: Ta_Package;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "ta_package_overrides" */
export type Ta_Package_Overrides_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Package_Overrides_Max_Order_By>;
  min?: InputMaybe<Ta_Package_Overrides_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_package_overrides". All fields are combined with a logical 'AND'. */
export type Ta_Package_Overrides_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Package_Overrides_Bool_Exp>>;
  _not?: InputMaybe<Ta_Package_Overrides_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Package_Overrides_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  overridden_package_id?: InputMaybe<Uuid_Comparison_Exp>;
  overriding_package_id?: InputMaybe<Uuid_Comparison_Exp>;
  taPackageByOverridingPackageId?: InputMaybe<Ta_Package_Bool_Exp>;
  ta_package?: InputMaybe<Ta_Package_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "ta_package_overrides" */
export type Ta_Package_Overrides_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  overridden_package_id?: InputMaybe<Order_By>;
  overriding_package_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_package_overrides" */
export type Ta_Package_Overrides_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  overridden_package_id?: InputMaybe<Order_By>;
  overriding_package_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_package_overrides". */
export type Ta_Package_Overrides_Order_By = {
  id?: InputMaybe<Order_By>;
  overridden_package_id?: InputMaybe<Order_By>;
  overriding_package_id?: InputMaybe<Order_By>;
  taPackageByOverridingPackageId?: InputMaybe<Ta_Package_Order_By>;
  ta_package?: InputMaybe<Ta_Package_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ta_package_overrides" */
export enum Ta_Package_Overrides_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OverriddenPackageId = 'overridden_package_id',
  /** column name */
  OverridingPackageId = 'overriding_package_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "ta_package_overrides" */
export type Ta_Package_Overrides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Package_Overrides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Package_Overrides_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  overridden_package_id?: InputMaybe<Scalars['uuid']['input']>;
  overriding_package_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** select columns of table "ta_package" */
export enum Ta_Package_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Priority = 'priority'
}

/** Streaming cursor of the table "ta_package" */
export type Ta_Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Package_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "ta_permission" */
export type Ta_Permission = {
  __typename?: 'ta_permission';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_organisation: Ta_Organisation;
  /** An object relationship */
  ta_permission_type: Ta_Permission_Type;
  /** An object relationship */
  ta_user?: Maybe<Ta_User>;
  /** An object relationship */
  ta_user_organisation?: Maybe<Ta_User_Organisation>;
  type: Ta_Permission_Type_Enum;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "ta_permission" */
export type Ta_Permission_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Permission_Max_Order_By>;
  min?: InputMaybe<Ta_Permission_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_permission". All fields are combined with a logical 'AND'. */
export type Ta_Permission_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Permission_Bool_Exp>>;
  _not?: InputMaybe<Ta_Permission_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Permission_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_permission_type?: InputMaybe<Ta_Permission_Type_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  ta_user_organisation?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  type?: InputMaybe<Ta_Permission_Type_Enum_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "ta_permission" */
export type Ta_Permission_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_permission" */
export type Ta_Permission_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_permission". */
export type Ta_Permission_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_permission_type?: InputMaybe<Ta_Permission_Type_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  ta_user_organisation?: InputMaybe<Ta_User_Organisation_Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "ta_permission" */
export enum Ta_Permission_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "ta_permission" */
export type Ta_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Permission_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Ta_Permission_Type_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "ta_permission_type" */
export type Ta_Permission_Type = {
  __typename?: 'ta_permission_type';
  description: Scalars['String']['output'];
  /** An array relationship */
  ta_permissions: Array<Ta_Permission>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "ta_permission_type" */
export type Ta_Permission_TypeTa_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Permission_Order_By>>;
  where?: InputMaybe<Ta_Permission_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ta_permission_type". All fields are combined with a logical 'AND'. */
export type Ta_Permission_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Permission_Type_Bool_Exp>>;
  _not?: InputMaybe<Ta_Permission_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Permission_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  ta_permissions?: InputMaybe<Ta_Permission_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Ta_Permission_Type_Enum {
  /** Access to the Subscription page: which packages the organisation subscribes to and their current counts. */
  Subscription = 'SUBSCRIPTION',
  /** Access to user insights: per-user readiness checks such as login state, recent activity and device system state. */
  UserInsight = 'USER_INSIGHT'
}

/** Boolean expression to compare columns of type "ta_permission_type_enum". All fields are combined with logical 'AND'. */
export type Ta_Permission_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ta_Permission_Type_Enum>;
  _in?: InputMaybe<Array<Ta_Permission_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Ta_Permission_Type_Enum>;
  _nin?: InputMaybe<Array<Ta_Permission_Type_Enum>>;
};

/** Ordering options when selecting data from "ta_permission_type". */
export type Ta_Permission_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  ta_permissions_aggregate?: InputMaybe<Ta_Permission_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "ta_permission_type" */
export enum Ta_Permission_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "ta_permission_type" */
export type Ta_Permission_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Permission_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Permission_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ta_personal_device" */
export type Ta_Personal_Device = {
  __typename?: 'ta_personal_device';
  created_at: Scalars['timestamptz']['output'];
  device_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_emulator: Scalars['Boolean']['output'];
  manufacturer: Scalars['String']['output'];
  model: Scalars['String']['output'];
  os_type: Scalars['String']['output'];
  os_version: Scalars['String']['output'];
  /** An array relationship */
  ta_personal_device_logs: Array<Ta_Personal_Device_Log>;
  /** An array relationship */
  ta_user_device_tokens: Array<Ta_User_Device_Tokens>;
};


/** columns and relationships of "ta_personal_device" */
export type Ta_Personal_DeviceTa_Personal_Device_LogsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Personal_Device_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Personal_Device_Log_Order_By>>;
  where?: InputMaybe<Ta_Personal_Device_Log_Bool_Exp>;
};


/** columns and relationships of "ta_personal_device" */
export type Ta_Personal_DeviceTa_User_Device_TokensArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Device_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Device_Tokens_Order_By>>;
  where?: InputMaybe<Ta_User_Device_Tokens_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ta_personal_device". All fields are combined with a logical 'AND'. */
export type Ta_Personal_Device_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Personal_Device_Bool_Exp>>;
  _not?: InputMaybe<Ta_Personal_Device_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Personal_Device_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_emulator?: InputMaybe<Boolean_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  os_type?: InputMaybe<String_Comparison_Exp>;
  os_version?: InputMaybe<String_Comparison_Exp>;
  ta_personal_device_logs?: InputMaybe<Ta_Personal_Device_Log_Bool_Exp>;
  ta_user_device_tokens?: InputMaybe<Ta_User_Device_Tokens_Bool_Exp>;
};

/** columns and relationships of "ta_personal_device_log" */
export type Ta_Personal_Device_Log = {
  __typename?: 'ta_personal_device_log';
  battery_level: Scalars['numeric']['output'];
  battery_optimization: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  notifications_allowed: Scalars['Boolean']['output'];
  personal_device_id: Scalars['uuid']['output'];
  ringer_mode?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ta_personal_device: Ta_Personal_Device;
  volume?: Maybe<Scalars['numeric']['output']>;
};

/** order by aggregate values of table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Ta_Personal_Device_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Personal_Device_Log_Max_Order_By>;
  min?: InputMaybe<Ta_Personal_Device_Log_Min_Order_By>;
  stddev?: InputMaybe<Ta_Personal_Device_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ta_Personal_Device_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ta_Personal_Device_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ta_Personal_Device_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Ta_Personal_Device_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ta_Personal_Device_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Ta_Personal_Device_Log_Variance_Order_By>;
};

/** order by avg() on columns of table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Avg_Order_By = {
  battery_level?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ta_personal_device_log". All fields are combined with a logical 'AND'. */
export type Ta_Personal_Device_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Personal_Device_Log_Bool_Exp>>;
  _not?: InputMaybe<Ta_Personal_Device_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Personal_Device_Log_Bool_Exp>>;
  battery_level?: InputMaybe<Numeric_Comparison_Exp>;
  battery_optimization?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notifications_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  personal_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  ringer_mode?: InputMaybe<String_Comparison_Exp>;
  ta_personal_device?: InputMaybe<Ta_Personal_Device_Bool_Exp>;
  volume?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_personal_device_log" */
export enum Ta_Personal_Device_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaPersonalDeviceLogPkey = 'ta_personal_device_log_pkey'
}

/** input type for inserting data into table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Insert_Input = {
  battery_level?: InputMaybe<Scalars['numeric']['input']>;
  battery_optimization?: InputMaybe<Scalars['Boolean']['input']>;
  notifications_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  personal_device_id?: InputMaybe<Scalars['uuid']['input']>;
  ringer_mode?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by max() on columns of table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Max_Order_By = {
  battery_level?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  personal_device_id?: InputMaybe<Order_By>;
  ringer_mode?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Min_Order_By = {
  battery_level?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  personal_device_id?: InputMaybe<Order_By>;
  ringer_mode?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Mutation_Response = {
  __typename?: 'ta_personal_device_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Personal_Device_Log>;
};

/** on_conflict condition type for table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_On_Conflict = {
  constraint: Ta_Personal_Device_Log_Constraint;
  update_columns?: Array<Ta_Personal_Device_Log_Update_Column>;
  where?: InputMaybe<Ta_Personal_Device_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_personal_device_log". */
export type Ta_Personal_Device_Log_Order_By = {
  battery_level?: InputMaybe<Order_By>;
  battery_optimization?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notifications_allowed?: InputMaybe<Order_By>;
  personal_device_id?: InputMaybe<Order_By>;
  ringer_mode?: InputMaybe<Order_By>;
  ta_personal_device?: InputMaybe<Ta_Personal_Device_Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "ta_personal_device_log" */
export enum Ta_Personal_Device_Log_Select_Column {
  /** column name */
  BatteryLevel = 'battery_level',
  /** column name */
  BatteryOptimization = 'battery_optimization',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationsAllowed = 'notifications_allowed',
  /** column name */
  PersonalDeviceId = 'personal_device_id',
  /** column name */
  RingerMode = 'ringer_mode',
  /** column name */
  Volume = 'volume'
}

/** order by stddev() on columns of table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Stddev_Order_By = {
  battery_level?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Stddev_Pop_Order_By = {
  battery_level?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Stddev_Samp_Order_By = {
  battery_level?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Personal_Device_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Personal_Device_Log_Stream_Cursor_Value_Input = {
  battery_level?: InputMaybe<Scalars['numeric']['input']>;
  battery_optimization?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notifications_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  personal_device_id?: InputMaybe<Scalars['uuid']['input']>;
  ringer_mode?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Sum_Order_By = {
  battery_level?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "ta_personal_device_log" (current role has no relevant permissions) */
export enum Ta_Personal_Device_Log_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Var_Pop_Order_By = {
  battery_level?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Var_Samp_Order_By = {
  battery_level?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ta_personal_device_log" */
export type Ta_Personal_Device_Log_Variance_Order_By = {
  battery_level?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_personal_device". */
export type Ta_Personal_Device_Order_By = {
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_emulator?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  os_type?: InputMaybe<Order_By>;
  os_version?: InputMaybe<Order_By>;
  ta_personal_device_logs_aggregate?: InputMaybe<Ta_Personal_Device_Log_Aggregate_Order_By>;
  ta_user_device_tokens_aggregate?: InputMaybe<Ta_User_Device_Tokens_Aggregate_Order_By>;
};

/** select columns of table "ta_personal_device" */
export enum Ta_Personal_Device_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsEmulator = 'is_emulator',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  Model = 'model',
  /** column name */
  OsType = 'os_type',
  /** column name */
  OsVersion = 'os_version'
}

/** Streaming cursor of the table "ta_personal_device" */
export type Ta_Personal_Device_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Personal_Device_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Personal_Device_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_emulator?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  os_type?: InputMaybe<Scalars['String']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ta_relationship_to_tag" */
export type Ta_Relationship_To_Tag = {
  __typename?: 'ta_relationship_to_tag';
  citizen_id?: Maybe<Scalars['uuid']['output']>;
  config?: Maybe<Scalars['ScenarioTagConfig']['output']>;
  created_at: Scalars['timestamptz']['output'];
  device_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  snooze_until?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  ta_citizen?: Maybe<Ta_Citizen>;
  /** An object relationship */
  ta_device?: Maybe<Ta_Device>;
  /** An object relationship */
  ta_sensor?: Maybe<Ta_Sensor>;
  /** An object relationship */
  ta_tag: Ta_Tag;
  /** An object relationship */
  ta_user?: Maybe<Ta_User>;
  tag_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by_userid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  view_tag_rule_config?: Maybe<View_Tag_Rule_Config>;
  /** An array relationship */
  view_user_resident: Array<View_User_Residents>;
};


/** columns and relationships of "ta_relationship_to_tag" */
export type Ta_Relationship_To_TagView_User_ResidentArgs = {
  distinct_on?: InputMaybe<Array<View_User_Residents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Residents_Order_By>>;
  where?: InputMaybe<View_User_Residents_Bool_Exp>;
};

/** order by aggregate values of table "ta_relationship_to_tag" */
export type Ta_Relationship_To_Tag_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Relationship_To_Tag_Max_Order_By>;
  min?: InputMaybe<Ta_Relationship_To_Tag_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ta_Relationship_To_Tag_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "ta_relationship_to_tag" */
export type Ta_Relationship_To_Tag_Arr_Rel_Insert_Input = {
  data: Array<Ta_Relationship_To_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Relationship_To_Tag_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_relationship_to_tag". All fields are combined with a logical 'AND'. */
export type Ta_Relationship_To_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Relationship_To_Tag_Bool_Exp>>;
  _not?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Relationship_To_Tag_Bool_Exp>>;
  citizen_id?: InputMaybe<Uuid_Comparison_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  snooze_until?: InputMaybe<Timestamp_Comparison_Exp>;
  ta_citizen?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_device?: InputMaybe<Ta_Device_Bool_Exp>;
  ta_sensor?: InputMaybe<Ta_Sensor_Bool_Exp>;
  ta_tag?: InputMaybe<Ta_Tag_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  tag_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_userid?: InputMaybe<Uuid_Comparison_Exp>;
  view_tag_rule_config?: InputMaybe<View_Tag_Rule_Config_Bool_Exp>;
  view_user_resident?: InputMaybe<View_User_Residents_Bool_Exp>;
};

/** unique or primary key constraints on table "ta_relationship_to_tag" */
export enum Ta_Relationship_To_Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaRelationshipToTagPkey = 'ta_relationship_to_tag_pkey',
  /** unique or primary key constraint on columns "tag_id", "citizen_id" */
  TaRelationshipToTagTagIdCitizenIdKey = 'ta_relationship_to_tag_tag_id_citizen_id_key',
  /** unique or primary key constraint on columns "tag_id", "device_id" */
  TaRelationshipToTagTagIdDeviceIdKey = 'ta_relationship_to_tag_tag_id_device_id_key',
  /** unique or primary key constraint on columns "tag_id", "sensor_id" */
  TaRelationshipToTagTagIdSensorIdKey = 'ta_relationship_to_tag_tag_id_sensor_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ta_Relationship_To_Tag_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ta_Relationship_To_Tag_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ta_Relationship_To_Tag_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "ta_relationship_to_tag" */
export type Ta_Relationship_To_Tag_Insert_Input = {
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  config?: InputMaybe<Scalars['jsonb']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  snooze_until?: InputMaybe<Scalars['timestamp']['input']>;
  ta_citizen?: InputMaybe<Ta_Citizen_Obj_Rel_Insert_Input>;
  ta_device?: InputMaybe<Ta_Device_Obj_Rel_Insert_Input>;
  ta_tag?: InputMaybe<Ta_Tag_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_userid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "ta_relationship_to_tag" */
export type Ta_Relationship_To_Tag_Max_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  snooze_until?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_relationship_to_tag" */
export type Ta_Relationship_To_Tag_Min_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  snooze_until?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_relationship_to_tag" */
export type Ta_Relationship_To_Tag_Mutation_Response = {
  __typename?: 'ta_relationship_to_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Relationship_To_Tag>;
};

/** on_conflict condition type for table "ta_relationship_to_tag" */
export type Ta_Relationship_To_Tag_On_Conflict = {
  constraint: Ta_Relationship_To_Tag_Constraint;
  update_columns?: Array<Ta_Relationship_To_Tag_Update_Column>;
  where?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_relationship_to_tag". */
export type Ta_Relationship_To_Tag_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  snooze_until?: InputMaybe<Order_By>;
  ta_citizen?: InputMaybe<Ta_Citizen_Order_By>;
  ta_device?: InputMaybe<Ta_Device_Order_By>;
  ta_sensor?: InputMaybe<Ta_Sensor_Order_By>;
  ta_tag?: InputMaybe<Ta_Tag_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
  view_tag_rule_config?: InputMaybe<View_Tag_Rule_Config_Order_By>;
  view_user_resident_aggregate?: InputMaybe<View_User_Residents_Aggregate_Order_By>;
};

/** primary key columns input for table: ta_relationship_to_tag */
export type Ta_Relationship_To_Tag_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ta_Relationship_To_Tag_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ta_relationship_to_tag" */
export enum Ta_Relationship_To_Tag_Select_Column {
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  SnoozeUntil = 'snooze_until',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserid = 'updated_by_userid'
}

/** input type for updating data in table "ta_relationship_to_tag" */
export type Ta_Relationship_To_Tag_Set_Input = {
  __typename?: 'ta_relationship_to_tag_set_input';
  config?: Maybe<Scalars['ScenarioTagConfig']['output']>;
  snooze_until?: Maybe<Scalars['timestamp']['output']>;
  updated_by_userid?: Maybe<Scalars['uuid']['output']>;
};

/** Streaming cursor of the table "ta_relationship_to_tag" */
export type Ta_Relationship_To_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Relationship_To_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Relationship_To_Tag_Stream_Cursor_Value_Input = {
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  config?: InputMaybe<Scalars['ScenarioTagConfig']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  snooze_until?: InputMaybe<Scalars['timestamp']['input']>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_userid?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "ta_relationship_to_tag" */
export enum Ta_Relationship_To_Tag_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  SnoozeUntil = 'snooze_until',
  /** column name */
  UpdatedByUserid = 'updated_by_userid'
}

export type Ta_Relationship_To_Tag_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ta_Relationship_To_Tag_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ta_Relationship_To_Tag_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ta_Relationship_To_Tag_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ta_Relationship_To_Tag_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ta_Relationship_To_Tag_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Relationship_To_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Relationship_To_Tag_Bool_Exp;
};

/** columns and relationships of "ta_rule_notification" */
export type Ta_Rule_Notification = {
  __typename?: 'ta_rule_notification';
  archived: Scalars['Boolean']['output'];
  config: Scalars['RuleConfig']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  last_triggered?: Maybe<Scalars['timestamp']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  notification_has_been_sent?: Maybe<Scalars['timestamp']['output']>;
  notification_text?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  ta_associated_sensors: Array<Ta_Associated_Sensor>;
  /** An array relationship */
  ta_notifications: Array<Ta_Notification>;
  /** An aggregate relationship */
  ta_notifications_aggregate: Ta_Notification_Aggregate;
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  /** An array relationship */
  ta_organisation_users: Array<Ta_User_Organisation>;
  /** An array relationship */
  ta_rule_notification_users: Array<Ta_Rule_Notification_User>;
  /** An object relationship */
  ta_sensor?: Maybe<Ta_Sensor>;
  /** An array relationship */
  ta_tag_rule_notifications: Array<Ta_Tag_Rule_Notification>;
  /** An object relationship */
  ta_user: Ta_User;
  /** An object relationship */
  ta_usergroup?: Maybe<Ta_Usergroup>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamp']['output'];
  user_id: Scalars['uuid']['output'];
  usergroup_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "ta_rule_notification" */
export type Ta_Rule_NotificationTa_Associated_SensorsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Associated_Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Associated_Sensor_Order_By>>;
  where?: InputMaybe<Ta_Associated_Sensor_Bool_Exp>;
};


/** columns and relationships of "ta_rule_notification" */
export type Ta_Rule_NotificationTa_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Order_By>>;
  where?: InputMaybe<Ta_Notification_Bool_Exp>;
};


/** columns and relationships of "ta_rule_notification" */
export type Ta_Rule_NotificationTa_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Order_By>>;
  where?: InputMaybe<Ta_Notification_Bool_Exp>;
};


/** columns and relationships of "ta_rule_notification" */
export type Ta_Rule_NotificationTa_Organisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


/** columns and relationships of "ta_rule_notification" */
export type Ta_Rule_NotificationTa_Rule_Notification_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Rule_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Rule_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Rule_Notification_User_Bool_Exp>;
};


/** columns and relationships of "ta_rule_notification" */
export type Ta_Rule_NotificationTa_Tag_Rule_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Rule_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Rule_Notification_Order_By>>;
  where?: InputMaybe<Ta_Tag_Rule_Notification_Bool_Exp>;
};

/** order by aggregate values of table "ta_rule_notification" */
export type Ta_Rule_Notification_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Rule_Notification_Max_Order_By>;
  min?: InputMaybe<Ta_Rule_Notification_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ta_Rule_Notification_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "ta_rule_notification" */
export type Ta_Rule_Notification_Arr_Rel_Insert_Input = {
  data: Array<Ta_Rule_Notification_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Rule_Notification_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_rule_notification". All fields are combined with a logical 'AND'. */
export type Ta_Rule_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Rule_Notification_Bool_Exp>>;
  _not?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Rule_Notification_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_triggered?: InputMaybe<Timestamp_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  notification_has_been_sent?: InputMaybe<Timestamp_Comparison_Exp>;
  notification_text?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_associated_sensors?: InputMaybe<Ta_Associated_Sensor_Bool_Exp>;
  ta_notifications?: InputMaybe<Ta_Notification_Bool_Exp>;
  ta_notifications_aggregate?: InputMaybe<Ta_Notification_Aggregate_Bool_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  ta_rule_notification_users?: InputMaybe<Ta_Rule_Notification_User_Bool_Exp>;
  ta_sensor?: InputMaybe<Ta_Sensor_Bool_Exp>;
  ta_tag_rule_notifications?: InputMaybe<Ta_Tag_Rule_Notification_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  usergroup_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_rule_notification" */
export enum Ta_Rule_Notification_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaRuleNotificationPkey = 'ta_rule_notification_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ta_Rule_Notification_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ta_Rule_Notification_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ta_Rule_Notification_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "ta_rule_notification" */
export type Ta_Rule_Notification_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notification_text?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_associated_sensors?: InputMaybe<Ta_Associated_Sensor_Arr_Rel_Insert_Input>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Arr_Rel_Insert_Input>;
  ta_tag_rule_notifications?: InputMaybe<Ta_Tag_Rule_Notification_Arr_Rel_Insert_Input>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Obj_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  usergroup_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "ta_rule_notification" */
export type Ta_Rule_Notification_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_triggered?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  notification_has_been_sent?: InputMaybe<Order_By>;
  notification_text?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  usergroup_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_rule_notification" */
export type Ta_Rule_Notification_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_triggered?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  notification_has_been_sent?: InputMaybe<Order_By>;
  notification_text?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  usergroup_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_rule_notification" */
export type Ta_Rule_Notification_Mutation_Response = {
  __typename?: 'ta_rule_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Rule_Notification>;
};

/** input type for inserting object relation for remote table "ta_rule_notification" */
export type Ta_Rule_Notification_Obj_Rel_Insert_Input = {
  data: Ta_Rule_Notification_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Rule_Notification_On_Conflict>;
};

/** on_conflict condition type for table "ta_rule_notification" */
export type Ta_Rule_Notification_On_Conflict = {
  constraint: Ta_Rule_Notification_Constraint;
  update_columns?: Array<Ta_Rule_Notification_Update_Column>;
  where?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_rule_notification". */
export type Ta_Rule_Notification_Order_By = {
  archived?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_triggered?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  notification_has_been_sent?: InputMaybe<Order_By>;
  notification_text?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  ta_associated_sensors_aggregate?: InputMaybe<Ta_Associated_Sensor_Aggregate_Order_By>;
  ta_notifications_aggregate?: InputMaybe<Ta_Notification_Aggregate_Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_organisation_users_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  ta_rule_notification_users_aggregate?: InputMaybe<Ta_Rule_Notification_User_Aggregate_Order_By>;
  ta_sensor?: InputMaybe<Ta_Sensor_Order_By>;
  ta_tag_rule_notifications_aggregate?: InputMaybe<Ta_Tag_Rule_Notification_Aggregate_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  usergroup_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_rule_notification */
export type Ta_Rule_Notification_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ta_Rule_Notification_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ta_rule_notification" */
export enum Ta_Rule_Notification_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Config = 'config',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LastTriggered = 'last_triggered',
  /** column name */
  Note = 'note',
  /** column name */
  NotificationHasBeenSent = 'notification_has_been_sent',
  /** column name */
  NotificationText = 'notification_text',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UsergroupId = 'usergroup_id'
}

/** input type for updating data in table "ta_rule_notification" */
export type Ta_Rule_Notification_Set_Input = {
  __typename?: 'ta_rule_notification_set_input';
  archived?: Maybe<Scalars['Boolean']['output']>;
  config?: Maybe<Scalars['RuleConfig']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  notification_text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Streaming cursor of the table "ta_rule_notification" */
export type Ta_Rule_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Rule_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Rule_Notification_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['RuleConfig']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_triggered?: InputMaybe<Scalars['timestamp']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notification_has_been_sent?: InputMaybe<Scalars['timestamp']['input']>;
  notification_text?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  usergroup_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "ta_rule_notification" */
export enum Ta_Rule_Notification_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Config = 'config',
  /** column name */
  Description = 'description',
  /** column name */
  Note = 'note',
  /** column name */
  NotificationText = 'notification_text',
  /** column name */
  Title = 'title'
}

export type Ta_Rule_Notification_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ta_Rule_Notification_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ta_Rule_Notification_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ta_Rule_Notification_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ta_Rule_Notification_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ta_Rule_Notification_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Rule_Notification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Rule_Notification_Bool_Exp;
};

/** columns and relationships of "ta_rule_notification_user" */
export type Ta_Rule_Notification_User = {
  __typename?: 'ta_rule_notification_user';
  archived: Scalars['Boolean']['output'];
  escalation_level?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  rule_notification_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_rule_notification: Ta_Rule_Notification;
  /** An object relationship */
  ta_user: Ta_User;
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Aggregate_Order_By = {
  avg?: InputMaybe<Ta_Rule_Notification_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Rule_Notification_User_Max_Order_By>;
  min?: InputMaybe<Ta_Rule_Notification_User_Min_Order_By>;
  stddev?: InputMaybe<Ta_Rule_Notification_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ta_Rule_Notification_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ta_Rule_Notification_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ta_Rule_Notification_User_Sum_Order_By>;
  var_pop?: InputMaybe<Ta_Rule_Notification_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ta_Rule_Notification_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Ta_Rule_Notification_User_Variance_Order_By>;
};

/** order by avg() on columns of table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Avg_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ta_rule_notification_user". All fields are combined with a logical 'AND'. */
export type Ta_Rule_Notification_User_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Rule_Notification_User_Bool_Exp>>;
  _not?: InputMaybe<Ta_Rule_Notification_User_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Rule_Notification_User_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  escalation_level?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rule_notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_rule_notification?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Max_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rule_notification_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Min_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rule_notification_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_rule_notification_user". */
export type Ta_Rule_Notification_User_Order_By = {
  archived?: InputMaybe<Order_By>;
  escalation_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rule_notification_id?: InputMaybe<Order_By>;
  ta_rule_notification?: InputMaybe<Ta_Rule_Notification_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "ta_rule_notification_user" */
export enum Ta_Rule_Notification_User_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  EscalationLevel = 'escalation_level',
  /** column name */
  Id = 'id',
  /** column name */
  RuleNotificationId = 'rule_notification_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Stddev_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Stddev_Pop_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Stddev_Samp_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Rule_Notification_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Rule_Notification_User_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  escalation_level?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rule_notification_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Sum_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Var_Pop_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Var_Samp_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ta_rule_notification_user" */
export type Ta_Rule_Notification_User_Variance_Order_By = {
  escalation_level?: InputMaybe<Order_By>;
};

/** columns and relationships of "ta_scenario_count" */
export type Ta_Scenario_Count = {
  __typename?: 'ta_scenario_count';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  organisation_id: Scalars['uuid']['output'];
  package_count_id?: Maybe<Scalars['uuid']['output']>;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  resident_name: Scalars['String']['output'];
  scenario_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_organisation: Ta_Organisation;
  /** An object relationship */
  ta_package_count?: Maybe<Ta_Package_Count>;
  /** An object relationship */
  ta_tag: Ta_Tag;
  updated_at: Scalars['timestamp']['output'];
};

/** order by aggregate values of table "ta_scenario_count" */
export type Ta_Scenario_Count_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Scenario_Count_Max_Order_By>;
  min?: InputMaybe<Ta_Scenario_Count_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_scenario_count". All fields are combined with a logical 'AND'. */
export type Ta_Scenario_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Scenario_Count_Bool_Exp>>;
  _not?: InputMaybe<Ta_Scenario_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Scenario_Count_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  package_count_id?: InputMaybe<Uuid_Comparison_Exp>;
  processed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  resident_name?: InputMaybe<String_Comparison_Exp>;
  scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_package_count?: InputMaybe<Ta_Package_Count_Bool_Exp>;
  ta_tag?: InputMaybe<Ta_Tag_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** order by max() on columns of table "ta_scenario_count" */
export type Ta_Scenario_Count_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  package_count_id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  resident_name?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_scenario_count" */
export type Ta_Scenario_Count_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  package_count_id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  resident_name?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_scenario_count". */
export type Ta_Scenario_Count_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  package_count_id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  resident_name?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_package_count?: InputMaybe<Ta_Package_Count_Order_By>;
  ta_tag?: InputMaybe<Ta_Tag_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ta_scenario_count" */
export enum Ta_Scenario_Count_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PackageCountId = 'package_count_id',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  ResidentName = 'resident_name',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "ta_scenario_count" */
export type Ta_Scenario_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Scenario_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Scenario_Count_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  package_count_id?: InputMaybe<Scalars['uuid']['input']>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  resident_name?: InputMaybe<Scalars['String']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** columns and relationships of "ta_sensor" */
export type Ta_Sensor = {
  __typename?: 'ta_sensor';
  active: Scalars['Boolean']['output'];
  archived: Scalars['Boolean']['output'];
  device_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  sensor_name?: Maybe<Scalars['String']['output']>;
  sensor_settings?: Maybe<Scalars['json']['output']>;
  sensor_type?: Maybe<Scalars['String']['output']>;
  sensor_value_type?: Maybe<Scalars['String']['output']>;
  serial_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  ta_associated_sensors: Array<Ta_Associated_Sensor>;
  /** An array relationship */
  ta_citizen_devices: Array<Ta_Citizen_Device>;
  /** An aggregate relationship */
  ta_citizen_devices_aggregate: Ta_Citizen_Device_Aggregate;
  /** An object relationship */
  ta_device?: Maybe<Ta_Device>;
  /** An array relationship */
  ta_notifications: Array<Ta_Notification>;
  /** An aggregate relationship */
  ta_notifications_aggregate: Ta_Notification_Aggregate;
  /** An array relationship */
  ta_relationship_to_tags: Array<Ta_Relationship_To_Tag>;
  /** An array relationship */
  ta_rule_notifications: Array<Ta_Rule_Notification>;
  /** An array relationship */
  ta_sensor_measurements: Array<Ta_Sensor_Measurement>;
  /** An object relationship */
  ta_user?: Maybe<Ta_User>;
  updated_at: Scalars['timestamp']['output'];
  updated_by_userid?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "ta_sensor" */
export type Ta_SensorSensor_SettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "ta_sensor" */
export type Ta_SensorTa_Associated_SensorsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Associated_Sensor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Associated_Sensor_Order_By>>;
  where?: InputMaybe<Ta_Associated_Sensor_Bool_Exp>;
};


/** columns and relationships of "ta_sensor" */
export type Ta_SensorTa_Citizen_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


/** columns and relationships of "ta_sensor" */
export type Ta_SensorTa_Citizen_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


/** columns and relationships of "ta_sensor" */
export type Ta_SensorTa_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Order_By>>;
  where?: InputMaybe<Ta_Notification_Bool_Exp>;
};


/** columns and relationships of "ta_sensor" */
export type Ta_SensorTa_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_Order_By>>;
  where?: InputMaybe<Ta_Notification_Bool_Exp>;
};


/** columns and relationships of "ta_sensor" */
export type Ta_SensorTa_Relationship_To_TagsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Relationship_To_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Relationship_To_Tag_Order_By>>;
  where?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
};


/** columns and relationships of "ta_sensor" */
export type Ta_SensorTa_Rule_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Rule_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Rule_Notification_Order_By>>;
  where?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
};


/** columns and relationships of "ta_sensor" */
export type Ta_SensorTa_Sensor_MeasurementsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Sensor_Measurement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Sensor_Measurement_Order_By>>;
  where?: InputMaybe<Ta_Sensor_Measurement_Bool_Exp>;
};

/** order by aggregate values of table "ta_sensor" */
export type Ta_Sensor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Sensor_Max_Order_By>;
  min?: InputMaybe<Ta_Sensor_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_sensor". All fields are combined with a logical 'AND'. */
export type Ta_Sensor_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Sensor_Bool_Exp>>;
  _not?: InputMaybe<Ta_Sensor_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Sensor_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  device_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sensor_name?: InputMaybe<String_Comparison_Exp>;
  sensor_settings?: InputMaybe<Json_Comparison_Exp>;
  sensor_type?: InputMaybe<String_Comparison_Exp>;
  sensor_value_type?: InputMaybe<String_Comparison_Exp>;
  serial_number?: InputMaybe<String_Comparison_Exp>;
  ta_associated_sensors?: InputMaybe<Ta_Associated_Sensor_Bool_Exp>;
  ta_citizen_devices?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
  ta_citizen_devices_aggregate?: InputMaybe<Ta_Citizen_Device_Aggregate_Bool_Exp>;
  ta_device?: InputMaybe<Ta_Device_Bool_Exp>;
  ta_notifications?: InputMaybe<Ta_Notification_Bool_Exp>;
  ta_notifications_aggregate?: InputMaybe<Ta_Notification_Aggregate_Bool_Exp>;
  ta_relationship_to_tags?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
  ta_rule_notifications?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
  ta_sensor_measurements?: InputMaybe<Ta_Sensor_Measurement_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by_userid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "ta_sensor" */
export type Ta_Sensor_Max_Order_By = {
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sensor_name?: InputMaybe<Order_By>;
  sensor_type?: InputMaybe<Order_By>;
  sensor_value_type?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
};

/** columns and relationships of "ta_sensor_measurement" */
export type Ta_Sensor_Measurement = {
  __typename?: 'ta_sensor_measurement';
  data_timestamp: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  measurement_value?: Maybe<Scalars['String']['output']>;
  sensor_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_sensor: Ta_Sensor;
  updated_at: Scalars['timestamp']['output'];
};

/** order by aggregate values of table "ta_sensor_measurement" */
export type Ta_Sensor_Measurement_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Sensor_Measurement_Max_Order_By>;
  min?: InputMaybe<Ta_Sensor_Measurement_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_sensor_measurement". All fields are combined with a logical 'AND'. */
export type Ta_Sensor_Measurement_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Sensor_Measurement_Bool_Exp>>;
  _not?: InputMaybe<Ta_Sensor_Measurement_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Sensor_Measurement_Bool_Exp>>;
  data_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  measurement_value?: InputMaybe<String_Comparison_Exp>;
  sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_sensor?: InputMaybe<Ta_Sensor_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** order by max() on columns of table "ta_sensor_measurement" */
export type Ta_Sensor_Measurement_Max_Order_By = {
  data_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measurement_value?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_sensor_measurement" */
export type Ta_Sensor_Measurement_Min_Order_By = {
  data_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measurement_value?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_sensor_measurement". */
export type Ta_Sensor_Measurement_Order_By = {
  data_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measurement_value?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  ta_sensor?: InputMaybe<Ta_Sensor_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ta_sensor_measurement" */
export enum Ta_Sensor_Measurement_Select_Column {
  /** column name */
  DataTimestamp = 'data_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  MeasurementValue = 'measurement_value',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "ta_sensor_measurement" */
export type Ta_Sensor_Measurement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Sensor_Measurement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Sensor_Measurement_Stream_Cursor_Value_Input = {
  data_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  measurement_value?: InputMaybe<Scalars['String']['input']>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** order by min() on columns of table "ta_sensor" */
export type Ta_Sensor_Min_Order_By = {
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sensor_name?: InputMaybe<Order_By>;
  sensor_type?: InputMaybe<Order_By>;
  sensor_value_type?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_sensor" */
export type Ta_Sensor_Mutation_Response = {
  __typename?: 'ta_sensor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Sensor>;
};

/** Ordering options when selecting data from "ta_sensor". */
export type Ta_Sensor_Order_By = {
  active?: InputMaybe<Order_By>;
  archived?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sensor_name?: InputMaybe<Order_By>;
  sensor_settings?: InputMaybe<Order_By>;
  sensor_type?: InputMaybe<Order_By>;
  sensor_value_type?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  ta_associated_sensors_aggregate?: InputMaybe<Ta_Associated_Sensor_Aggregate_Order_By>;
  ta_citizen_devices_aggregate?: InputMaybe<Ta_Citizen_Device_Aggregate_Order_By>;
  ta_device?: InputMaybe<Ta_Device_Order_By>;
  ta_notifications_aggregate?: InputMaybe<Ta_Notification_Aggregate_Order_By>;
  ta_relationship_to_tags_aggregate?: InputMaybe<Ta_Relationship_To_Tag_Aggregate_Order_By>;
  ta_rule_notifications_aggregate?: InputMaybe<Ta_Rule_Notification_Aggregate_Order_By>;
  ta_sensor_measurements_aggregate?: InputMaybe<Ta_Sensor_Measurement_Aggregate_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_sensor */
export type Ta_Sensor_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_sensor" */
export enum Ta_Sensor_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Archived = 'archived',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  SensorName = 'sensor_name',
  /** column name */
  SensorSettings = 'sensor_settings',
  /** column name */
  SensorType = 'sensor_type',
  /** column name */
  SensorValueType = 'sensor_value_type',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserid = 'updated_by_userid'
}

/** input type for updating data in table "ta_sensor" */
export type Ta_Sensor_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "ta_sensor" */
export type Ta_Sensor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Sensor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Sensor_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sensor_name?: InputMaybe<Scalars['String']['input']>;
  sensor_settings?: InputMaybe<Scalars['json']['input']>;
  sensor_type?: InputMaybe<Scalars['String']['input']>;
  sensor_value_type?: InputMaybe<Scalars['String']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by_userid?: InputMaybe<Scalars['uuid']['input']>;
};

export type Ta_Sensor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Sensor_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Sensor_Bool_Exp;
};

/** columns and relationships of "ta_sms_log" */
export type Ta_Sms_Log = {
  __typename?: 'ta_sms_log';
  command: Scalars['String']['output'];
  created_at: Scalars['timestamp']['output'];
  device_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  sid: Scalars['String']['output'];
  status: Scalars['String']['output'];
  /** An object relationship */
  ta_device?: Maybe<Ta_Device>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamp']['output'];
};

/** order by aggregate values of table "ta_sms_log" */
export type Ta_Sms_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Sms_Log_Max_Order_By>;
  min?: InputMaybe<Ta_Sms_Log_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_sms_log". All fields are combined with a logical 'AND'. */
export type Ta_Sms_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Sms_Log_Bool_Exp>>;
  _not?: InputMaybe<Ta_Sms_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Sms_Log_Bool_Exp>>;
  command?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  device_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sid?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  ta_device?: InputMaybe<Ta_Device_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** order by max() on columns of table "ta_sms_log" */
export type Ta_Sms_Log_Max_Order_By = {
  command?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_sms_log" */
export type Ta_Sms_Log_Min_Order_By = {
  command?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_sms_log". */
export type Ta_Sms_Log_Order_By = {
  command?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ta_device?: InputMaybe<Ta_Device_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ta_sms_log" */
export enum Ta_Sms_Log_Select_Column {
  /** column name */
  Command = 'command',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  Sid = 'sid',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "ta_sms_log" */
export type Ta_Sms_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Sms_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Sms_Log_Stream_Cursor_Value_Input = {
  command?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** columns and relationships of "ta_supplier" */
export type Ta_Supplier = {
  __typename?: 'ta_supplier';
  address?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  ta_gateways: Array<Ta_Gateway>;
  /** An array relationship */
  ta_organisations: Array<Ta_Organisation>;
  /** An array relationship */
  ta_supplier_users: Array<Ta_Supplier_User>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "ta_supplier" */
export type Ta_SupplierTa_GatewaysArgs = {
  distinct_on?: InputMaybe<Array<Ta_Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Gateway_Order_By>>;
  where?: InputMaybe<Ta_Gateway_Bool_Exp>;
};


/** columns and relationships of "ta_supplier" */
export type Ta_SupplierTa_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Organisation_Order_By>>;
  where?: InputMaybe<Ta_Organisation_Bool_Exp>;
};


/** columns and relationships of "ta_supplier" */
export type Ta_SupplierTa_Supplier_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Supplier_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Supplier_User_Order_By>>;
  where?: InputMaybe<Ta_Supplier_User_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ta_supplier". All fields are combined with a logical 'AND'. */
export type Ta_Supplier_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Supplier_Bool_Exp>>;
  _not?: InputMaybe<Ta_Supplier_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Supplier_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  ta_gateways?: InputMaybe<Ta_Gateway_Bool_Exp>;
  ta_organisations?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_supplier_users?: InputMaybe<Ta_Supplier_User_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "ta_supplier". */
export type Ta_Supplier_Order_By = {
  address?: InputMaybe<Order_By>;
  archived?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  ta_gateways_aggregate?: InputMaybe<Ta_Gateway_Aggregate_Order_By>;
  ta_organisations_aggregate?: InputMaybe<Ta_Organisation_Aggregate_Order_By>;
  ta_supplier_users_aggregate?: InputMaybe<Ta_Supplier_User_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ta_supplier" */
export enum Ta_Supplier_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Archived = 'archived',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "ta_supplier" */
export type Ta_Supplier_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Supplier_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Supplier_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "ta_supplier_user" */
export type Ta_Supplier_User = {
  __typename?: 'ta_supplier_user';
  archived: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  supplier_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_supplier: Ta_Supplier;
  /** An object relationship */
  ta_user: Ta_User;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "ta_supplier_user" */
export type Ta_Supplier_User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Supplier_User_Max_Order_By>;
  min?: InputMaybe<Ta_Supplier_User_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_supplier_user". All fields are combined with a logical 'AND'. */
export type Ta_Supplier_User_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Supplier_User_Bool_Exp>>;
  _not?: InputMaybe<Ta_Supplier_User_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Supplier_User_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_supplier?: InputMaybe<Ta_Supplier_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "ta_supplier_user" */
export type Ta_Supplier_User_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_supplier_user" */
export type Ta_Supplier_User_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_supplier_user". */
export type Ta_Supplier_User_Order_By = {
  archived?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  supplier_id?: InputMaybe<Order_By>;
  ta_supplier?: InputMaybe<Ta_Supplier_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "ta_supplier_user" */
export enum Ta_Supplier_User_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Id = 'id',
  /** column name */
  SupplierId = 'supplier_id',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "ta_supplier_user" */
export type Ta_Supplier_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Supplier_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Supplier_User_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "ta_tag" */
export type Ta_Tag = {
  __typename?: 'ta_tag';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  snooze_allowed: Scalars['Boolean']['output'];
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  /** An array relationship */
  ta_organisation_users: Array<Ta_User_Organisation>;
  /** An array relationship */
  ta_relationship_to_tags: Array<Ta_Relationship_To_Tag>;
  /** An array relationship */
  ta_tag_packages: Array<Ta_Tag_Package>;
  /** An array relationship */
  ta_tag_rule_notifications: Array<Ta_Tag_Rule_Notification>;
  tag_type?: Maybe<Scalars['TagType']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "ta_tag" */
export type Ta_TagTa_Organisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


/** columns and relationships of "ta_tag" */
export type Ta_TagTa_Relationship_To_TagsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Relationship_To_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Relationship_To_Tag_Order_By>>;
  where?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
};


/** columns and relationships of "ta_tag" */
export type Ta_TagTa_Tag_PackagesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Package_Order_By>>;
  where?: InputMaybe<Ta_Tag_Package_Bool_Exp>;
};


/** columns and relationships of "ta_tag" */
export type Ta_TagTa_Tag_Rule_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Rule_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Rule_Notification_Order_By>>;
  where?: InputMaybe<Ta_Tag_Rule_Notification_Bool_Exp>;
};

/** order by aggregate values of table "ta_tag" */
export type Ta_Tag_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Tag_Max_Order_By>;
  min?: InputMaybe<Ta_Tag_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_tag". All fields are combined with a logical 'AND'. */
export type Ta_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Tag_Bool_Exp>>;
  _not?: InputMaybe<Ta_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Tag_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  snooze_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  ta_relationship_to_tags?: InputMaybe<Ta_Relationship_To_Tag_Bool_Exp>;
  ta_tag_packages?: InputMaybe<Ta_Tag_Package_Bool_Exp>;
  ta_tag_rule_notifications?: InputMaybe<Ta_Tag_Rule_Notification_Bool_Exp>;
  tag_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_tag" */
export enum Ta_Tag_Constraint {
  /** unique or primary key constraint on columns "name" */
  TaTagNameKeyNoNulls = 'ta_tag_name_key_no_nulls',
  /** unique or primary key constraint on columns "organisation_id", "name" */
  TaTagNameOrganisationIdKey = 'ta_tag_name_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  TaTagPkey = 'ta_tag_pkey'
}

/** input type for inserting data into table "ta_tag" */
export type Ta_Tag_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  snooze_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Arr_Rel_Insert_Input>;
  ta_relationship_to_tags?: InputMaybe<Ta_Relationship_To_Tag_Arr_Rel_Insert_Input>;
  ta_tag_rule_notifications?: InputMaybe<Ta_Tag_Rule_Notification_Arr_Rel_Insert_Input>;
  tag_type?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "ta_tag" */
export type Ta_Tag_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  tag_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_tag" */
export type Ta_Tag_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  tag_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_tag" */
export type Ta_Tag_Mutation_Response = {
  __typename?: 'ta_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Tag>;
};

/** input type for inserting object relation for remote table "ta_tag" */
export type Ta_Tag_Obj_Rel_Insert_Input = {
  data: Ta_Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Tag_On_Conflict>;
};

/** on_conflict condition type for table "ta_tag" */
export type Ta_Tag_On_Conflict = {
  constraint: Ta_Tag_Constraint;
  update_columns?: Array<Ta_Tag_Update_Column>;
  where?: InputMaybe<Ta_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_tag". */
export type Ta_Tag_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  snooze_allowed?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_organisation_users_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  ta_relationship_to_tags_aggregate?: InputMaybe<Ta_Relationship_To_Tag_Aggregate_Order_By>;
  ta_tag_packages_aggregate?: InputMaybe<Ta_Tag_Package_Aggregate_Order_By>;
  ta_tag_rule_notifications_aggregate?: InputMaybe<Ta_Tag_Rule_Notification_Aggregate_Order_By>;
  tag_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "ta_tag_package" */
export type Ta_Tag_Package = {
  __typename?: 'ta_tag_package';
  id: Scalars['uuid']['output'];
  package_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_package: Ta_Package;
  /** An object relationship */
  ta_tag: Ta_Tag;
  tag_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "ta_tag_package" */
export type Ta_Tag_Package_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Tag_Package_Max_Order_By>;
  min?: InputMaybe<Ta_Tag_Package_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_tag_package". All fields are combined with a logical 'AND'. */
export type Ta_Tag_Package_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Tag_Package_Bool_Exp>>;
  _not?: InputMaybe<Ta_Tag_Package_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Tag_Package_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  package_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_package?: InputMaybe<Ta_Package_Bool_Exp>;
  ta_tag?: InputMaybe<Ta_Tag_Bool_Exp>;
  tag_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "ta_tag_package" */
export type Ta_Tag_Package_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_tag_package" */
export type Ta_Tag_Package_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_tag_package". */
export type Ta_Tag_Package_Order_By = {
  id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
  ta_package?: InputMaybe<Ta_Package_Order_By>;
  ta_tag?: InputMaybe<Ta_Tag_Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ta_tag_package" */
export enum Ta_Tag_Package_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PackageId = 'package_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "ta_tag_package" */
export type Ta_Tag_Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Tag_Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Tag_Package_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  package_id?: InputMaybe<Scalars['uuid']['input']>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** primary key columns input for table: ta_tag */
export type Ta_Tag_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "ta_tag_rule_notification" */
export type Ta_Tag_Rule_Notification = {
  __typename?: 'ta_tag_rule_notification';
  id: Scalars['uuid']['output'];
  is_associated: Scalars['Boolean']['output'];
  rule_notification_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_rule_notification: Ta_Rule_Notification;
  /** An object relationship */
  ta_tag: Ta_Tag;
  tag_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "ta_tag_rule_notification" */
export type Ta_Tag_Rule_Notification_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Tag_Rule_Notification_Max_Order_By>;
  min?: InputMaybe<Ta_Tag_Rule_Notification_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ta_tag_rule_notification" */
export type Ta_Tag_Rule_Notification_Arr_Rel_Insert_Input = {
  data: Array<Ta_Tag_Rule_Notification_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Tag_Rule_Notification_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_tag_rule_notification". All fields are combined with a logical 'AND'. */
export type Ta_Tag_Rule_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Tag_Rule_Notification_Bool_Exp>>;
  _not?: InputMaybe<Ta_Tag_Rule_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Tag_Rule_Notification_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_associated?: InputMaybe<Boolean_Comparison_Exp>;
  rule_notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_rule_notification?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
  ta_tag?: InputMaybe<Ta_Tag_Bool_Exp>;
  tag_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_tag_rule_notification" */
export enum Ta_Tag_Rule_Notification_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaTagRuleNotificationPkey = 'ta_tag_rule_notification_pkey',
  /** unique or primary key constraint on columns "rule_notification_id", "tag_id", "is_associated" */
  TaTagRuleNotificationTagIdRuleNotificationIdIsAssocia = 'ta_tag_rule_notification_tag_id_rule_notification_id_is_associa'
}

/** input type for inserting data into table "ta_tag_rule_notification" */
export type Ta_Tag_Rule_Notification_Insert_Input = {
  is_associated?: InputMaybe<Scalars['Boolean']['input']>;
  rule_notification_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_rule_notification?: InputMaybe<Ta_Rule_Notification_Obj_Rel_Insert_Input>;
  ta_tag?: InputMaybe<Ta_Tag_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "ta_tag_rule_notification" */
export type Ta_Tag_Rule_Notification_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  rule_notification_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_tag_rule_notification" */
export type Ta_Tag_Rule_Notification_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  rule_notification_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_tag_rule_notification" */
export type Ta_Tag_Rule_Notification_Mutation_Response = {
  __typename?: 'ta_tag_rule_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Tag_Rule_Notification>;
};

/** on_conflict condition type for table "ta_tag_rule_notification" */
export type Ta_Tag_Rule_Notification_On_Conflict = {
  constraint: Ta_Tag_Rule_Notification_Constraint;
  update_columns?: Array<Ta_Tag_Rule_Notification_Update_Column>;
  where?: InputMaybe<Ta_Tag_Rule_Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_tag_rule_notification". */
export type Ta_Tag_Rule_Notification_Order_By = {
  id?: InputMaybe<Order_By>;
  is_associated?: InputMaybe<Order_By>;
  rule_notification_id?: InputMaybe<Order_By>;
  ta_rule_notification?: InputMaybe<Ta_Rule_Notification_Order_By>;
  ta_tag?: InputMaybe<Ta_Tag_Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ta_tag_rule_notification" */
export enum Ta_Tag_Rule_Notification_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsAssociated = 'is_associated',
  /** column name */
  RuleNotificationId = 'rule_notification_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "ta_tag_rule_notification" */
export type Ta_Tag_Rule_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Tag_Rule_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Tag_Rule_Notification_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_associated?: InputMaybe<Scalars['Boolean']['input']>;
  rule_notification_id?: InputMaybe<Scalars['uuid']['input']>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** placeholder for update columns of table "ta_tag_rule_notification" (current role has no relevant permissions) */
export enum Ta_Tag_Rule_Notification_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** select columns of table "ta_tag" */
export enum Ta_Tag_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SnoozeAllowed = 'snooze_allowed',
  /** column name */
  TagType = 'tag_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ta_tag" */
export type Ta_Tag_Set_Input = {
  __typename?: 'ta_tag_set_input';
  name?: Maybe<Scalars['String']['output']>;
  snooze_allowed?: Maybe<Scalars['Boolean']['output']>;
  tag_type?: Maybe<Scalars['TagType']['output']>;
};

/** Streaming cursor of the table "ta_tag" */
export type Ta_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Tag_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  snooze_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  tag_type?: InputMaybe<Scalars['TagType']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "ta_tag" */
export enum Ta_Tag_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  SnoozeAllowed = 'snooze_allowed',
  /** column name */
  TagType = 'tag_type'
}

export type Ta_Tag_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Tag_Bool_Exp;
};

/** columns and relationships of "ta_tracker" */
export type Ta_Tracker = {
  __typename?: 'ta_tracker';
  archived: Scalars['Boolean']['output'];
  citizen_id?: Maybe<Scalars['uuid']['output']>;
  display_map: Scalars['Boolean']['output'];
  entity_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_setup: Scalars['Boolean']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  serial_number: Scalars['String']['output'];
  /** An object relationship */
  ta_activation?: Maybe<Ta_Activation>;
  /** An object relationship */
  ta_citizen?: Maybe<Ta_Citizen>;
  /** An array relationship */
  ta_tracker_logs: Array<Ta_Tracker_Log>;
  /** An array relationship */
  ta_tracker_measurements: Array<Ta_Tracker_Measurement>;
  /** An aggregate relationship */
  ta_tracker_measurements_aggregate: Ta_Tracker_Measurement_Aggregate;
  /** An object relationship */
  ta_user?: Maybe<Ta_User>;
  tracker_type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamp']['output'];
  updated_by_userid?: Maybe<Scalars['uuid']['output']>;
  wake_tracker: Scalars['Boolean']['output'];
};


/** columns and relationships of "ta_tracker" */
export type Ta_TrackerTa_Tracker_LogsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Log_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Log_Bool_Exp>;
};


/** columns and relationships of "ta_tracker" */
export type Ta_TrackerTa_Tracker_MeasurementsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Measurement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Measurement_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
};


/** columns and relationships of "ta_tracker" */
export type Ta_TrackerTa_Tracker_Measurements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tracker_Measurement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tracker_Measurement_Order_By>>;
  where?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
};

/** order by aggregate values of table "ta_tracker" */
export type Ta_Tracker_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Tracker_Max_Order_By>;
  min?: InputMaybe<Ta_Tracker_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ta_tracker" */
export type Ta_Tracker_Arr_Rel_Insert_Input = {
  data: Array<Ta_Tracker_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Tracker_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_tracker". All fields are combined with a logical 'AND'. */
export type Ta_Tracker_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Tracker_Bool_Exp>>;
  _not?: InputMaybe<Ta_Tracker_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Tracker_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  citizen_id?: InputMaybe<Uuid_Comparison_Exp>;
  display_map?: InputMaybe<Boolean_Comparison_Exp>;
  entity_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_setup?: InputMaybe<Boolean_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  serial_number?: InputMaybe<String_Comparison_Exp>;
  ta_activation?: InputMaybe<Ta_Activation_Bool_Exp>;
  ta_citizen?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_tracker_logs?: InputMaybe<Ta_Tracker_Log_Bool_Exp>;
  ta_tracker_measurements?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
  ta_tracker_measurements_aggregate?: InputMaybe<Ta_Tracker_Measurement_Aggregate_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  tracker_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by_userid?: InputMaybe<Uuid_Comparison_Exp>;
  wake_tracker?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_tracker" */
export enum Ta_Tracker_Constraint {
  /** unique or primary key constraint on columns "phone_number" */
  TaTrackerPhoneNumberKey = 'ta_tracker_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  TaTrackerPkey = 'ta_tracker_pkey',
  /** unique or primary key constraint on columns "tracker_type", "serial_number" */
  TaTrackerSerialNumberTrackerTypeKey = 'ta_tracker_serial_number_tracker_type_key'
}

/** input type for inserting data into table "ta_tracker" */
export type Ta_Tracker_Insert_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  display_map?: InputMaybe<Scalars['Boolean']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  is_setup?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  ta_activation?: InputMaybe<Ta_Activation_Obj_Rel_Insert_Input>;
  ta_citizen?: InputMaybe<Ta_Citizen_Obj_Rel_Insert_Input>;
  tracker_type?: InputMaybe<Scalars['String']['input']>;
  wake_tracker?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "ta_tracker_log" */
export type Ta_Tracker_Log = {
  __typename?: 'ta_tracker_log';
  command?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  sid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ta_tracker?: Maybe<Ta_Tracker>;
  tracker_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  values?: Maybe<Scalars['json']['output']>;
};


/** columns and relationships of "ta_tracker_log" */
export type Ta_Tracker_LogValuesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "ta_tracker_log" */
export type Ta_Tracker_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Tracker_Log_Max_Order_By>;
  min?: InputMaybe<Ta_Tracker_Log_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_tracker_log". All fields are combined with a logical 'AND'. */
export type Ta_Tracker_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Tracker_Log_Bool_Exp>>;
  _not?: InputMaybe<Ta_Tracker_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Tracker_Log_Bool_Exp>>;
  command?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sid?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  ta_tracker?: InputMaybe<Ta_Tracker_Bool_Exp>;
  tracker_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  values?: InputMaybe<Json_Comparison_Exp>;
};

/** order by max() on columns of table "ta_tracker_log" */
export type Ta_Tracker_Log_Max_Order_By = {
  command?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tracker_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_tracker_log" */
export type Ta_Tracker_Log_Min_Order_By = {
  command?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tracker_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_tracker_log". */
export type Ta_Tracker_Log_Order_By = {
  command?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ta_tracker?: InputMaybe<Ta_Tracker_Order_By>;
  tracker_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  values?: InputMaybe<Order_By>;
};

/** select columns of table "ta_tracker_log" */
export enum Ta_Tracker_Log_Select_Column {
  /** column name */
  Command = 'command',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Sid = 'sid',
  /** column name */
  Status = 'status',
  /** column name */
  TrackerId = 'tracker_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Values = 'values'
}

/** Streaming cursor of the table "ta_tracker_log" */
export type Ta_Tracker_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Tracker_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Tracker_Log_Stream_Cursor_Value_Input = {
  command?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tracker_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  values?: InputMaybe<Scalars['json']['input']>;
};

/** order by max() on columns of table "ta_tracker" */
export type Ta_Tracker_Max_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  tracker_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
};

/** columns and relationships of "ta_tracker_measurement" */
export type Ta_Tracker_Measurement = {
  __typename?: 'ta_tracker_measurement';
  archived: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  measurement_value?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ta_tracker: Ta_Tracker;
  /** An object relationship */
  ta_user?: Maybe<Ta_User>;
  tracker_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamp']['output'];
  updated_by_userid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "ta_tracker_measurement" */
export type Ta_Tracker_Measurement_Aggregate = {
  __typename?: 'ta_tracker_measurement_aggregate';
  aggregate?: Maybe<Ta_Tracker_Measurement_Aggregate_Fields>;
  nodes: Array<Ta_Tracker_Measurement>;
};

export type Ta_Tracker_Measurement_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ta_Tracker_Measurement_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ta_Tracker_Measurement_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ta_Tracker_Measurement_Aggregate_Bool_Exp_Count>;
};

export type Ta_Tracker_Measurement_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ta_Tracker_Measurement_Select_Column_Ta_Tracker_Measurement_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ta_Tracker_Measurement_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ta_Tracker_Measurement_Select_Column_Ta_Tracker_Measurement_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ta_Tracker_Measurement_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ta_Tracker_Measurement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ta_tracker_measurement" */
export type Ta_Tracker_Measurement_Aggregate_Fields = {
  __typename?: 'ta_tracker_measurement_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ta_Tracker_Measurement_Max_Fields>;
  min?: Maybe<Ta_Tracker_Measurement_Min_Fields>;
};


/** aggregate fields of "ta_tracker_measurement" */
export type Ta_Tracker_Measurement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ta_Tracker_Measurement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ta_tracker_measurement" */
export type Ta_Tracker_Measurement_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Tracker_Measurement_Max_Order_By>;
  min?: InputMaybe<Ta_Tracker_Measurement_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_tracker_measurement". All fields are combined with a logical 'AND'. */
export type Ta_Tracker_Measurement_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Tracker_Measurement_Bool_Exp>>;
  _not?: InputMaybe<Ta_Tracker_Measurement_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Tracker_Measurement_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  measurement_value?: InputMaybe<String_Comparison_Exp>;
  ta_tracker?: InputMaybe<Ta_Tracker_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  tracker_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by_userid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ta_Tracker_Measurement_Max_Fields = {
  __typename?: 'ta_tracker_measurement_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  measurement_value?: Maybe<Scalars['String']['output']>;
  tracker_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  updated_by_userid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "ta_tracker_measurement" */
export type Ta_Tracker_Measurement_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  measurement_value?: InputMaybe<Order_By>;
  tracker_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ta_Tracker_Measurement_Min_Fields = {
  __typename?: 'ta_tracker_measurement_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  measurement_value?: Maybe<Scalars['String']['output']>;
  tracker_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  updated_by_userid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "ta_tracker_measurement" */
export type Ta_Tracker_Measurement_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  measurement_value?: InputMaybe<Order_By>;
  tracker_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_tracker_measurement". */
export type Ta_Tracker_Measurement_Order_By = {
  archived?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measurement_value?: InputMaybe<Order_By>;
  ta_tracker?: InputMaybe<Ta_Tracker_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  tracker_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
};

/** select columns of table "ta_tracker_measurement" */
export enum Ta_Tracker_Measurement_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Id = 'id',
  /** column name */
  MeasurementValue = 'measurement_value',
  /** column name */
  TrackerId = 'tracker_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserid = 'updated_by_userid'
}

/** select "ta_tracker_measurement_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ta_tracker_measurement" */
export enum Ta_Tracker_Measurement_Select_Column_Ta_Tracker_Measurement_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived'
}

/** select "ta_tracker_measurement_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ta_tracker_measurement" */
export enum Ta_Tracker_Measurement_Select_Column_Ta_Tracker_Measurement_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived'
}

/** Streaming cursor of the table "ta_tracker_measurement" */
export type Ta_Tracker_Measurement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Tracker_Measurement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Tracker_Measurement_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  measurement_value?: InputMaybe<Scalars['String']['input']>;
  tracker_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by_userid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by min() on columns of table "ta_tracker" */
export type Ta_Tracker_Min_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  tracker_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_tracker" */
export type Ta_Tracker_Mutation_Response = {
  __typename?: 'ta_tracker_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Tracker>;
};

/** input type for inserting object relation for remote table "ta_tracker" */
export type Ta_Tracker_Obj_Rel_Insert_Input = {
  data: Ta_Tracker_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Tracker_On_Conflict>;
};

/** on_conflict condition type for table "ta_tracker" */
export type Ta_Tracker_On_Conflict = {
  constraint: Ta_Tracker_Constraint;
  update_columns?: Array<Ta_Tracker_Update_Column>;
  where?: InputMaybe<Ta_Tracker_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_tracker". */
export type Ta_Tracker_Order_By = {
  archived?: InputMaybe<Order_By>;
  citizen_id?: InputMaybe<Order_By>;
  display_map?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_setup?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  ta_activation?: InputMaybe<Ta_Activation_Order_By>;
  ta_citizen?: InputMaybe<Ta_Citizen_Order_By>;
  ta_tracker_logs_aggregate?: InputMaybe<Ta_Tracker_Log_Aggregate_Order_By>;
  ta_tracker_measurements_aggregate?: InputMaybe<Ta_Tracker_Measurement_Aggregate_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  tracker_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
  wake_tracker?: InputMaybe<Order_By>;
};

/** select columns of table "ta_tracker" */
export enum Ta_Tracker_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  DisplayMap = 'display_map',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsSetup = 'is_setup',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  TrackerType = 'tracker_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserid = 'updated_by_userid',
  /** column name */
  WakeTracker = 'wake_tracker'
}

/** Streaming cursor of the table "ta_tracker" */
export type Ta_Tracker_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Tracker_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Tracker_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  display_map?: InputMaybe<Scalars['Boolean']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_setup?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  tracker_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by_userid?: InputMaybe<Scalars['uuid']['input']>;
  wake_tracker?: InputMaybe<Scalars['Boolean']['input']>;
};

/** placeholder for update columns of table "ta_tracker" (current role has no relevant permissions) */
export enum Ta_Tracker_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "ta_user" */
export type Ta_User = {
  __typename?: 'ta_user';
  allow_indoor_atlas: Scalars['Boolean']['output'];
  archived: Scalars['Boolean']['output'];
  consent_accepted: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  email_verified: Scalars['Boolean']['output'];
  full_name?: Maybe<Scalars['String']['output']>;
  hasura_user_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  personal_devices: Array<Ta_User_Device_Tokens>;
  show_communicate: Scalars['Boolean']['output'];
  show_locate: Scalars['Boolean']['output'];
  show_measure: Scalars['Boolean']['output'];
  /** An array relationship */
  taCitizenUsersByUserId: Array<Ta_Citizen_User>;
  /** An array relationship */
  ta_notification_users: Array<Ta_Notification_User>;
  /** An aggregate relationship */
  ta_notification_users_aggregate: Ta_Notification_User_Aggregate;
  /** An array relationship */
  ta_permissions: Array<Ta_Permission>;
  /** An array relationship */
  ta_rule_notification_users: Array<Ta_Rule_Notification_User>;
  /** An array relationship */
  ta_rule_notifications: Array<Ta_Rule_Notification>;
  /** An array relationship */
  ta_supplier_users: Array<Ta_Supplier_User>;
  /** An array relationship */
  ta_user_insights: Array<Ta_User_Insight>;
  /** An array relationship */
  ta_user_organisations: Array<Ta_User_Organisation>;
  /** An array relationship */
  ta_usergroup_users: Array<Ta_Usergroup_User>;
  updated_at: Scalars['timestamp']['output'];
  updated_by_userid?: Maybe<Scalars['uuid']['output']>;
  user_image_uri?: Maybe<Scalars['String']['output']>;
  user_language?: Maybe<Scalars['ta_user_user_language']['output']>;
  user_phone?: Maybe<Scalars['String']['output']>;
  user_role: Scalars['String']['output'];
  user_timezone?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  view_user_residents: Array<View_User_Residents>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserPersonal_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Device_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Device_Tokens_Order_By>>;
  where?: InputMaybe<Ta_User_Device_Tokens_Bool_Exp>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserTaCitizenUsersByUserIdArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_User_Order_By>>;
  where?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserTa_Notification_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Notification_User_Bool_Exp>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserTa_Notification_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Notification_User_Bool_Exp>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserTa_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Permission_Order_By>>;
  where?: InputMaybe<Ta_Permission_Bool_Exp>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserTa_Rule_Notification_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Rule_Notification_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Rule_Notification_User_Order_By>>;
  where?: InputMaybe<Ta_Rule_Notification_User_Bool_Exp>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserTa_Rule_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Rule_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Rule_Notification_Order_By>>;
  where?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserTa_Supplier_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Supplier_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Supplier_User_Order_By>>;
  where?: InputMaybe<Ta_Supplier_User_Bool_Exp>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserTa_User_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Insight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Insight_Order_By>>;
  where?: InputMaybe<Ta_User_Insight_Bool_Exp>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserTa_User_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserTa_Usergroup_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_User_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_User_Bool_Exp>;
};


/** columns and relationships of "ta_user" */
export type Ta_UserView_User_ResidentsArgs = {
  distinct_on?: InputMaybe<Array<View_User_Residents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Residents_Order_By>>;
  where?: InputMaybe<View_User_Residents_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ta_user". All fields are combined with a logical 'AND'. */
export type Ta_User_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_User_Bool_Exp>>;
  _not?: InputMaybe<Ta_User_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_User_Bool_Exp>>;
  allow_indoor_atlas?: InputMaybe<Boolean_Comparison_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  consent_accepted?: InputMaybe<Boolean_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  email_verified?: InputMaybe<Boolean_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  hasura_user_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  personal_devices?: InputMaybe<Ta_User_Device_Tokens_Bool_Exp>;
  show_communicate?: InputMaybe<Boolean_Comparison_Exp>;
  show_locate?: InputMaybe<Boolean_Comparison_Exp>;
  show_measure?: InputMaybe<Boolean_Comparison_Exp>;
  taCitizenUsersByUserId?: InputMaybe<Ta_Citizen_User_Bool_Exp>;
  ta_notification_users?: InputMaybe<Ta_Notification_User_Bool_Exp>;
  ta_notification_users_aggregate?: InputMaybe<Ta_Notification_User_Aggregate_Bool_Exp>;
  ta_permissions?: InputMaybe<Ta_Permission_Bool_Exp>;
  ta_rule_notification_users?: InputMaybe<Ta_Rule_Notification_User_Bool_Exp>;
  ta_rule_notifications?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
  ta_supplier_users?: InputMaybe<Ta_Supplier_User_Bool_Exp>;
  ta_user_insights?: InputMaybe<Ta_User_Insight_Bool_Exp>;
  ta_user_organisations?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  ta_usergroup_users?: InputMaybe<Ta_Usergroup_User_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by_userid?: InputMaybe<Uuid_Comparison_Exp>;
  user_image_uri?: InputMaybe<String_Comparison_Exp>;
  user_language?: InputMaybe<String_Comparison_Exp>;
  user_phone?: InputMaybe<String_Comparison_Exp>;
  user_role?: InputMaybe<String_Comparison_Exp>;
  user_timezone?: InputMaybe<String_Comparison_Exp>;
  view_user_residents?: InputMaybe<View_User_Residents_Bool_Exp>;
};

export type Ta_User_Device_Token = {
  __typename?: 'ta_user_device_token';
  device_type?: Maybe<Scalars['UserDeviceType']['output']>;
};

export type Ta_User_Device_Token_Set_Input = {
  __typename?: 'ta_user_device_token_set_input';
  device_type?: Maybe<Scalars['UserDeviceType']['output']>;
};

export type Ta_User_Device_Token_Stream_Cursor_Value_Input = {
  device_type?: InputMaybe<Scalars['UserDeviceType']['input']>;
};

/** columns and relationships of "ta_user_device_tokens" */
export type Ta_User_Device_Tokens = {
  __typename?: 'ta_user_device_tokens';
  app_version?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  device_id: Scalars['String']['output'];
  device_type?: Maybe<Scalars['String']['output']>;
  force_logout_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  isActive: Scalars['Boolean']['output'];
  last_notification_received?: Maybe<Scalars['timestamptz']['output']>;
  personal_device_id?: Maybe<Scalars['uuid']['output']>;
  silenced_until?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  ta_personal_device?: Maybe<Ta_Personal_Device>;
  /** An object relationship */
  ta_user: Ta_User;
  /** An array relationship */
  ta_user_organisations: Array<Ta_User_Organisation>;
  token: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "ta_user_device_tokens" */
export type Ta_User_Device_TokensTa_User_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};

/** order by aggregate values of table "ta_user_device_tokens" */
export type Ta_User_Device_Tokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_User_Device_Tokens_Max_Order_By>;
  min?: InputMaybe<Ta_User_Device_Tokens_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_user_device_tokens". All fields are combined with a logical 'AND'. */
export type Ta_User_Device_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_User_Device_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Ta_User_Device_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_User_Device_Tokens_Bool_Exp>>;
  app_version?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_id?: InputMaybe<String_Comparison_Exp>;
  device_type?: InputMaybe<String_Comparison_Exp>;
  force_logout_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  last_notification_received?: InputMaybe<Timestamptz_Comparison_Exp>;
  personal_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  silenced_until?: InputMaybe<Timestamp_Comparison_Exp>;
  ta_personal_device?: InputMaybe<Ta_Personal_Device_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  ta_user_organisations?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_user_device_tokens" */
export enum Ta_User_Device_Tokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaUserDeviceTokensPkey = 'ta_user_device_tokens_pkey',
  /** unique or primary key constraint on columns "token" */
  TaUserDeviceTokensTokenKey = 'ta_user_device_tokens_token_key'
}

/** input type for inserting data into table "ta_user_device_tokens" */
export type Ta_User_Device_Tokens_Insert_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  force_logout_at?: InputMaybe<Scalars['timestamptz']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  personal_device_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_user_organisations?: InputMaybe<Ta_User_Organisation_Arr_Rel_Insert_Input>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "ta_user_device_tokens" */
export type Ta_User_Device_Tokens_Max_Order_By = {
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type?: InputMaybe<Order_By>;
  force_logout_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_notification_received?: InputMaybe<Order_By>;
  personal_device_id?: InputMaybe<Order_By>;
  silenced_until?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_user_device_tokens" */
export type Ta_User_Device_Tokens_Min_Order_By = {
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type?: InputMaybe<Order_By>;
  force_logout_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_notification_received?: InputMaybe<Order_By>;
  personal_device_id?: InputMaybe<Order_By>;
  silenced_until?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_user_device_tokens" */
export type Ta_User_Device_Tokens_Mutation_Response = {
  __typename?: 'ta_user_device_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_User_Device_Tokens>;
};

/** on_conflict condition type for table "ta_user_device_tokens" */
export type Ta_User_Device_Tokens_On_Conflict = {
  constraint: Ta_User_Device_Tokens_Constraint;
  update_columns?: Array<Ta_User_Device_Tokens_Update_Column>;
  where?: InputMaybe<Ta_User_Device_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_user_device_tokens". */
export type Ta_User_Device_Tokens_Order_By = {
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type?: InputMaybe<Order_By>;
  force_logout_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  last_notification_received?: InputMaybe<Order_By>;
  personal_device_id?: InputMaybe<Order_By>;
  silenced_until?: InputMaybe<Order_By>;
  ta_personal_device?: InputMaybe<Ta_Personal_Device_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  ta_user_organisations_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_user_device_tokens */
export type Ta_User_Device_Tokens_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_user_device_tokens" */
export enum Ta_User_Device_Tokens_Select_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceType = 'device_type',
  /** column name */
  ForceLogoutAt = 'force_logout_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  LastNotificationReceived = 'last_notification_received',
  /** column name */
  PersonalDeviceId = 'personal_device_id',
  /** column name */
  SilencedUntil = 'silenced_until',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "ta_user_device_tokens" */
export type Ta_User_Device_Tokens_Set_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  force_logout_at?: InputMaybe<Scalars['timestamptz']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  personal_device_id?: InputMaybe<Scalars['uuid']['input']>;
  silenced_until?: InputMaybe<Scalars['timestamp']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ta_user_device_tokens" */
export type Ta_User_Device_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_User_Device_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_User_Device_Tokens_Stream_Cursor_Value_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  force_logout_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last_notification_received?: InputMaybe<Scalars['timestamptz']['input']>;
  personal_device_id?: InputMaybe<Scalars['uuid']['input']>;
  silenced_until?: InputMaybe<Scalars['timestamp']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "ta_user_device_tokens" */
export enum Ta_User_Device_Tokens_Update_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceType = 'device_type',
  /** column name */
  ForceLogoutAt = 'force_logout_at',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  PersonalDeviceId = 'personal_device_id',
  /** column name */
  SilencedUntil = 'silenced_until',
  /** column name */
  Token = 'token'
}

export type Ta_User_Device_Tokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_User_Device_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_User_Device_Tokens_Bool_Exp;
};

/** columns and relationships of "ta_user_insight" */
export type Ta_User_Insight = {
  __typename?: 'ta_user_insight';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  is_valid: Scalars['Boolean']['output'];
  /** An object relationship */
  ta_user: Ta_User;
  /** An object relationship */
  ta_user_insight_type: Ta_User_Insight_Type;
  type: Ta_User_Insight_Type_Enum;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "ta_user_insight" */
export type Ta_User_Insight_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_User_Insight_Max_Order_By>;
  min?: InputMaybe<Ta_User_Insight_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ta_user_insight". All fields are combined with a logical 'AND'. */
export type Ta_User_Insight_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_User_Insight_Bool_Exp>>;
  _not?: InputMaybe<Ta_User_Insight_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_User_Insight_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_valid?: InputMaybe<Boolean_Comparison_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  ta_user_insight_type?: InputMaybe<Ta_User_Insight_Type_Bool_Exp>;
  type?: InputMaybe<Ta_User_Insight_Type_Enum_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "ta_user_insight" */
export type Ta_User_Insight_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_user_insight" */
export type Ta_User_Insight_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ta_user_insight". */
export type Ta_User_Insight_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_valid?: InputMaybe<Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  ta_user_insight_type?: InputMaybe<Ta_User_Insight_Type_Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "ta_user_insight" */
export enum Ta_User_Insight_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "ta_user_insight" */
export type Ta_User_Insight_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_User_Insight_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_User_Insight_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_valid?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Ta_User_Insight_Type_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "ta_user_insight_type" */
export type Ta_User_Insight_Type = {
  __typename?: 'ta_user_insight_type';
  description: Scalars['String']['output'];
  /** An array relationship */
  ta_user_insights: Array<Ta_User_Insight>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "ta_user_insight_type" */
export type Ta_User_Insight_TypeTa_User_InsightsArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Insight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Insight_Order_By>>;
  where?: InputMaybe<Ta_User_Insight_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ta_user_insight_type". All fields are combined with a logical 'AND'. */
export type Ta_User_Insight_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_User_Insight_Type_Bool_Exp>>;
  _not?: InputMaybe<Ta_User_Insight_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_User_Insight_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  ta_user_insights?: InputMaybe<Ta_User_Insight_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Ta_User_Insight_Type_Enum {
  /** If the current state and configuration of a device meeting our requirements. */
  DeviceSystemState = 'DEVICE_SYSTEM_STATE',
  /** Checks if any notifications were sent recently. */
  NotificationRecentlySent = 'NOTIFICATION_RECENTLY_SENT',
  /** Ensures there is recent user activity (e.g., checked and declined). */
  UserActivity = 'USER_ACTIVITY',
  /** Verifies that the user is currently authenticated and logged into the system. */
  UserLoggedIn = 'USER_LOGGED_IN'
}

/** Boolean expression to compare columns of type "ta_user_insight_type_enum". All fields are combined with logical 'AND'. */
export type Ta_User_Insight_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ta_User_Insight_Type_Enum>;
  _in?: InputMaybe<Array<Ta_User_Insight_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Ta_User_Insight_Type_Enum>;
  _nin?: InputMaybe<Array<Ta_User_Insight_Type_Enum>>;
};

/** Ordering options when selecting data from "ta_user_insight_type". */
export type Ta_User_Insight_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  ta_user_insights_aggregate?: InputMaybe<Ta_User_Insight_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "ta_user_insight_type" */
export enum Ta_User_Insight_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "ta_user_insight_type" */
export type Ta_User_Insight_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_User_Insight_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_User_Insight_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "ta_user" */
export type Ta_User_Mutation_Response = {
  __typename?: 'ta_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_User>;
};

/** Ordering options when selecting data from "ta_user". */
export type Ta_User_Order_By = {
  allow_indoor_atlas?: InputMaybe<Order_By>;
  archived?: InputMaybe<Order_By>;
  consent_accepted?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_verified?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  hasura_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  personal_devices_aggregate?: InputMaybe<Ta_User_Device_Tokens_Aggregate_Order_By>;
  show_communicate?: InputMaybe<Order_By>;
  show_locate?: InputMaybe<Order_By>;
  show_measure?: InputMaybe<Order_By>;
  taCitizenUsersByUserId_aggregate?: InputMaybe<Ta_Citizen_User_Aggregate_Order_By>;
  ta_notification_users_aggregate?: InputMaybe<Ta_Notification_User_Aggregate_Order_By>;
  ta_permissions_aggregate?: InputMaybe<Ta_Permission_Aggregate_Order_By>;
  ta_rule_notification_users_aggregate?: InputMaybe<Ta_Rule_Notification_User_Aggregate_Order_By>;
  ta_rule_notifications_aggregate?: InputMaybe<Ta_Rule_Notification_Aggregate_Order_By>;
  ta_supplier_users_aggregate?: InputMaybe<Ta_Supplier_User_Aggregate_Order_By>;
  ta_user_insights_aggregate?: InputMaybe<Ta_User_Insight_Aggregate_Order_By>;
  ta_user_organisations_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  ta_usergroup_users_aggregate?: InputMaybe<Ta_Usergroup_User_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_userid?: InputMaybe<Order_By>;
  user_image_uri?: InputMaybe<Order_By>;
  user_language?: InputMaybe<Order_By>;
  user_phone?: InputMaybe<Order_By>;
  user_role?: InputMaybe<Order_By>;
  user_timezone?: InputMaybe<Order_By>;
  view_user_residents_aggregate?: InputMaybe<View_User_Residents_Aggregate_Order_By>;
};

/** columns and relationships of "ta_user_organisation" */
export type Ta_User_Organisation = {
  __typename?: 'ta_user_organisation';
  /** An array relationship */
  all_ta_users: Array<Ta_User_Organisation>;
  id: Scalars['uuid']['output'];
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_organisation: Ta_Organisation;
  /** An array relationship */
  ta_permissions: Array<Ta_Permission>;
  /** An object relationship */
  ta_user: Ta_User;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "ta_user_organisation" */
export type Ta_User_OrganisationAll_Ta_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


/** columns and relationships of "ta_user_organisation" */
export type Ta_User_OrganisationTa_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Permission_Order_By>>;
  where?: InputMaybe<Ta_Permission_Bool_Exp>;
};

/** order by aggregate values of table "ta_user_organisation" */
export type Ta_User_Organisation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_User_Organisation_Max_Order_By>;
  min?: InputMaybe<Ta_User_Organisation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ta_user_organisation" */
export type Ta_User_Organisation_Arr_Rel_Insert_Input = {
  data: Array<Ta_User_Organisation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_User_Organisation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_user_organisation". All fields are combined with a logical 'AND'. */
export type Ta_User_Organisation_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_User_Organisation_Bool_Exp>>;
  _not?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_User_Organisation_Bool_Exp>>;
  all_ta_users?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_permissions?: InputMaybe<Ta_Permission_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_user_organisation" */
export enum Ta_User_Organisation_Constraint {
  /** unique or primary key constraint on columns "user_id", "organisation_id" */
  TaUserOrganisationOrganisationIdUserIdKey = 'ta_user_organisation_organisation_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  TaUserOrganisationPkey = 'ta_user_organisation_pkey'
}

/** input type for inserting data into table "ta_user_organisation" */
export type Ta_User_Organisation_Insert_Input = {
  all_ta_users?: InputMaybe<Ta_User_Organisation_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "ta_user_organisation" */
export type Ta_User_Organisation_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_user_organisation" */
export type Ta_User_Organisation_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_user_organisation" */
export type Ta_User_Organisation_Mutation_Response = {
  __typename?: 'ta_user_organisation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_User_Organisation>;
};

/** on_conflict condition type for table "ta_user_organisation" */
export type Ta_User_Organisation_On_Conflict = {
  constraint: Ta_User_Organisation_Constraint;
  update_columns?: Array<Ta_User_Organisation_Update_Column>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_user_organisation". */
export type Ta_User_Organisation_Order_By = {
  all_ta_users_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_permissions_aggregate?: InputMaybe<Ta_Permission_Aggregate_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_user_organisation */
export type Ta_User_Organisation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_user_organisation" */
export enum Ta_User_Organisation_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "ta_user_organisation" */
export type Ta_User_Organisation_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "ta_user_organisation" */
export type Ta_User_Organisation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_User_Organisation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_User_Organisation_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "ta_user_organisation" */
export enum Ta_User_Organisation_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

export type Ta_User_Organisation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_User_Organisation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_User_Organisation_Bool_Exp;
};

/** primary key columns input for table: ta_user */
export type Ta_User_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_user" */
export enum Ta_User_Select_Column {
  /** column name */
  AllowIndoorAtlas = 'allow_indoor_atlas',
  /** column name */
  Archived = 'archived',
  /** column name */
  ConsentAccepted = 'consent_accepted',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  FullName = 'full_name',
  /** column name */
  HasuraUserId = 'hasura_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  ShowCommunicate = 'show_communicate',
  /** column name */
  ShowLocate = 'show_locate',
  /** column name */
  ShowMeasure = 'show_measure',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserid = 'updated_by_userid',
  /** column name */
  UserImageUri = 'user_image_uri',
  /** column name */
  UserLanguage = 'user_language',
  /** column name */
  UserPhone = 'user_phone',
  /** column name */
  UserRole = 'user_role',
  /** column name */
  UserTimezone = 'user_timezone'
}

/** input type for updating data in table "ta_user" */
export type Ta_User_Set_Input = {
  __typename?: 'ta_user_set_input';
  allow_indoor_atlas?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  consent_accepted?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  show_communicate?: Maybe<Scalars['Boolean']['output']>;
  show_locate?: Maybe<Scalars['Boolean']['output']>;
  show_measure?: Maybe<Scalars['Boolean']['output']>;
  user_image_uri?: Maybe<Scalars['String']['output']>;
  user_language?: Maybe<Scalars['ta_user_user_language']['output']>;
  user_phone?: Maybe<Scalars['String']['output']>;
  user_timezone?: Maybe<Scalars['String']['output']>;
};

/** Streaming cursor of the table "ta_user" */
export type Ta_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_User_Stream_Cursor_Value_Input = {
  allow_indoor_atlas?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  consent_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  hasura_user_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  show_communicate?: InputMaybe<Scalars['Boolean']['input']>;
  show_locate?: InputMaybe<Scalars['Boolean']['input']>;
  show_measure?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by_userid?: InputMaybe<Scalars['uuid']['input']>;
  user_image_uri?: InputMaybe<Scalars['String']['input']>;
  user_language?: InputMaybe<Scalars['ta_user_user_language']['input']>;
  user_phone?: InputMaybe<Scalars['String']['input']>;
  user_role?: InputMaybe<Scalars['String']['input']>;
  user_timezone?: InputMaybe<Scalars['String']['input']>;
};

export type Ta_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_User_Bool_Exp;
};

/** columns and relationships of "ta_usergroup" */
export type Ta_Usergroup = {
  __typename?: 'ta_usergroup';
  archived: Scalars['Boolean']['output'];
  config?: Maybe<Scalars['UserGroupConfig']['output']>;
  created_at: Scalars['timestamptz']['output'];
  end_time?: Maybe<Scalars['time']['output']>;
  group_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  organisation_id: Scalars['uuid']['output'];
  start_time?: Maybe<Scalars['time']['output']>;
  /** An array relationship */
  ta_associated_escalation_groups: Array<Ta_Associated_Escalation_Group>;
  /** An object relationship */
  ta_organisation: Ta_Organisation;
  /** An array relationship */
  ta_rule_notifications: Array<Ta_Rule_Notification>;
  /** An array relationship */
  ta_user_organisations: Array<Ta_User_Organisation>;
  /** An array relationship */
  ta_usergroup_citizens: Array<Ta_Usergroup_Citizen>;
  /** An array relationship */
  ta_usergroup_users: Array<Ta_Usergroup_User>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "ta_usergroup" */
export type Ta_UsergroupTa_Associated_Escalation_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Associated_Escalation_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Associated_Escalation_Group_Order_By>>;
  where?: InputMaybe<Ta_Associated_Escalation_Group_Bool_Exp>;
};


/** columns and relationships of "ta_usergroup" */
export type Ta_UsergroupTa_Rule_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Rule_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Rule_Notification_Order_By>>;
  where?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
};


/** columns and relationships of "ta_usergroup" */
export type Ta_UsergroupTa_User_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};


/** columns and relationships of "ta_usergroup" */
export type Ta_UsergroupTa_Usergroup_CitizensArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_Citizen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_Citizen_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
};


/** columns and relationships of "ta_usergroup" */
export type Ta_UsergroupTa_Usergroup_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_Usergroup_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Usergroup_User_Order_By>>;
  where?: InputMaybe<Ta_Usergroup_User_Bool_Exp>;
};

/** order by aggregate values of table "ta_usergroup" */
export type Ta_Usergroup_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Usergroup_Max_Order_By>;
  min?: InputMaybe<Ta_Usergroup_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ta_Usergroup_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "ta_usergroup". All fields are combined with a logical 'AND'. */
export type Ta_Usergroup_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Usergroup_Bool_Exp>>;
  _not?: InputMaybe<Ta_Usergroup_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Usergroup_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_time?: InputMaybe<Time_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_time?: InputMaybe<Time_Comparison_Exp>;
  ta_associated_escalation_groups?: InputMaybe<Ta_Associated_Escalation_Group_Bool_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_rule_notifications?: InputMaybe<Ta_Rule_Notification_Bool_Exp>;
  ta_user_organisations?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  ta_usergroup_citizens?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
  ta_usergroup_users?: InputMaybe<Ta_Usergroup_User_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "ta_usergroup_citizen" */
export type Ta_Usergroup_Citizen = {
  __typename?: 'ta_usergroup_citizen';
  citizen_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_citizen: Ta_Citizen;
  /** An object relationship */
  ta_citizen_usergroup_users?: Maybe<Ta_Usergroup_User>;
  /** An object relationship */
  ta_usergroup: Ta_Usergroup;
  usergroup_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "ta_usergroup_citizen" */
export type Ta_Usergroup_Citizen_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Usergroup_Citizen_Max_Order_By>;
  min?: InputMaybe<Ta_Usergroup_Citizen_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ta_usergroup_citizen" */
export type Ta_Usergroup_Citizen_Arr_Rel_Insert_Input = {
  data: Array<Ta_Usergroup_Citizen_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Usergroup_Citizen_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_usergroup_citizen". All fields are combined with a logical 'AND'. */
export type Ta_Usergroup_Citizen_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Usergroup_Citizen_Bool_Exp>>;
  _not?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Usergroup_Citizen_Bool_Exp>>;
  citizen_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_citizen?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_citizen_usergroup_users?: InputMaybe<Ta_Usergroup_User_Bool_Exp>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Bool_Exp>;
  usergroup_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_usergroup_citizen" */
export enum Ta_Usergroup_Citizen_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaUsergroupCitizenPkey = 'ta_usergroup_citizen_pkey',
  /** unique or primary key constraint on columns "usergroup_id", "citizen_id" */
  TaUsergroupCitizenUsergroupIdCitizenIdKey = 'ta_usergroup_citizen_usergroup_id_citizen_id_key'
}

/** input type for inserting data into table "ta_usergroup_citizen" */
export type Ta_Usergroup_Citizen_Insert_Input = {
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_citizen?: InputMaybe<Ta_Citizen_Obj_Rel_Insert_Input>;
  ta_citizen_usergroup_users?: InputMaybe<Ta_Usergroup_User_Obj_Rel_Insert_Input>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Obj_Rel_Insert_Input>;
  usergroup_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "ta_usergroup_citizen" */
export type Ta_Usergroup_Citizen_Max_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  usergroup_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_usergroup_citizen" */
export type Ta_Usergroup_Citizen_Min_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  usergroup_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_usergroup_citizen" */
export type Ta_Usergroup_Citizen_Mutation_Response = {
  __typename?: 'ta_usergroup_citizen_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Usergroup_Citizen>;
};

/** input type for inserting object relation for remote table "ta_usergroup_citizen" */
export type Ta_Usergroup_Citizen_Obj_Rel_Insert_Input = {
  data: Ta_Usergroup_Citizen_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Usergroup_Citizen_On_Conflict>;
};

/** on_conflict condition type for table "ta_usergroup_citizen" */
export type Ta_Usergroup_Citizen_On_Conflict = {
  constraint: Ta_Usergroup_Citizen_Constraint;
  update_columns?: Array<Ta_Usergroup_Citizen_Update_Column>;
  where?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_usergroup_citizen". */
export type Ta_Usergroup_Citizen_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ta_citizen?: InputMaybe<Ta_Citizen_Order_By>;
  ta_citizen_usergroup_users?: InputMaybe<Ta_Usergroup_User_Order_By>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Order_By>;
  usergroup_id?: InputMaybe<Order_By>;
};

/** select columns of table "ta_usergroup_citizen" */
export enum Ta_Usergroup_Citizen_Select_Column {
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UsergroupId = 'usergroup_id'
}

/** Streaming cursor of the table "ta_usergroup_citizen" */
export type Ta_Usergroup_Citizen_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Usergroup_Citizen_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Usergroup_Citizen_Stream_Cursor_Value_Input = {
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  usergroup_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "ta_usergroup_citizen" (current role has no relevant permissions) */
export enum Ta_Usergroup_Citizen_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** unique or primary key constraints on table "ta_usergroup" */
export enum Ta_Usergroup_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaUsergroupPkey = 'ta_usergroup_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ta_Usergroup_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ta_Usergroup_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ta_Usergroup_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "ta_usergroup" */
export type Ta_Usergroup_Insert_Input = {
  group_name?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  ta_associated_escalation_groups?: InputMaybe<Ta_Associated_Escalation_Group_Arr_Rel_Insert_Input>;
  ta_rule_notifications?: InputMaybe<Ta_Rule_Notification_Arr_Rel_Insert_Input>;
  ta_user_organisations?: InputMaybe<Ta_User_Organisation_Arr_Rel_Insert_Input>;
  ta_usergroup_citizens?: InputMaybe<Ta_Usergroup_Citizen_Arr_Rel_Insert_Input>;
  ta_usergroup_users?: InputMaybe<Ta_Usergroup_User_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "ta_usergroup" */
export type Ta_Usergroup_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_usergroup" */
export type Ta_Usergroup_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_usergroup" */
export type Ta_Usergroup_Mutation_Response = {
  __typename?: 'ta_usergroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Usergroup>;
};

/** input type for inserting object relation for remote table "ta_usergroup" */
export type Ta_Usergroup_Obj_Rel_Insert_Input = {
  data: Ta_Usergroup_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Usergroup_On_Conflict>;
};

/** on_conflict condition type for table "ta_usergroup" */
export type Ta_Usergroup_On_Conflict = {
  constraint: Ta_Usergroup_Constraint;
  update_columns?: Array<Ta_Usergroup_Update_Column>;
  where?: InputMaybe<Ta_Usergroup_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_usergroup". */
export type Ta_Usergroup_Order_By = {
  archived?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  ta_associated_escalation_groups_aggregate?: InputMaybe<Ta_Associated_Escalation_Group_Aggregate_Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_rule_notifications_aggregate?: InputMaybe<Ta_Rule_Notification_Aggregate_Order_By>;
  ta_user_organisations_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  ta_usergroup_citizens_aggregate?: InputMaybe<Ta_Usergroup_Citizen_Aggregate_Order_By>;
  ta_usergroup_users_aggregate?: InputMaybe<Ta_Usergroup_User_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_usergroup */
export type Ta_Usergroup_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ta_Usergroup_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ta_usergroup" */
export enum Ta_Usergroup_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ta_usergroup" */
export type Ta_Usergroup_Set_Input = {
  __typename?: 'ta_usergroup_set_input';
  archived?: Maybe<Scalars['Boolean']['output']>;
  config?: Maybe<Scalars['UserGroupConfig']['output']>;
  end_time?: Maybe<Scalars['time']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['time']['output']>;
};

/** Streaming cursor of the table "ta_usergroup" */
export type Ta_Usergroup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Usergroup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Usergroup_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['UserGroupConfig']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_time?: InputMaybe<Scalars['time']['input']>;
  group_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['time']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "ta_usergroup" */
export enum Ta_Usergroup_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Config = 'config',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  StartTime = 'start_time'
}

export type Ta_Usergroup_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ta_Usergroup_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ta_Usergroup_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ta_Usergroup_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ta_Usergroup_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ta_Usergroup_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Usergroup_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Usergroup_Bool_Exp;
};

/** columns and relationships of "ta_usergroup_user" */
export type Ta_Usergroup_User = {
  __typename?: 'ta_usergroup_user';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ta_user: Ta_User;
  /** An object relationship */
  ta_user_usergroup_citizens?: Maybe<Ta_Usergroup_Citizen>;
  /** An object relationship */
  ta_usergroup: Ta_Usergroup;
  user_id: Scalars['uuid']['output'];
  usergroup_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "ta_usergroup_user" */
export type Ta_Usergroup_User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Usergroup_User_Max_Order_By>;
  min?: InputMaybe<Ta_Usergroup_User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ta_usergroup_user" */
export type Ta_Usergroup_User_Arr_Rel_Insert_Input = {
  data: Array<Ta_Usergroup_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Usergroup_User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ta_usergroup_user". All fields are combined with a logical 'AND'. */
export type Ta_Usergroup_User_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Usergroup_User_Bool_Exp>>;
  _not?: InputMaybe<Ta_Usergroup_User_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Usergroup_User_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  ta_user_usergroup_citizens?: InputMaybe<Ta_Usergroup_Citizen_Bool_Exp>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  usergroup_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_usergroup_user" */
export enum Ta_Usergroup_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaUsergroupUserPkey = 'ta_usergroup_user_pkey',
  /** unique or primary key constraint on columns "user_id", "usergroup_id" */
  TaUsergroupUserUsergroupIdUserIdKey = 'ta_usergroup_user_usergroup_id_user_id_key'
}

/** input type for inserting data into table "ta_usergroup_user" */
export type Ta_Usergroup_User_Insert_Input = {
  ta_user_usergroup_citizens?: InputMaybe<Ta_Usergroup_Citizen_Obj_Rel_Insert_Input>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  usergroup_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "ta_usergroup_user" */
export type Ta_Usergroup_User_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  usergroup_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_usergroup_user" */
export type Ta_Usergroup_User_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  usergroup_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_usergroup_user" */
export type Ta_Usergroup_User_Mutation_Response = {
  __typename?: 'ta_usergroup_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Usergroup_User>;
};

/** input type for inserting object relation for remote table "ta_usergroup_user" */
export type Ta_Usergroup_User_Obj_Rel_Insert_Input = {
  data: Ta_Usergroup_User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Usergroup_User_On_Conflict>;
};

/** on_conflict condition type for table "ta_usergroup_user" */
export type Ta_Usergroup_User_On_Conflict = {
  constraint: Ta_Usergroup_User_Constraint;
  update_columns?: Array<Ta_Usergroup_User_Update_Column>;
  where?: InputMaybe<Ta_Usergroup_User_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_usergroup_user". */
export type Ta_Usergroup_User_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  ta_user_usergroup_citizens?: InputMaybe<Ta_Usergroup_Citizen_Order_By>;
  ta_usergroup?: InputMaybe<Ta_Usergroup_Order_By>;
  user_id?: InputMaybe<Order_By>;
  usergroup_id?: InputMaybe<Order_By>;
};

/** select columns of table "ta_usergroup_user" */
export enum Ta_Usergroup_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UsergroupId = 'usergroup_id'
}

/** Streaming cursor of the table "ta_usergroup_user" */
export type Ta_Usergroup_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Usergroup_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Usergroup_User_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  usergroup_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "ta_usergroup_user" (current role has no relevant permissions) */
export enum Ta_Usergroup_User_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "ta_zone" */
export type Ta_Zone = {
  __typename?: 'ta_zone';
  coordinates?: Maybe<Scalars['geography']['output']>;
  floor_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  organisation_id: Scalars['uuid']['output'];
  square_meters?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  ta_citizen?: Maybe<Ta_Citizen>;
  /** An array relationship */
  ta_devices: Array<Ta_Device>;
  /** An object relationship */
  ta_floor?: Maybe<Ta_Floors>;
  /** An object relationship */
  ta_organisation: Ta_Organisation;
  /** An array relationship */
  ta_organisation_users: Array<Ta_User_Organisation>;
  zone_name: Scalars['String']['output'];
};


/** columns and relationships of "ta_zone" */
export type Ta_ZoneTa_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Device_Order_By>>;
  where?: InputMaybe<Ta_Device_Bool_Exp>;
};


/** columns and relationships of "ta_zone" */
export type Ta_ZoneTa_Organisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ta_User_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_User_Organisation_Order_By>>;
  where?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
};

/** order by aggregate values of table "ta_zone" */
export type Ta_Zone_Aggregate_Order_By = {
  avg?: InputMaybe<Ta_Zone_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ta_Zone_Max_Order_By>;
  min?: InputMaybe<Ta_Zone_Min_Order_By>;
  stddev?: InputMaybe<Ta_Zone_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ta_Zone_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ta_Zone_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ta_Zone_Sum_Order_By>;
  var_pop?: InputMaybe<Ta_Zone_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ta_Zone_Var_Samp_Order_By>;
  variance?: InputMaybe<Ta_Zone_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ta_zone" */
export type Ta_Zone_Arr_Rel_Insert_Input = {
  data: Array<Ta_Zone_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Zone_On_Conflict>;
};

/** order by avg() on columns of table "ta_zone" */
export type Ta_Zone_Avg_Order_By = {
  square_meters?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ta_zone". All fields are combined with a logical 'AND'. */
export type Ta_Zone_Bool_Exp = {
  _and?: InputMaybe<Array<Ta_Zone_Bool_Exp>>;
  _not?: InputMaybe<Ta_Zone_Bool_Exp>;
  _or?: InputMaybe<Array<Ta_Zone_Bool_Exp>>;
  coordinates?: InputMaybe<Geography_Comparison_Exp>;
  floor_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  square_meters?: InputMaybe<Numeric_Comparison_Exp>;
  ta_citizen?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_devices?: InputMaybe<Ta_Device_Bool_Exp>;
  ta_floor?: InputMaybe<Ta_Floors_Bool_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Bool_Exp>;
  zone_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ta_zone" */
export enum Ta_Zone_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaZonePkey = 'ta_zone_pkey'
}

/** input type for incrementing numeric columns in table "ta_zone" */
export type Ta_Zone_Inc_Input = {
  square_meters?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "ta_zone" */
export type Ta_Zone_Insert_Input = {
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  floor_id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  square_meters?: InputMaybe<Scalars['numeric']['input']>;
  ta_citizen?: InputMaybe<Ta_Citizen_Obj_Rel_Insert_Input>;
  ta_devices?: InputMaybe<Ta_Device_Arr_Rel_Insert_Input>;
  ta_floor?: InputMaybe<Ta_Floors_Obj_Rel_Insert_Input>;
  ta_organisation_users?: InputMaybe<Ta_User_Organisation_Arr_Rel_Insert_Input>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "ta_zone" */
export type Ta_Zone_Max_Order_By = {
  floor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  square_meters?: InputMaybe<Order_By>;
  zone_name?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ta_zone" */
export type Ta_Zone_Min_Order_By = {
  floor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  square_meters?: InputMaybe<Order_By>;
  zone_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ta_zone" */
export type Ta_Zone_Mutation_Response = {
  __typename?: 'ta_zone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ta_Zone>;
};

/** input type for inserting object relation for remote table "ta_zone" */
export type Ta_Zone_Obj_Rel_Insert_Input = {
  data: Ta_Zone_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ta_Zone_On_Conflict>;
};

/** on_conflict condition type for table "ta_zone" */
export type Ta_Zone_On_Conflict = {
  constraint: Ta_Zone_Constraint;
  update_columns?: Array<Ta_Zone_Update_Column>;
  where?: InputMaybe<Ta_Zone_Bool_Exp>;
};

/** Ordering options when selecting data from "ta_zone". */
export type Ta_Zone_Order_By = {
  coordinates?: InputMaybe<Order_By>;
  floor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  square_meters?: InputMaybe<Order_By>;
  ta_citizen?: InputMaybe<Ta_Citizen_Order_By>;
  ta_devices_aggregate?: InputMaybe<Ta_Device_Aggregate_Order_By>;
  ta_floor?: InputMaybe<Ta_Floors_Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_organisation_users_aggregate?: InputMaybe<Ta_User_Organisation_Aggregate_Order_By>;
  zone_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ta_zone */
export type Ta_Zone_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ta_zone" */
export enum Ta_Zone_Select_Column {
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  FloorId = 'floor_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SquareMeters = 'square_meters',
  /** column name */
  ZoneName = 'zone_name'
}

/** input type for updating data in table "ta_zone" */
export type Ta_Zone_Set_Input = {
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  floor_id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  square_meters?: InputMaybe<Scalars['numeric']['input']>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "ta_zone" */
export type Ta_Zone_Stddev_Order_By = {
  square_meters?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ta_zone" */
export type Ta_Zone_Stddev_Pop_Order_By = {
  square_meters?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ta_zone" */
export type Ta_Zone_Stddev_Samp_Order_By = {
  square_meters?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ta_zone" */
export type Ta_Zone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ta_Zone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ta_Zone_Stream_Cursor_Value_Input = {
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  floor_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  square_meters?: InputMaybe<Scalars['numeric']['input']>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "ta_zone" */
export type Ta_Zone_Sum_Order_By = {
  square_meters?: InputMaybe<Order_By>;
};

/** update columns of table "ta_zone" */
export enum Ta_Zone_Update_Column {
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  FloorId = 'floor_id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SquareMeters = 'square_meters',
  /** column name */
  ZoneName = 'zone_name'
}

export type Ta_Zone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ta_Zone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ta_Zone_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ta_Zone_Bool_Exp;
};

/** order by var_pop() on columns of table "ta_zone" */
export type Ta_Zone_Var_Pop_Order_By = {
  square_meters?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ta_zone" */
export type Ta_Zone_Var_Samp_Order_By = {
  square_meters?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ta_zone" */
export type Ta_Zone_Variance_Order_By = {
  square_meters?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export type Usergroup_User_Status = {
  __typename?: 'usergroup_user_status';
  status?: Maybe<Scalars['UserGroupUserResidentRelationshipType']['output']>;
};

export type Usergroup_User_Status_Set_Input = {
  __typename?: 'usergroup_user_status_set_input';
  status?: Maybe<Scalars['UserGroupUserResidentRelationshipType']['output']>;
};

export type Usergroup_User_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['UserGroupUserResidentRelationshipType']['input']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "view_default_scenarios" */
export type View_Default_Scenarios = {
  __typename?: 'view_default_scenarios';
  archived?: Maybe<Scalars['Boolean']['output']>;
  config: Scalars['RuleConfig']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_triggered?: Maybe<Scalars['timestamp']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  notification_has_been_sent?: Maybe<Scalars['timestamp']['output']>;
  notification_text?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  ta_tag_rule_notifications: Array<Ta_Tag_Rule_Notification>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  usergroup_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "view_default_scenarios" */
export type View_Default_ScenariosTa_Tag_Rule_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Ta_Tag_Rule_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Tag_Rule_Notification_Order_By>>;
  where?: InputMaybe<Ta_Tag_Rule_Notification_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "view_default_scenarios". All fields are combined with a logical 'AND'. */
export type View_Default_Scenarios_Bool_Exp = {
  _and?: InputMaybe<Array<View_Default_Scenarios_Bool_Exp>>;
  _not?: InputMaybe<View_Default_Scenarios_Bool_Exp>;
  _or?: InputMaybe<Array<View_Default_Scenarios_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_triggered?: InputMaybe<Timestamp_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  notification_has_been_sent?: InputMaybe<Timestamp_Comparison_Exp>;
  notification_text?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_tag_rule_notifications?: InputMaybe<Ta_Tag_Rule_Notification_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  usergroup_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "view_default_scenarios". */
export type View_Default_Scenarios_Order_By = {
  archived?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_triggered?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  notification_has_been_sent?: InputMaybe<Order_By>;
  notification_text?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  ta_tag_rule_notifications_aggregate?: InputMaybe<Ta_Tag_Rule_Notification_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  usergroup_id?: InputMaybe<Order_By>;
};

/** select columns of table "view_default_scenarios" */
export enum View_Default_Scenarios_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Config = 'config',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LastTriggered = 'last_triggered',
  /** column name */
  Note = 'note',
  /** column name */
  NotificationHasBeenSent = 'notification_has_been_sent',
  /** column name */
  NotificationText = 'notification_text',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UsergroupId = 'usergroup_id'
}

export type View_Default_Scenarios_Set_Input = {
  __typename?: 'view_default_scenarios_set_input';
  config?: Maybe<Scalars['RuleConfig']['output']>;
};

/** Streaming cursor of the table "view_default_scenarios" */
export type View_Default_Scenarios_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Default_Scenarios_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Default_Scenarios_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['RuleConfig']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_triggered?: InputMaybe<Scalars['timestamp']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notification_has_been_sent?: InputMaybe<Scalars['timestamp']['input']>;
  notification_text?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  usergroup_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "view_feature_subscription_device" */
export type View_Feature_Subscription_Device = {
  __typename?: 'view_feature_subscription_device';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  eui?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  in_use?: Maybe<Scalars['Boolean']['output']>;
  operation_mode?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  resident_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  /** An array relationship */
  view_user_permissions: Array<View_User_Permissions>;
};


/** columns and relationships of "view_feature_subscription_device" */
export type View_Feature_Subscription_DeviceView_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<View_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Permissions_Order_By>>;
  where?: InputMaybe<View_User_Permissions_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "view_feature_subscription_device". All fields are combined with a logical 'AND'. */
export type View_Feature_Subscription_Device_Bool_Exp = {
  _and?: InputMaybe<Array<View_Feature_Subscription_Device_Bool_Exp>>;
  _not?: InputMaybe<View_Feature_Subscription_Device_Bool_Exp>;
  _or?: InputMaybe<Array<View_Feature_Subscription_Device_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  eui?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_use?: InputMaybe<Boolean_Comparison_Exp>;
  operation_mode?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  resident_name?: InputMaybe<String_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  view_user_permissions?: InputMaybe<View_User_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "view_feature_subscription_device". */
export type View_Feature_Subscription_Device_Order_By = {
  created_at?: InputMaybe<Order_By>;
  eui?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_use?: InputMaybe<Order_By>;
  operation_mode?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  resident_name?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  view_user_permissions_aggregate?: InputMaybe<View_User_Permissions_Aggregate_Order_By>;
};

/** select columns of table "view_feature_subscription_device" */
export enum View_Feature_Subscription_Device_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Eui = 'eui',
  /** column name */
  Id = 'id',
  /** column name */
  InUse = 'in_use',
  /** column name */
  OperationMode = 'operation_mode',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ResidentName = 'resident_name'
}

/** Streaming cursor of the table "view_feature_subscription_device" */
export type View_Feature_Subscription_Device_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Feature_Subscription_Device_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Feature_Subscription_Device_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  eui?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_use?: InputMaybe<Scalars['Boolean']['input']>;
  operation_mode?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  resident_name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "view_feature_subscription_package" */
export type View_Feature_Subscription_Package = {
  __typename?: 'view_feature_subscription_package';
  affected_at?: Maybe<Scalars['timestamp']['output']>;
  count?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  package_id?: Maybe<Scalars['uuid']['output']>;
  package_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  /** An array relationship */
  view_user_permissions: Array<View_User_Permissions>;
};


/** columns and relationships of "view_feature_subscription_package" */
export type View_Feature_Subscription_PackageView_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<View_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Permissions_Order_By>>;
  where?: InputMaybe<View_User_Permissions_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "view_feature_subscription_package". All fields are combined with a logical 'AND'. */
export type View_Feature_Subscription_Package_Bool_Exp = {
  _and?: InputMaybe<Array<View_Feature_Subscription_Package_Bool_Exp>>;
  _not?: InputMaybe<View_Feature_Subscription_Package_Bool_Exp>;
  _or?: InputMaybe<Array<View_Feature_Subscription_Package_Bool_Exp>>;
  affected_at?: InputMaybe<Timestamp_Comparison_Exp>;
  count?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  package_id?: InputMaybe<Uuid_Comparison_Exp>;
  package_name?: InputMaybe<String_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  view_user_permissions?: InputMaybe<View_User_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "view_feature_subscription_package". */
export type View_Feature_Subscription_Package_Order_By = {
  affected_at?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
  package_name?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  view_user_permissions_aggregate?: InputMaybe<View_User_Permissions_Aggregate_Order_By>;
};

/** select columns of table "view_feature_subscription_package" */
export enum View_Feature_Subscription_Package_Select_Column {
  /** column name */
  AffectedAt = 'affected_at',
  /** column name */
  Count = 'count',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PackageId = 'package_id',
  /** column name */
  PackageName = 'package_name'
}

/** Streaming cursor of the table "view_feature_subscription_package" */
export type View_Feature_Subscription_Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Feature_Subscription_Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Feature_Subscription_Package_Stream_Cursor_Value_Input = {
  affected_at?: InputMaybe<Scalars['timestamp']['input']>;
  count?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  package_id?: InputMaybe<Scalars['uuid']['input']>;
  package_name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "view_feature_user_insight" */
export type View_Feature_User_Insight = {
  __typename?: 'view_feature_user_insight';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  is_valid?: Maybe<Scalars['Boolean']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  view_user_permissions: Array<View_User_Permissions>;
};


/** columns and relationships of "view_feature_user_insight" */
export type View_Feature_User_InsightView_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<View_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_User_Permissions_Order_By>>;
  where?: InputMaybe<View_User_Permissions_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "view_feature_user_insight". All fields are combined with a logical 'AND'. */
export type View_Feature_User_Insight_Bool_Exp = {
  _and?: InputMaybe<Array<View_Feature_User_Insight_Bool_Exp>>;
  _not?: InputMaybe<View_Feature_User_Insight_Bool_Exp>;
  _or?: InputMaybe<Array<View_Feature_User_Insight_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_valid?: InputMaybe<Boolean_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  view_user_permissions?: InputMaybe<View_User_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "view_feature_user_insight". */
export type View_Feature_User_Insight_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_valid?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_user_permissions_aggregate?: InputMaybe<View_User_Permissions_Aggregate_Order_By>;
};

/** select columns of table "view_feature_user_insight" */
export enum View_Feature_User_Insight_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "view_feature_user_insight" */
export type View_Feature_User_Insight_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Feature_User_Insight_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Feature_User_Insight_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_valid?: InputMaybe<Scalars['Boolean']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "view_tag_rule_config" */
export type View_Tag_Rule_Config = {
  __typename?: 'view_tag_rule_config';
  citizen_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  schedule?: Maybe<Scalars['Schedule']['output']>;
  snooze_allowed?: Maybe<Scalars['Boolean']['output']>;
  snooze_until?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  ta_organisation?: Maybe<Ta_Organisation>;
  /** An object relationship */
  ta_tag?: Maybe<Ta_Tag>;
  tag_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "view_tag_rule_config". All fields are combined with a logical 'AND'. */
export type View_Tag_Rule_Config_Bool_Exp = {
  _and?: InputMaybe<Array<View_Tag_Rule_Config_Bool_Exp>>;
  _not?: InputMaybe<View_Tag_Rule_Config_Bool_Exp>;
  _or?: InputMaybe<Array<View_Tag_Rule_Config_Bool_Exp>>;
  citizen_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  schedule?: InputMaybe<String_Comparison_Exp>;
  snooze_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  snooze_until?: InputMaybe<Timestamp_Comparison_Exp>;
  ta_organisation?: InputMaybe<Ta_Organisation_Bool_Exp>;
  ta_tag?: InputMaybe<Ta_Tag_Bool_Exp>;
  tag_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "view_tag_rule_config". */
export type View_Tag_Rule_Config_Order_By = {
  citizen_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  schedule?: InputMaybe<Order_By>;
  snooze_allowed?: InputMaybe<Order_By>;
  snooze_until?: InputMaybe<Order_By>;
  ta_organisation?: InputMaybe<Ta_Organisation_Order_By>;
  ta_tag?: InputMaybe<Ta_Tag_Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** select columns of table "view_tag_rule_config" */
export enum View_Tag_Rule_Config_Select_Column {
  /** column name */
  CitizenId = 'citizen_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Schedule = 'schedule',
  /** column name */
  SnoozeAllowed = 'snooze_allowed',
  /** column name */
  SnoozeUntil = 'snooze_until',
  /** column name */
  TagId = 'tag_id'
}

export type View_Tag_Rule_Config_Set_Input = {
  __typename?: 'view_tag_rule_config_set_input';
  schedule?: Maybe<Scalars['Schedule']['output']>;
};

/** Streaming cursor of the table "view_tag_rule_config" */
export type View_Tag_Rule_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Tag_Rule_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Tag_Rule_Config_Stream_Cursor_Value_Input = {
  citizen_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  schedule?: InputMaybe<Scalars['Schedule']['input']>;
  snooze_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  snooze_until?: InputMaybe<Scalars['timestamp']['input']>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "view_user_permissions" */
export type View_User_Permissions = {
  __typename?: 'view_user_permissions';
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "view_user_permissions" */
export type View_User_Permissions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<View_User_Permissions_Max_Order_By>;
  min?: InputMaybe<View_User_Permissions_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "view_user_permissions". All fields are combined with a logical 'AND'. */
export type View_User_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<View_User_Permissions_Bool_Exp>>;
  _not?: InputMaybe<View_User_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<View_User_Permissions_Bool_Exp>>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "view_user_permissions" */
export type View_User_Permissions_Max_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "view_user_permissions" */
export type View_User_Permissions_Min_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "view_user_permissions". */
export type View_User_Permissions_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "view_user_permissions" */
export enum View_User_Permissions_Select_Column {
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "view_user_permissions" */
export type View_User_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_User_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_User_Permissions_Stream_Cursor_Value_Input = {
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "view_user_residents" */
export type View_User_Residents = {
  __typename?: 'view_user_residents';
  resident_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  ta_citizen: Array<Ta_Citizen>;
  /** An array relationship */
  ta_citizen_devices: Array<Ta_Citizen_Device>;
  /** An aggregate relationship */
  ta_citizen_devices_aggregate: Ta_Citizen_Device_Aggregate;
  /** An object relationship */
  ta_resident?: Maybe<Ta_Citizen>;
  /** An object relationship */
  ta_user?: Maybe<Ta_User>;
  type?: Maybe<Scalars['UserResidentRelationshipType']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "view_user_residents" */
export type View_User_ResidentsTa_CitizenArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Bool_Exp>;
};


/** columns and relationships of "view_user_residents" */
export type View_User_ResidentsTa_Citizen_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};


/** columns and relationships of "view_user_residents" */
export type View_User_ResidentsTa_Citizen_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ta_Citizen_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ta_Citizen_Device_Order_By>>;
  where?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
};

/** order by aggregate values of table "view_user_residents" */
export type View_User_Residents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<View_User_Residents_Max_Order_By>;
  min?: InputMaybe<View_User_Residents_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "view_user_residents". All fields are combined with a logical 'AND'. */
export type View_User_Residents_Bool_Exp = {
  _and?: InputMaybe<Array<View_User_Residents_Bool_Exp>>;
  _not?: InputMaybe<View_User_Residents_Bool_Exp>;
  _or?: InputMaybe<Array<View_User_Residents_Bool_Exp>>;
  resident_id?: InputMaybe<Uuid_Comparison_Exp>;
  ta_citizen?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_citizen_devices?: InputMaybe<Ta_Citizen_Device_Bool_Exp>;
  ta_citizen_devices_aggregate?: InputMaybe<Ta_Citizen_Device_Aggregate_Bool_Exp>;
  ta_resident?: InputMaybe<Ta_Citizen_Bool_Exp>;
  ta_user?: InputMaybe<Ta_User_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "view_user_residents" */
export type View_User_Residents_Max_Order_By = {
  resident_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "view_user_residents" */
export type View_User_Residents_Min_Order_By = {
  resident_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "view_user_residents". */
export type View_User_Residents_Order_By = {
  resident_id?: InputMaybe<Order_By>;
  ta_citizen_aggregate?: InputMaybe<Ta_Citizen_Aggregate_Order_By>;
  ta_citizen_devices_aggregate?: InputMaybe<Ta_Citizen_Device_Aggregate_Order_By>;
  ta_resident?: InputMaybe<Ta_Citizen_Order_By>;
  ta_user?: InputMaybe<Ta_User_Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "view_user_residents" */
export enum View_User_Residents_Select_Column {
  /** column name */
  ResidentId = 'resident_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type View_User_Residents_Set_Input = {
  __typename?: 'view_user_residents_set_input';
  type?: Maybe<Scalars['UserResidentRelationshipType']['output']>;
};

/** Streaming cursor of the table "view_user_residents" */
export type View_User_Residents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_User_Residents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_User_Residents_Stream_Cursor_Value_Input = {
  resident_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['UserResidentRelationshipType']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type S_Get_User_Groups_By_Org_For_ShiftSubscriptionVariables = Exact<{
  organisation_id: Scalars['uuid']['input'];
}>;


export type S_Get_User_Groups_By_Org_For_ShiftSubscription = { __typename?: 'subscription_root', ta_usergroup: Array<{ __typename?: 'ta_usergroup', id: uuid, config?: UserGroupConfig | null, group_name: string, ta_usergroup_users: Array<{ __typename?: 'ta_usergroup_user', user_id: uuid }>, ta_usergroup_citizens: Array<{ __typename?: 'ta_usergroup_citizen', ta_citizen: { __typename?: 'ta_citizen', id: uuid, citizen_name: string, ta_citizen_users: Array<{ __typename?: 'ta_citizen_user', user_id: uuid, ta_user: { __typename?: 'ta_user', id: uuid, email: string, full_name?: string | null } }> } }> }> };

export type Update_Citizen_UserMutationVariables = Exact<{
  insertArr: Array<Ta_Citizen_User_Insert_Input> | Ta_Citizen_User_Insert_Input;
  deleteArr: Array<Ta_Citizen_User_Bool_Exp> | Ta_Citizen_User_Bool_Exp;
}>;


export type Update_Citizen_UserMutation = { __typename?: 'mutation_root', insert_ta_citizen_user?: { __typename?: 'ta_citizen_user_mutation_response', affected_rows: number } | null, delete_ta_citizen_user?: { __typename?: 'ta_citizen_user_mutation_response', affected_rows: number } | null };

export type Update_User_ModalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  full_name: Scalars['String']['input'];
  user_language?: InputMaybe<Scalars['String']['input']>;
  user_timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type Update_User_ModalMutation = { __typename?: 'mutation_root', update_ta_user_by_pk?: { __typename?: 'ta_user', full_name?: string | null, user_language?: ta_user_user_language | null, updated_at: timestamp, user_timezone?: string | null } | null };

export type Styra_Get_Package_DataQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  start: Scalars['timestamp']['input'];
  end: Scalars['timestamp']['input'];
}>;


export type Styra_Get_Package_DataQuery = { __typename?: 'query_root', view_feature_subscription_package: Array<{ __typename?: 'view_feature_subscription_package', id?: uuid | null, package_id?: uuid | null, package_name?: string | null, count?: numeric | null, affected_at?: timestamp | null, organisation_id?: uuid | null }>, view_feature_subscription_device: Array<{ __typename?: 'view_feature_subscription_device', id?: uuid | null, eui?: string | null, in_use?: boolean | null, operation_mode?: string | null, resident_name?: string | null, created_at?: timestamp | null, organisation_id?: uuid | null }> };

export type Styra_Get_User_Insight_DataQueryVariables = Exact<{
  organisation_id: Scalars['uuid']['input'];
  start: Scalars['timestamp']['input'];
  end: Scalars['timestamp']['input'];
}>;


export type Styra_Get_User_Insight_DataQuery = { __typename?: 'query_root', view_feature_user_insight: Array<{ __typename?: 'view_feature_user_insight', id?: uuid | null, user_id?: uuid | null, email?: string | null, full_name?: string | null, type?: string | null, is_valid?: boolean | null, created_at?: timestamp | null }> };

export type S_Delete_UsergroupMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type S_Delete_UsergroupMutation = { __typename?: 'mutation_root', delete_ta_usergroup?: { __typename?: 'ta_usergroup_mutation_response', affected_rows: number } | null };

export type Insert_Relationship_To_TagMutationVariables = Exact<{
  objects: Array<Ta_Relationship_To_Tag_Insert_Input> | Ta_Relationship_To_Tag_Insert_Input;
  constraint: Ta_Relationship_To_Tag_Constraint;
}>;


export type Insert_Relationship_To_TagMutation = { __typename?: 'mutation_root', insert_ta_relationship_to_tag?: { __typename?: 'ta_relationship_to_tag_mutation_response', affected_rows: number } | null };

export type Insert_Tag_With_RelationshipMutationVariables = Exact<{
  constraint: Ta_Relationship_To_Tag_Constraint;
  objects: Array<Ta_Relationship_To_Tag_Insert_Input> | Ta_Relationship_To_Tag_Insert_Input;
}>;


export type Insert_Tag_With_RelationshipMutation = { __typename?: 'mutation_root', insert_ta_relationship_to_tag?: { __typename?: 'ta_relationship_to_tag_mutation_response', affected_rows: number } | null };

export type S_Save_Associated_Escalation_GroupsMutationVariables = Exact<{
  shouldDelete: Scalars['Boolean']['input'];
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  shouldInsert: Scalars['Boolean']['input'];
  input: Array<Ta_Associated_Escalation_Group_Insert_Input> | Ta_Associated_Escalation_Group_Insert_Input;
  shouldUpdate: Scalars['Boolean']['input'];
  updates: Array<Ta_Associated_Escalation_Group_Updates> | Ta_Associated_Escalation_Group_Updates;
}>;


export type S_Save_Associated_Escalation_GroupsMutation = { __typename?: 'mutation_root', delete_ta_associated_escalation_group?: { __typename?: 'ta_associated_escalation_group_mutation_response', affected_rows: number } | null, insert_ta_associated_escalation_group?: { __typename?: 'ta_associated_escalation_group_mutation_response', affected_rows: number } | null, update_ta_associated_escalation_group_many?: Array<{ __typename?: 'ta_associated_escalation_group_mutation_response', affected_rows: number } | null> | null };

export type Styra_Update_DeviceMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  room?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notes_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  view_template?: InputMaybe<Scalars['json']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type Styra_Update_DeviceMutation = { __typename?: 'mutation_root', update_ta_device_by_pk?: { __typename?: 'ta_device', id: uuid } | null, update_ta_sensor?: { __typename?: 'ta_sensor_mutation_response', affected_rows: number } | null };

export type Update_UserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  email: Scalars['String']['input'];
  full_name: Scalars['String']['input'];
  user_image_uri?: InputMaybe<Scalars['String']['input']>;
  user_language?: InputMaybe<Scalars['String']['input']>;
  user_phone?: InputMaybe<Scalars['String']['input']>;
  user_timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type Update_UserMutation = { __typename?: 'mutation_root', update_ta_user_by_pk?: { __typename?: 'ta_user', email: string, full_name?: string | null, user_image_uri?: string | null, user_language?: ta_user_user_language | null, user_phone?: string | null, updated_at: timestamp, user_timezone?: string | null } | null };

export type Styra_Get_Devices_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Styra_Get_Devices_QueryQuery = { __typename?: 'query_root', ta_device: Array<(
    { __typename?: 'ta_device' }
    & { ' $fragmentRefs'?: { 'DeviceFieldsFragmentFragment': DeviceFieldsFragmentFragment } }
  )> };

export type Styra_Graph_Notifications_QueryQueryVariables = Exact<{
  where: Ta_Notification_Bool_Exp;
  includeLogs: Scalars['Boolean']['input'];
}>;


export type Styra_Graph_Notifications_QueryQuery = { __typename?: 'query_root', ta_notification: Array<{ __typename?: 'ta_notification', id: uuid, processed_at?: timestamptz | null, sensor_id?: uuid | null, citizen_id?: uuid | null, config: RuleConfig, ta_citizen?: { __typename?: 'ta_citizen', id: uuid, citizen_name: string } | null, ta_rule_notification: { __typename?: 'ta_rule_notification', id: uuid, ta_tag_rule_notifications: Array<{ __typename?: 'ta_tag_rule_notification', ta_tag: { __typename?: 'ta_tag', name: string, tag_type?: TagType | null } }> }, ta_notification_users_aggregate: { __typename?: 'ta_notification_user_aggregate', aggregate?: { __typename?: 'ta_notification_user_aggregate_fields', count: number } | null }, ta_notification_users: Array<{ __typename?: 'ta_notification_user', user_id: uuid, escalation_level?: number | null, state?: NotificationUserState | null, state_updated_at?: timestamp | null }>, ta_notification_reminders: Array<{ __typename?: 'ta_notification_reminder', id: uuid, created_at: timestamptz }>, ta_notification_logs?: Array<{ __typename?: 'ta_notification_log', id: uuid, type?: NotificationLogType | null, updated_at: timestamptz, user_id: uuid, user_device_token_id?: uuid | null, ta_user: { __typename?: 'ta_user', id: uuid, email: string, full_name?: string | null }, ta_user_device_token?: { __typename?: 'ta_user_device_tokens', id: uuid, app_version?: string | null, device_type?: string | null, silenced_until?: timestamp | null, ta_user: { __typename?: 'ta_user', id: uuid, email: string, full_name?: string | null } } | null }> }> };

export type Styra_Get_Maintenance_BannerQueryVariables = Exact<{ [key: string]: never; }>;


export type Styra_Get_Maintenance_BannerQuery = { __typename?: 'query_root', ta_maintenance: Array<{ __typename?: 'ta_maintenance', id: uuid, group_id: uuid, type: Ta_Maintenance_Type_Enum, language: string, text: string, display_start: timestamp, display_end: timestamp, maintenance_start?: timestamp | null, maintenance_end?: timestamp | null, organisation_id?: uuid | null, published: boolean, show_in_app: boolean, show_in_web: boolean }> };

export type Styra_Notification_Stats_QueryQueryVariables = Exact<{
  residentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  start: Scalars['timestamptz']['input'];
  end: Scalars['timestamptz']['input'];
}>;


export type Styra_Notification_Stats_QueryQuery = { __typename?: 'query_root', ta_notification: Array<{ __typename?: 'ta_notification', id: uuid, citizen_id?: uuid | null, processed_at?: timestamptz | null, ta_notification_users: Array<{ __typename?: 'ta_notification_user', id: uuid, escalation_level?: number | null, state?: NotificationUserState | null, state_updated_at?: timestamp | null }>, ta_notification_reminders: Array<{ __typename?: 'ta_notification_reminder', id: uuid, created_at: timestamptz }> }> };

export type Get_Organisation_By_PkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type Get_Organisation_By_PkQuery = { __typename?: 'query_root', ta_organisation_by_pk?: { __typename?: 'ta_organisation', id: uuid, ta_user_organisations: Array<{ __typename?: 'ta_user_organisation', id: uuid, ta_user: (
        { __typename?: 'ta_user' }
        & { ' $fragmentRefs'?: { 'UserFragmentFragment': UserFragmentFragment } }
      ) }>, ta_citizens: Array<{ __typename?: 'ta_citizen', id: uuid, citizen_name: string, citizen_address?: string | null, is_common_area: boolean, ta_relationship_to_tags: Array<(
        { __typename?: 'ta_relationship_to_tag' }
        & { ' $fragmentRefs'?: { 'TagRelationshipsWithRulesFragment': TagRelationshipsWithRulesFragment } }
      )> }>, ta_devices: Array<(
      { __typename?: 'ta_device' }
      & { ' $fragmentRefs'?: { 'DeviceFieldsFragmentFragment': DeviceFieldsFragmentFragment } }
    )>, ta_usergroups: Array<(
      { __typename?: 'ta_usergroup' }
      & { ' $fragmentRefs'?: { 'OrgUserGroupsFragmentFragment': OrgUserGroupsFragmentFragment } }
    )>, ta_rule_notifications: Array<{ __typename?: 'ta_rule_notification', id: uuid, title?: string | null, description?: string | null, notification_text?: string | null, last_triggered?: timestamp | null, config: RuleConfig, ta_sensor?: { __typename?: 'ta_sensor', id: uuid, sensor_type?: string | null, sensor_name?: string | null, ta_device?: { __typename?: 'ta_device', eui: string } | null } | null, ta_tag_rule_notifications: Array<{ __typename?: 'ta_tag_rule_notification', is_associated: boolean, ta_tag: { __typename?: 'ta_tag', id: uuid, name: string, tag_type?: TagType | null, ta_tag_packages: Array<{ __typename?: 'ta_tag_package', package_id: uuid, ta_package: { __typename?: 'ta_package', name: string } }> } }>, ta_usergroup?: { __typename?: 'ta_usergroup', id: uuid, group_name: string } | null }> } | null };

export type Styra_Get_Organisation_ListQueryVariables = Exact<{ [key: string]: never; }>;


export type Styra_Get_Organisation_ListQuery = { __typename?: 'query_root', ta_organisation: Array<{ __typename?: 'ta_organisation', id: uuid, name: string, supplier_id?: uuid | null, config?: OrganisationConfig | null, status?: Ta_Organisation_Status_Enum | null, tz?: string | null, ta_supplier?: { __typename?: 'ta_supplier', name: string } | null }> };

export type Organisation_Report_QueryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type Organisation_Report_QueryQuery = { __typename?: 'query_root', ta_organisation_by_pk?: { __typename?: 'ta_organisation', id: uuid, ta_citizens: Array<{ __typename?: 'ta_citizen', id: uuid, name: string }>, ta_tags: Array<{ __typename?: 'ta_tag', name: string, id: uuid }> } | null };

export type QueryNotificationForHomeQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type QueryNotificationForHomeQuery = { __typename?: 'query_root', ta_notification: Array<{ __typename?: 'ta_notification', processed_at?: timestamptz | null, notification_text?: string | null, ta_notification_users: Array<{ __typename?: 'ta_notification_user', user_id: uuid }> }> };

export type GetNotificationPerScenarioQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetNotificationPerScenarioQuery = { __typename?: 'query_root', ta_organisation_by_pk?: { __typename?: 'ta_organisation', ta_tags: Array<{ __typename?: 'ta_tag', id: uuid, name: string, ta_tag_rule_notifications: Array<{ __typename?: 'ta_tag_rule_notification', ta_rule_notification: { __typename?: 'ta_rule_notification', ta_notifications: Array<{ __typename?: 'ta_notification', id: uuid, ta_notification_users: Array<{ __typename?: 'ta_notification_user', id: uuid }> }> } }> }> } | null };

export type Get_Relation_To_Tag_By_PkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type Get_Relation_To_Tag_By_PkQuery = { __typename?: 'query_root', ta_relationship_to_tag_by_pk?: { __typename?: 'ta_relationship_to_tag', id: uuid, snooze_until?: timestamp | null, config?: ScenarioTagConfig | null, updated_at: timestamptz, ta_user?: { __typename?: 'ta_user', email: string, full_name?: string | null, id: uuid } | null, ta_tag: { __typename?: 'ta_tag', id: uuid, name: string, snooze_allowed: boolean } } | null };

export type GetNotificationCountPerScenarioQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetNotificationCountPerScenarioQuery = { __typename?: 'query_root', ta_organisation_by_pk?: { __typename?: 'ta_organisation', ta_tags: Array<{ __typename?: 'ta_tag', id: uuid, name: string, ta_tag_rule_notifications: Array<{ __typename?: 'ta_tag_rule_notification', ta_rule_notification: { __typename?: 'ta_rule_notification', ta_notifications: Array<{ __typename?: 'ta_notification', id: uuid, processed_at?: timestamptz | null, ta_notification_users: Array<{ __typename?: 'ta_notification_user', id: uuid }> }> } }> }> } | null };

export type Get_Sensor_HistoryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  timestamp: Scalars['timestamptz']['input'];
}>;


export type Get_Sensor_HistoryQuery = { __typename?: 'query_root', ta_sensor_by_pk?: { __typename?: 'ta_sensor', id: uuid, sensor_type?: string | null, ta_notifications: Array<{ __typename?: 'ta_notification', id: uuid, created_at: timestamp, processed_at?: timestamptz | null, follow_up_at?: timestamptz | null, ta_rule_notification_id: uuid, ta_notification_users: Array<{ __typename?: 'ta_notification_user', id: uuid }> }>, ta_sensor_measurements: Array<{ __typename?: 'ta_sensor_measurement', id: uuid, data_timestamp: timestamptz, updated_at: timestamp }> } | null };

export type S_Get_User_Groups_By_OrgQueryVariables = Exact<{
  organisation_id: Scalars['uuid']['input'];
}>;


export type S_Get_User_Groups_By_OrgQuery = { __typename?: 'query_root', ta_usergroup: Array<(
    { __typename?: 'ta_usergroup', id: uuid, ta_organisation: { __typename?: 'ta_organisation', id: uuid, name: string } }
    & { ' $fragmentRefs'?: { 'OrgUserGroupsFragmentFragment': OrgUserGroupsFragmentFragment } }
  )> };

export type Styra_Get_User_PermissionsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type Styra_Get_User_PermissionsQuery = { __typename?: 'query_root', view_user_permissions: Array<{ __typename?: 'view_user_permissions', organisation_id?: uuid | null, type?: string | null }> };

export type TagRelationshipsFragment = { __typename?: 'ta_relationship_to_tag', id: uuid, snooze_until?: timestamp | null, config?: ScenarioTagConfig | null, ta_tag: { __typename?: 'ta_tag', id: uuid, name: string, organisation_id?: uuid | null, tag_type?: TagType | null, snooze_allowed: boolean, ta_tag_packages: Array<{ __typename?: 'ta_tag_package', package_id: uuid }> } } & { ' $fragmentName'?: 'TagRelationshipsFragment' };

export type TagRelationshipsWithRulesFragment = { __typename?: 'ta_relationship_to_tag', id: uuid, snooze_until?: timestamp | null, config?: ScenarioTagConfig | null, ta_tag: { __typename?: 'ta_tag', id: uuid, name: string, organisation_id?: uuid | null, tag_type?: TagType | null, snooze_allowed: boolean, ta_tag_packages: Array<{ __typename?: 'ta_tag_package', package_id: uuid }>, rules: Array<{ __typename?: 'ta_tag_rule_notification', id: uuid }> } } & { ' $fragmentName'?: 'TagRelationshipsWithRulesFragment' };

export type DeviceFieldsFragmentFragment = { __typename?: 'ta_device', id: uuid, active: boolean, created_at?: timestamptz | null, default_name?: string | null, device_id?: string | null, discovered?: boolean | null, eui: string, gateway_id?: string | null, location?: string | null, manufacturer_name?: string | null, metadata?: ta_device_metadata_type | null, model_identifier?: string | null, name?: string | null, notes?: string | null, floor_id?: uuid | null, position?: string | null, notes_updated_at?: timestamptz | null, online?: boolean | null, organisation_id?: uuid | null, room?: string | null, serial_number?: string | null, template_hash?: string | null, updated_at?: timestamptz | null, version?: numeric | null, view_template?: ta_device_view_template_type | null, zone_id?: uuid | null, ta_citizen_devices: Array<{ __typename?: 'ta_citizen_device', id: uuid, ta_citizen: { __typename?: 'ta_citizen', id: uuid, citizen_name: string, ta_relationship_to_tags: Array<(
        { __typename?: 'ta_relationship_to_tag' }
        & { ' $fragmentRefs'?: { 'TagRelationshipsFragment': TagRelationshipsFragment } }
      )> } }>, ta_gateway?: { __typename?: 'ta_gateway', id: uuid } | null, ta_organisation?: { __typename?: 'ta_organisation', id: uuid, name: string } | null, ta_relationship_to_tags: Array<(
    { __typename?: 'ta_relationship_to_tag' }
    & { ' $fragmentRefs'?: { 'TagRelationshipsFragment': TagRelationshipsFragment } }
  )>, ta_sensors: Array<{ __typename?: 'ta_sensor', id: uuid, sensor_name?: string | null, sensor_type?: string | null, serial_number?: string | null, sensor_value_type?: string | null, updated_at: timestamp, archived: boolean, active: boolean, ta_sensor_measurements: Array<{ __typename?: 'ta_sensor_measurement', measurement_value?: string | null, data_timestamp: timestamptz }>, ta_relationship_to_tags: Array<(
      { __typename?: 'ta_relationship_to_tag' }
      & { ' $fragmentRefs'?: { 'TagRelationshipsFragment': TagRelationshipsFragment } }
    )> }> } & { ' $fragmentName'?: 'DeviceFieldsFragmentFragment' };

export type UserFragmentFragment = { __typename?: 'ta_user', full_name?: string | null, email: string, id: uuid, user_role: string, user_phone?: string | null, user_language?: ta_user_user_language | null, user_timezone?: string | null } & { ' $fragmentName'?: 'UserFragmentFragment' };

export type OrgUserGroupsFragmentFragment = { __typename?: 'ta_usergroup', id: uuid, group_name: string, config?: UserGroupConfig | null, ta_usergroup_citizens: Array<{ __typename?: 'ta_usergroup_citizen', id: uuid, ta_citizen: { __typename?: 'ta_citizen', id: uuid, citizen_name: string, citizen_address?: string | null } }>, ta_associated_escalation_groups: Array<{ __typename?: 'ta_associated_escalation_group', id: uuid, associated_group_id: uuid, config?: AssociatedEscalationGroupConfig | null, ta_usergroup: { __typename?: 'ta_usergroup', group_name: string }, associated_usergroup?: { __typename?: 'ta_usergroup', group_name: string } | null }>, ta_usergroup_users: Array<{ __typename?: 'ta_usergroup_user', id: uuid, ta_user: (
      { __typename?: 'ta_user' }
      & { ' $fragmentRefs'?: { 'UserFragmentFragment': UserFragmentFragment } }
    ) }> } & { ' $fragmentName'?: 'OrgUserGroupsFragmentFragment' };

export type RuleFragmentFragment = { __typename?: 'ta_rule_notification', id: uuid, config: RuleConfig, archived: boolean, sensor_id?: uuid | null, user_id: uuid, note?: string | null, notification_text?: string | null, notification_has_been_sent?: timestamp | null, last_triggered?: timestamp | null, title?: string | null, description?: string | null, updated_at: timestamp, organisation_id?: uuid | null, ta_organisation?: { __typename?: 'ta_organisation', id: uuid, name: string, archived: boolean } | null, ta_rule_notification_users: Array<{ __typename?: 'ta_rule_notification_user', id: uuid, user_id: uuid, rule_notification_id: uuid, escalation_level?: number | null, ta_user: { __typename?: 'ta_user', id: uuid, email: string, full_name?: string | null, archived: boolean } }>, ta_sensor?: { __typename?: 'ta_sensor', sensor_name?: string | null, sensor_type?: string | null, ta_device?: { __typename?: 'ta_device', eui: string, id: uuid, default_name?: string | null, organisation_id?: uuid | null, ta_gateway?: { __typename?: 'ta_gateway', id: uuid, serial: string } | null, ta_organisation?: { __typename?: 'ta_organisation', name: string, id: uuid } | null } | null } | null, ta_user: { __typename?: 'ta_user', id: uuid, email: string }, ta_associated_sensors: Array<{ __typename?: 'ta_associated_sensor', id: uuid, rule_notification_id: uuid, sensor_id: uuid }>, ta_usergroup?: { __typename?: 'ta_usergroup', id: uuid, group_name: string, ta_usergroup_users: Array<{ __typename?: 'ta_usergroup_user', id: uuid, ta_user: { __typename?: 'ta_user', id: uuid, email: string, full_name?: string | null } }> } | null, ta_tag_rule_notifications: Array<{ __typename?: 'ta_tag_rule_notification', id: uuid, is_associated: boolean, ta_tag: { __typename?: 'ta_tag', id: uuid, name: string, tag_type?: TagType | null, snooze_allowed: boolean, organisation_id?: uuid | null, ta_tag_packages: Array<{ __typename?: 'ta_tag_package', package_id: uuid, ta_package: { __typename?: 'ta_package', name: string } }> } }> } & { ' $fragmentName'?: 'RuleFragmentFragment' };

export const TagRelationshipsWithRulesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagRelationshipsWithRules"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_relationship_to_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_until"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"tag_type"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rules"},"name":{"kind":"Name","value":"ta_tag_rule_notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_rule_notification"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"rule_notification_id"}}]}}]}}]}}]} as unknown as DocumentNode<TagRelationshipsWithRulesFragment, unknown>;
export const TagRelationshipsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagRelationships"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_relationship_to_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_until"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"tag_type"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_id"}}]}}]}}]}}]} as unknown as DocumentNode<TagRelationshipsFragment, unknown>;
export const DeviceFieldsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeviceFieldsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_device"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_id"}},{"kind":"Field","name":{"kind":"Name","value":"discovered"}},{"kind":"Field","name":{"kind":"Name","value":"eui"}},{"kind":"Field","name":{"kind":"Name","value":"gateway_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"model_identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"floor_id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"notes_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"online"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"room"}},{"kind":"Field","name":{"kind":"Name","value":"serial_number"}},{"kind":"Field","name":{"kind":"Name","value":"template_hash"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"view_template"}},{"kind":"Field","name":{"kind":"Name","value":"zone_id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizen_devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_name"}},{"kind":"Field","name":{"kind":"Name","value":"ta_relationship_to_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagRelationships"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_relationship_to_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagRelationships"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_sensors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_name"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_type"}},{"kind":"Field","name":{"kind":"Name","value":"serial_number"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_value_type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"ta_sensor_measurements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurement_value"}},{"kind":"Field","name":{"kind":"Name","value":"data_timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_relationship_to_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagRelationships"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagRelationships"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_relationship_to_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_until"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"tag_type"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeviceFieldsFragmentFragment, unknown>;
export const UserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_role"}},{"kind":"Field","name":{"kind":"Name","value":"user_phone"}},{"kind":"Field","name":{"kind":"Name","value":"user_language"}},{"kind":"Field","name":{"kind":"Name","value":"user_timezone"}}]}}]} as unknown as DocumentNode<UserFragmentFragment, unknown>;
export const OrgUserGroupsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgUserGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_usergroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"group_name"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup_citizens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_citizen"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"citizen_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_citizen"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_name"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_associated_escalation_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"associated_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"associated_usergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_role"}},{"kind":"Field","name":{"kind":"Name","value":"user_phone"}},{"kind":"Field","name":{"kind":"Name","value":"user_language"}},{"kind":"Field","name":{"kind":"Name","value":"user_timezone"}}]}}]} as unknown as DocumentNode<OrgUserGroupsFragmentFragment, unknown>;
export const RuleFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RuleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_rule_notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"notification_text"}},{"kind":"Field","name":{"kind":"Name","value":"notification_has_been_sent"}},{"kind":"Field","name":{"kind":"Name","value":"last_triggered"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_rule_notification_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"rule_notification_id"}},{"kind":"Field","name":{"kind":"Name","value":"escalation_level"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_sensor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eui"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"default_name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sensor_name"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_associated_sensors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rule_notification_id"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"group_name"}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_rule_notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tag_type"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_associated"}}]}}]}}]} as unknown as DocumentNode<RuleFragmentFragment, unknown>;
export const S_Get_User_Groups_By_Org_For_ShiftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"S_GET_USER_GROUPS_BY_ORG_FOR_SHIFT"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"group_name"}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup_citizens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_citizen"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_citizen"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"citizen_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_citizen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_name"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizen_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_user_organisations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<S_Get_User_Groups_By_Org_For_ShiftSubscription, S_Get_User_Groups_By_Org_For_ShiftSubscriptionVariables>;
export const Update_Citizen_UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_CITIZEN_USER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"insertArr"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ta_citizen_user_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteArr"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ta_citizen_user_bool_exp"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_ta_citizen_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"insertArr"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"ta_citizen_user_citizen_id_user_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"archived"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_ta_citizen_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteArr"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<Update_Citizen_UserMutation, Update_Citizen_UserMutationVariables>;
export const Update_User_ModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_USER_MODAL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"full_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_timezone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_ta_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"full_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_language"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_timezone"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_language"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_timezone"}}]}}]}}]} as unknown as DocumentNode<Update_User_ModalMutation, Update_User_ModalMutationVariables>;
export const Styra_Get_Package_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"STYRA_GET_PACKAGE_DATA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"view_feature_subscription_package"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"affected_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"affected_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package_id"}},{"kind":"Field","name":{"kind":"Name","value":"package_name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"affected_at"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"view_feature_subscription_device"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eui"}},{"kind":"Field","name":{"kind":"Name","value":"in_use"}},{"kind":"Field","name":{"kind":"Name","value":"operation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"resident_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]} as unknown as DocumentNode<Styra_Get_Package_DataQuery, Styra_Get_Package_DataQueryVariables>;
export const Styra_Get_User_Insight_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"STYRA_GET_USER_INSIGHT_DATA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"view_feature_user_insight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"is_valid"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<Styra_Get_User_Insight_DataQuery, Styra_Get_User_Insight_DataQueryVariables>;
export const S_Delete_UsergroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"S_DELETE_USERGROUP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_ta_usergroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<S_Delete_UsergroupMutation, S_Delete_UsergroupMutationVariables>;
export const Insert_Relationship_To_TagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"INSERT_RELATIONSHIP_TO_TAG"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ta_relationship_to_tag_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constraint"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ta_relationship_to_tag_constraint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_ta_relationship_to_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constraint"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<Insert_Relationship_To_TagMutation, Insert_Relationship_To_TagMutationVariables>;
export const Insert_Tag_With_RelationshipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"INSERT_TAG_WITH_RELATIONSHIP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constraint"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ta_relationship_to_tag_constraint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ta_relationship_to_tag_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_ta_relationship_to_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constraint"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<Insert_Tag_With_RelationshipMutation, Insert_Tag_With_RelationshipMutationVariables>;
export const S_Save_Associated_Escalation_GroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"S_SAVE_ASSOCIATED_ESCALATION_GROUPS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldDelete"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldInsert"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ta_associated_escalation_group_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ta_associated_escalation_group_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_ta_associated_escalation_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldDelete"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_ta_associated_escalation_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldInsert"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_ta_associated_escalation_group_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdate"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<S_Save_Associated_Escalation_GroupsMutation, S_Save_Associated_Escalation_GroupsMutationVariables>;
export const Styra_Update_DeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"STYRA_UPDATE_DEVICE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"room"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes_updated_at"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"view_template"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"json"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_ta_device_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"room"},"value":{"kind":"Variable","name":{"kind":"Name","value":"room"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notes_updated_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes_updated_at"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"view_template"},"value":{"kind":"Variable","name":{"kind":"Name","value":"view_template"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_ta_sensor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"device_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sensor_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"lastupdate","block":false},{"kind":"StringValue","value":"offline","block":false},{"kind":"StringValue","value":"batterypercentage","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<Styra_Update_DeviceMutation, Styra_Update_DeviceMutationVariables>;
export const Update_UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_USER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"full_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_image_uri"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_timezone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_ta_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"full_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_language"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_image_uri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_image_uri"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_timezone"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_image_uri"}},{"kind":"Field","name":{"kind":"Name","value":"user_language"}},{"kind":"Field","name":{"kind":"Name","value":"user_phone"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_timezone"}}]}}]}}]} as unknown as DocumentNode<Update_UserMutation, Update_UserMutationVariables>;
export const Styra_Get_Devices_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"STYRA_GET_DEVICES_QUERY"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_device"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceFieldsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagRelationships"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_relationship_to_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_until"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"tag_type"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeviceFieldsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_device"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_id"}},{"kind":"Field","name":{"kind":"Name","value":"discovered"}},{"kind":"Field","name":{"kind":"Name","value":"eui"}},{"kind":"Field","name":{"kind":"Name","value":"gateway_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"model_identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"floor_id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"notes_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"online"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"room"}},{"kind":"Field","name":{"kind":"Name","value":"serial_number"}},{"kind":"Field","name":{"kind":"Name","value":"template_hash"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"view_template"}},{"kind":"Field","name":{"kind":"Name","value":"zone_id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizen_devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_name"}},{"kind":"Field","name":{"kind":"Name","value":"ta_relationship_to_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagRelationships"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_relationship_to_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagRelationships"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_sensors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_name"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_type"}},{"kind":"Field","name":{"kind":"Name","value":"serial_number"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_value_type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"ta_sensor_measurements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurement_value"}},{"kind":"Field","name":{"kind":"Name","value":"data_timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_relationship_to_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagRelationships"}}]}}]}}]}}]} as unknown as DocumentNode<Styra_Get_Devices_QueryQuery, Styra_Get_Devices_QueryQueryVariables>;
export const Styra_Graph_Notifications_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"STYRA_GRAPH_NOTIFICATIONS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ta_notification_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeLogs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_notification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_id"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_rule_notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_rule_notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tag_type"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_notification_users_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_notification_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"escalation_level"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"state_updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_notification_reminders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_notification_logs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeLogs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_device_token_id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_user_device_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"app_version"}},{"kind":"Field","name":{"kind":"Name","value":"device_type"}},{"kind":"Field","name":{"kind":"Name","value":"silenced_until"}},{"kind":"Field","name":{"kind":"Name","value":"ta_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Styra_Graph_Notifications_QueryQuery, Styra_Graph_Notifications_QueryQueryVariables>;
export const Styra_Get_Maintenance_BannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"STYRA_GET_MAINTENANCE_BANNER"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_maintenance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"show_in_web"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"group_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"display_start"}},{"kind":"Field","name":{"kind":"Name","value":"display_end"}},{"kind":"Field","name":{"kind":"Name","value":"maintenance_start"}},{"kind":"Field","name":{"kind":"Name","value":"maintenance_end"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_app"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_web"}}]}}]}}]} as unknown as DocumentNode<Styra_Get_Maintenance_BannerQuery, Styra_Get_Maintenance_BannerQueryVariables>;
export const Styra_Notification_Stats_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"STYRA_NOTIFICATION_STATS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"residentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_notification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"citizen_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"residentIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"processed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_id"}},{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"ta_notification_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"escalation_level"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"state_updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_notification_reminders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}}]} as unknown as DocumentNode<Styra_Notification_Stats_QueryQuery, Styra_Notification_Stats_QueryQueryVariables>;
export const Get_Organisation_By_PkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_ORGANISATION_BY_PK"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_organisation_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_user_organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"citizen_name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"500"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_name"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_address"}},{"kind":"Field","name":{"kind":"Name","value":"is_common_area"}},{"kind":"Field","name":{"kind":"Name","value":"ta_relationship_to_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagRelationshipsWithRules"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_devices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"500"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceFieldsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgUserGroupsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_rule_notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"notification_text"}},{"kind":"Field","name":{"kind":"Name","value":"last_triggered"}},{"kind":"Field","name":{"kind":"Name","value":"ta_sensor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_type"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_name"}},{"kind":"Field","name":{"kind":"Name","value":"ta_device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eui"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_rule_notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_associated"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tag_type"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"group_name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagRelationships"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_relationship_to_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_until"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"tag_type"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_role"}},{"kind":"Field","name":{"kind":"Name","value":"user_phone"}},{"kind":"Field","name":{"kind":"Name","value":"user_language"}},{"kind":"Field","name":{"kind":"Name","value":"user_timezone"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagRelationshipsWithRules"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_relationship_to_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_until"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"tag_type"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rules"},"name":{"kind":"Name","value":"ta_tag_rule_notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_rule_notification"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"rule_notification_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeviceFieldsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_device"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_id"}},{"kind":"Field","name":{"kind":"Name","value":"discovered"}},{"kind":"Field","name":{"kind":"Name","value":"eui"}},{"kind":"Field","name":{"kind":"Name","value":"gateway_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"model_identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"floor_id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"notes_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"online"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"room"}},{"kind":"Field","name":{"kind":"Name","value":"serial_number"}},{"kind":"Field","name":{"kind":"Name","value":"template_hash"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"view_template"}},{"kind":"Field","name":{"kind":"Name","value":"zone_id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizen_devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_name"}},{"kind":"Field","name":{"kind":"Name","value":"ta_relationship_to_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagRelationships"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_relationship_to_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagRelationships"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_sensors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_name"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_type"}},{"kind":"Field","name":{"kind":"Name","value":"serial_number"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_value_type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"ta_sensor_measurements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurement_value"}},{"kind":"Field","name":{"kind":"Name","value":"data_timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_relationship_to_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagRelationships"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgUserGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_usergroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"group_name"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup_citizens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_citizen"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"citizen_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_citizen"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_name"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_associated_escalation_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"associated_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"associated_usergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Organisation_By_PkQuery, Get_Organisation_By_PkQueryVariables>;
export const Styra_Get_Organisation_ListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"STYRA_GET_ORGANISATION_LIST"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"ta_supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tz"},"name":{"kind":"Name","value":"organisation_timezone"}}]}}]}}]} as unknown as DocumentNode<Styra_Get_Organisation_ListQuery, Styra_Get_Organisation_ListQueryVariables>;
export const Organisation_Report_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ORGANISATION_REPORT_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_organisation_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"citizen_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"citizen_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"use_case","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Organisation_Report_QueryQuery, Organisation_Report_QueryQueryVariables>;
export const QueryNotificationForHomeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryNotificationForHome"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_notification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_rule_notification"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"processed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"notification_text"}},{"kind":"Field","name":{"kind":"Name","value":"ta_notification_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<QueryNotificationForHomeQuery, QueryNotificationForHomeQueryVariables>;
export const GetNotificationPerScenarioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotificationPerScenario"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_organisation_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"use_case","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_rule_notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_rule_notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_notification_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNotificationPerScenarioQuery, GetNotificationPerScenarioQueryVariables>;
export const Get_Relation_To_Tag_By_PkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_RELATION_TO_TAG_BY_PK"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_relationship_to_tag_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_until"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"ta_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"snooze_allowed"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Relation_To_Tag_By_PkQuery, Get_Relation_To_Tag_By_PkQueryVariables>;
export const GetNotificationCountPerScenarioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotificationCountPerScenario"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_organisation_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"use_case","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ta_tag_rule_notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_rule_notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"ta_notification_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNotificationCountPerScenarioQuery, GetNotificationCountPerScenarioQueryVariables>;
export const Get_Sensor_HistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_SENSOR_HISTORY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_sensor_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensor_type"}},{"kind":"Field","name":{"kind":"Name","value":"ta_notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_rule_notification"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"processed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"processed_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"follow_up_at"}},{"kind":"Field","name":{"kind":"Name","value":"ta_notification_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_rule_notification_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_sensor_measurements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Sensor_HistoryQuery, Get_Sensor_HistoryQueryVariables>;
export const S_Get_User_Groups_By_OrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"S_GET_USER_GROUPS_BY_ORG"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgUserGroupsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_role"}},{"kind":"Field","name":{"kind":"Name","value":"user_phone"}},{"kind":"Field","name":{"kind":"Name","value":"user_language"}},{"kind":"Field","name":{"kind":"Name","value":"user_timezone"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgUserGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ta_usergroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"group_name"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup_citizens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_citizen"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"citizen_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_citizen"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_citizen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_name"}},{"kind":"Field","name":{"kind":"Name","value":"citizen_address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_associated_escalation_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"associated_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"associated_usergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ta_usergroup_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ta_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ta_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}}]} as unknown as DocumentNode<S_Get_User_Groups_By_OrgQuery, S_Get_User_Groups_By_OrgQueryVariables>;
export const Styra_Get_User_PermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"STYRA_GET_USER_PERMISSIONS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"view_user_permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"organisation_id"},{"kind":"EnumValue","value":"type"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<Styra_Get_User_PermissionsQuery, Styra_Get_User_PermissionsQueryVariables>;